webpackJsonp([5],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+DAr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6664817b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("NkIV");
function injectStyle (ssrContext) {
  __webpack_require__("FQR9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6664817b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+OPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:'icon-menu icon-menu-' + _vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name))+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path && _vm.link.name)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":'/#' + _vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.nameshort ? _vm.link.nameshort : _vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name)))])]:[_c('i',{class:'icon-menu icon-menu-' + _vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name)))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ZBl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+wRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsCustomerDetails_vue__ = __webpack_require__("e0Nk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab69bd3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsCustomerDetails_vue__ = __webpack_require__("BxdH");
function injectStyle (ssrContext) {
  __webpack_require__("zouy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ab69bd3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsCustomerDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab69bd3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsCustomerDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/bpg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/goY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);











var _components;








__WEBPACK_IMPORTED_MODULE_10_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    defaultData: {},
    modeldata: {},
    taxesData: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    },
    taxesData: function taxesData(value) {
      this.taxes = value;
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      taxes: this.value || this.taxesData
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'tips_taxes': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.tips_taxes)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', response.data[0]);
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    handleActive: function handleActive(e) {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'tips_in_use': this.model.tips_in_use ? 1 : 0
      };
      var actionText = this.model.tips_in_use ? 'enabled' : 'disabled';
      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.handleErrors(response.errors);
          self.model.tips_in_use = !self.model.tips_in_use;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validationa.wentWrong'), 'error');
        }
      });
    }
  }
});

/***/ }),

/***/ "/mvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__ = __webpack_require__("vCTZ");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CategoryForm', __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "/yjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);










var _components;






__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a), _components),
  props: {
    defaultData: {},
    modeldata: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
      this.setUpBits(value);
    }
  },
  data: function data() {
    return {
      labels: {
        'order_new': this.$t('settingsPushNotif.order_new'),
        'order_completed_pickup': this.$t('settingsPushNotif.order_completed_pickup'),
        'order_completed_meet': this.$t('settingsPushNotif.order_completed_meet'),
        'order_completed_delivery': this.$t('settingsPushNotif.order_completed_delivery'),
        'order_completed_eat': this.$t('settingsPushNotif.order_completed_eat'),
        'order_canceled': this.$t('settingsPushNotif.order_canceled')
      },
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      modelValidations: {
        text: { required: true }
      },
      parameters: ['{time}', '{date_time}', '{persons_number}'],
      notifBits: {
        'DELIVERY': {
          'PROCESSING': ['', '']
        },
        'PICK_UP': {
          'PROCESSING': ['', '']
        },
        'MEET_HALF': {
          'PROCESSING': ['', '']
        },
        'EAT_LOCATION': {
          'DELIVERED': ['', '', '']
        }
      }
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
          console.warn(this.errors);
        }
      }
    },
    setUpBits: function setUpBits(model) {
      for (var idx in model) {
        var notif = model[idx];
        for (var notifIdx in notif.messages) {
          var message = notif.messages[notifIdx];
          if (message.status === 'PROCESSING' || message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION') {
            var bits = this.getBits(message.message, notif.delivery_type);
            this.notifBits[notif.delivery_type][message.status] = bits;
          }
        }
      }
    },
    getBits: function getBits(message, type) {
      switch (type) {
        case 'EAT_LOCATION':
          var bits = message.split('{persons_number}');
          if (bits.length < 2) {
            bits.push(' ');
            bits.push(' ');
            return bits;
          } else {
            var bits2 = bits[1].split('{date_time}');
            if (bits2.length < 2) {
              bits2.push(' ');
            }
            bits[1] = bits2[0];
            bits[2] = bits2[1];
          }
          return bits;
        default:
          var bitsDef = message.split('{time}');
          if (bitsDef.length < 2) {
            bitsDef.push(' ');
          }
          return bitsDef;
      }
    },
    getMsgFromBits: function getMsgFromBits(type, status) {
      var bits = this.notifBits[type][status];
      switch (type) {
        case 'EAT_LOCATION':
          return bits[0] + '{persons_number}' + bits[1] + '{date_time}' + bits[2];
        default:
          return bits[0] + '{time}' + bits[1];
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');

      for (var idx in this.model) {
        var notif = this.model[idx];
        for (var notifIdx in notif.messages) {
          var message = notif.messages[notifIdx];
          if (message.status === 'PROCESSING' || message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION') {
            this.model[idx].messages[notifIdx].message = this.getMsgFromBits(notif.delivery_type, message.status);
          }
        }
      }

      var data = {
        'token': this.$session.get('token'),
        'push_notifications': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch({});
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('validationa.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
        }
      });
    }
  }
});

/***/ }),

/***/ "021c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "04eR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0rqh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/EK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "19rj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");

















__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    ChartPieCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */],
    ChartBarsCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]
  },
  created: function created() {
    console.warn(this.tableData);
    this.locations = this.$session.get('selectedCompanyData').locations_details;
    if (this.locations.length > 1) {
      this.showLocations = true;
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.selectedLocation = filterCookie[0];
      }
    }
    this.getData(this.selectedLocation);
  },
  data: function data() {
    return {
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      locations: [],
      showLocations: false,
      selectedLocation: '',
      cardsClass: 'col-lg-3 col-sm-12',
      statsCards: {
        'new_orders': {
          type: 'warning',
          icon: 'dash1.png',
          title: this.$t('dashboard.tile1Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'total_orders': {
          type: 'success',
          icon: 'dash2.png',
          title: this.$t('dashboard.tile2Title'),
          value: '',
          canceled: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'revenue': {
          type: 'danger',
          icon: 'dash3.png',
          title: this.$t('dashboard.tile3Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'installed_apps': {
          type: 'info',
          icon: 'dash4.png',
          title: this.$t('dashboard.tile4Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        }
      },
      ordersChart: {
        data: {
          labels: [],
          series: [],
          canceled: [],
          delivered: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '200px'
        }
      },
      salesChart: {
        data: {
          labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        title: 'Today',
        data: {
          labels: ['Cappucinno', 'Ristretto', 'Expresso', 'Ice coffe', 'Cookie'],
          series: [[411, 345, 201, 189, 157]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          }
        }
      },
      deliveryChart: {
        title: 'Today',
        data: {
          labels: ['Pick-up', 'Meet me half-way', 'On Location', 'Delivery'],
          series: [[411, 345, 201, 189]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          }
        }
      }
    };
  },

  methods: {
    filterLocations: function filterLocations() {
      this.getData(this.selectedLocation);
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.selectedLocation]), 1);
    },
    getData: function getData(location) {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (location && location !== '') {
        data.location = location;
        this.cardsClass = 'col-lg-4 col-sm-12';
      } else {
        this.cardsClass = 'col-lg-3 col-sm-12';
      }
      this.apiRequest('/reports/dashboard', 'GET', data, function (response) {
        if (response.status === true) {
          console.warn(response.data);
          self.ordersChart.data.labels = response.data.orders.labels;
          self.ordersChart.data.series = [response.data.orders.delivered];
          self.$refs.refOrdersChart.initChart();

          self.salesChart.data.labels = response.data.sales.labels;
          self.salesChart.data.series = [response.data.sales.values];
          self.$refs.salesChart.initChart();

          self.topProdsChart.data.labels = response.data.top_products.labels;
          self.topProdsChart.data.series = [response.data.top_products.values];
          self.$refs.topProdsChart.initChart();

          self.deliveryChart.data.labels = response.data.delivery_types.labels;
          self.deliveryChart.data.series = [response.data.delivery_types.values];
          self.$refs.deliveryChart.initChart();

          self.statsCards.new_orders.value = response.data.counters.new_orders;
          self.statsCards.total_orders.value = response.data.counters.total_orders;
          self.statsCards.total_orders.canceled = response.data.counters.total_canceled;
          self.statsCards.revenue.value = response.data.counters.revenue;
          self.statsCards.installed_apps.value = response.data.counters.installed_apps;
        }
      });
    }
  }
});

/***/ }),

/***/ "1hFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__ = __webpack_require__("YeLk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db2709_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__ = __webpack_require__("HuIP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db2709_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1rzg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1s1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__("EdqV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb73bdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__("GgTn");
function injectStyle (ssrContext) {
  __webpack_require__("Klnn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb73bdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21i8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBarsCard_vue__ = __webpack_require__("hvya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc0f99e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBarsCard_vue__ = __webpack_require__("NyKN");
function injectStyle (ssrContext) {
  __webpack_require__("Sw0U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBarsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc0f99e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBarsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Igw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNotifications_vue__ = __webpack_require__("/yjk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e532af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNotifications_vue__ = __webpack_require__("DZct");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNotifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e532af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNotifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2OT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__OrderView_vue__ = __webpack_require__("q0FD");
































__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_24_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_27_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_26_src_components_UIComponents_Switch_vue__["a" /* default */],
    OrderForm: __WEBPACK_IMPORTED_MODULE_28__OrderView_vue__["a" /* default */]
  },
  computed: {},
  created: function created() {
    this.getData(false, false);

    var userData = JSON.parse(this.$session.get('userData'));

    this.locations = this.$session.get('selectedCompanyData').locations_details;
    if (this.locations.length > 1) {
      this.showLocations = true;
    }
    var filterCookie = this.$cookie.get('filter-locations');
    if (filterCookie) {
      filterCookie = JSON.parse(filterCookie);
      this.locationFilter = filterCookie;
    }
  },
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 99999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      searchQuery: '',
      timeout: null,
      propsToSearch: ['status', 'price'],
      tableColumns: [{
        prop: 'number',
        label: 'Number',
        minWidth: 100
      }, {
        prop: 'type',
        label: 'Type',
        minWidth: 100
      }],
      orders: [],
      ordersReversed: [],
      useReversed: false,
      tableData: [],
      windowHeight: 0,
      tableTopHeight: 70,
      tableBottomHeight: 62,
      pageTopHeight: 0,
      initialStatuses: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'],
      requestLimit: 30,
      requestPage: 1,
      customFilter: false,
      showLoadMore: false,
      requestFilters: [{
        value: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] }, {
        value: [] }, {
        value: '' }],
      locationFilter: [],
      resetFiltersObj: [{ value: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] }, { value: [] }, { value: '' }],
      filters: [],
      statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
      locations: [],
      showLocations: false,
      heartbeatSet: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      console.warn('mounted');
      _this.windowHeight = window.innerHeight;
      _this.tableTopHeight = _this.$refs.tableTop && _this.$refs.tableTop.clientHeight ? _this.$refs.tableTop.clientHeight : 0;

      if (window.innerWidth < 1200) {
        _this.pageTopHeight = 0;
      } else {
        _this.pageTopHeight = 0;
      }

      window.addEventListener('resize', function () {
        _this.windowHeight = window.innerHeight;
        _this.tableTopHeight = _this.$refs.tableTop && _this.$refs.tableTop.clientHeight ? _this.$refs.tableTop.clientHeight : 0;

        if (window.innerWidth < 1200) {
          _this.pageTopHeight = 0;
        } else {
          _this.pageTopHeight = 0;
        }
      });

      if (!_this.heartbeatSet) {
        _this.heartbeat();
        _this.heartbeatSet = true;
      }
    });
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/orders/view/');
      this.$refs.orderForm.getData();
    },

    heartbeat: function heartbeat() {
      var _this2 = this;

      var self = this;
      setInterval(function () {
        console.warn(self.customFilter);
        if (!self.customFilter) {
          self.getData(true, false);
        }
      }, 60000);
      setInterval(function () {
        if (self.$session.get('temp-status')) {
          self.requestFilters[0].value = [_this2.$session.get('temp-status')];
          self.$session.remove('temp-status');
          self.getData(true, false);
        }
      }, 1000);
    },
    getData: function getData(isHeartBeat, isLoadMore) {
      if (!isHeartBeat) {
        this.$nextTick(function () {
          this.loading = true;
        });
      }
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1,
        limit: this.requestLimit,
        page: this.requestPage,
        sort_order: self.useReversed ? 'desc' : 'asc'
      };
      if (this.requestFilters[0].value.length) {
        data.statuses = this.requestFilters[0].value.join(',');
      }
      if (this.locationFilter.length) {
        data.location_ids = this.locationFilter.join(',');
      }
      if (this.requestFilters[2].value !== '') {
        data.search = this.requestFilters[2].value;
      }
      var currentOrderId = null;
      if (this.showForm()) {
        currentOrderId = parseInt(this.$route.params.id);
      }
      this.apiRequest('/order', 'GET', data, function (response) {
        if (response.status === true) {
          var goodOrders = [];
          for (var idx in response.data) {
            if (response.data[idx]['status'].id === 'DRAFT') {} else {
              response.data[idx]['status_type'] = response.data[idx]['status'].id;
              response.data[idx]['production_location'] = response.data[idx].production_details !== null ? response.data[idx].production_details.location.id : '';

              goodOrders.push(response.data[idx]);

              if (isHeartBeat && currentOrderId === response.data[idx].id) {
                if (self.$refs.orderForm) {
                  self.$refs.orderForm.heartbeat(response.data[idx]);
                }
              }
            }
            if (response.data[idx]['customer']) {
              if (response.data[idx]['customer']['firstname'] === null) {
                if (response.data[idx]['delivery_details_firstname']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_firstname'] + '</b>';
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>';
                } else if (response.data[idx]['delivery_details_phone']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_phone'] + '</b>';
                } else if (response.data[idx]['customer']['phone']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['phone'] + '</b>';
                }
                if (response.data[idx]['customer']['email']) {
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>';
                }
                response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">Number of Orders: ' + response.data[idx]['counter_orders_per_customer'] + '</span>';
              } else if (response.data[idx]['customer']['firstname'] !== null && response.data[idx]['customer']['lastname'] !== null || response.data[idx]['customer']['firstname'] !== null) {
                if (response.data[idx]['delivery_details_firstname']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_firstname'] + '</b>';
                } else {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['firstname'] + ' ' + response.data[idx]['customer']['lastname'] + '</b>';
                }
                if (response.data[idx]['delivery_details_phone']) {
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>';
                } else if (response.data[idx]['customer']['phone']) {
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['phone'] + '</small>';
                }
                if (response.data[idx]['customer']['email']) {
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>';
                }
                response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">Number of Orders: ' + response.data[idx]['counter_orders_per_customer'] + '</span>';
              } else {
                response.data[idx]['customer_display'] = 'CCC';
              }
            } else {
              response.data[idx]['customer_display'] = '';
            }
          }

          if (goodOrders.length < self.requestLimit) {
            self.showLoadMore = false;
          } else {
            self.showLoadMore = true;
          }

          if (isLoadMore) {
            self.orders = self.orders.concat(goodOrders);
          } else {
            self.orders = goodOrders;
          }

          self.tableData = self.orders;

          self.paginationDef.pageSize = self.tableData.length + 1;

          self.scrollToCurrent();

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    },
    scrollToCurrent: function scrollToCurrent() {
      this.$nextTick(function () {
        var el = this.$el.getElementsByClassName('current')[0];
        if (el) {
          var container = this.$refs.tableContainerRef;
          var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody');
          var position = 1;

          for (var i = 0; i < table.children.length; i++) {
            if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
              if (i > 1) {
                position = i;
              }
            }
          }
          container.scrollTo({
            left: 0,
            top: el.clientHeight * position,
            behavior: 'smooth'
          });
        }
      });
    },
    rowClass: function rowClass(row, index) {
      if (this.$route.params.id && parseInt(row.row.id) === parseInt(this.$route.params.id)) {
        return 'current row-' + this.orderStatusClass(row.row.status.id);
      } else {
        return 'row-' + this.orderStatusClass(row.row.status.id);
      }
    },
    showForm: function showForm() {
      if (this.$route.path.indexOf('view') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    removeFilter: function removeFilter(filterKey, key) {
      if (filterKey === 0) {
        __WEBPACK_IMPORTED_MODULE_24_vue___default.a.delete(this.requestFilters[filterKey].value, key);
      } else {
        __WEBPACK_IMPORTED_MODULE_24_vue___default.a.delete(this.filters[filterKey].value, key);
      }
      this.tableTopHeight = this.$refs.tableTop.clientHeight;
      this.updateCookie();
    },
    resetFilters: function resetFilters() {
      this.customFilter = false;
      this.requestPage = 1;
      var filter = this.resetFiltersObj;
      this.requestFilters = filter;
    },
    loadMore: function loadMore() {
      this.customFilter = true;
      this.requestPage = this.requestPage + 1;
      this.getData(false, true);
    },
    updateCookie: function updateCookie() {
      console.warn(this.locationFilter);
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locationFilter), 1);
      this.requestPage = 1;
      this.getData(false, false);
    },
    updateList: function updateList(id, status) {
      var idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData);

      if (idx) {
        this.tableData[idx]['status'] = status;
        this.tableData[idx]['status_type'] = status['type'];
      }
    },
    search: function search() {
      clearTimeout(this.timeout);

      var self = this;
      this.timeout = setTimeout(function () {
        console.log('searching:', self.searchQuery);
        self.requestFilters[2].value = self.searchQuery;
      }, 500);
    }
  },
  watch: {
    requestFilters: {
      handler: function handler(newval, oldval) {
        var self = this;
        var onlyDefaults = newval[0]['value'].filter(function (elm) {
          return self.resetFiltersObj[0]['value'].indexOf(elm) === -1;
        });

        var rev = false;
        if (newval[2]['value'] === '' && (newval[0]['value'].length === 6 && onlyDefaults || newval[0]['value'].length === 1 && newval[0]['value'][0] === 'NEW' || newval[0]['value'].length === 1 && newval[0]['value'][0] === 'PROCESSING')) {
          this.customFilter = false;
          rev = false;
        } else {
          this.customFilter = true;
          rev = true;
        }
        this.useReversed = rev;

        this.requestPage = 1;
        this.getData(false, false);

        this.paginationDef.pageSize = this.tableData.length + 1;
      },
      deep: true
    }
  }
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f907236e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("sWJb");
function injectStyle (ssrContext) {
  __webpack_require__("mhKA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f907236e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2mRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_tree_halower_dist_halower_tree_min_css__ = __webpack_require__("ug9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_tree_halower_dist_halower_tree_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_tree_halower_dist_halower_tree_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_tree_halower__ = __webpack_require__("lTSm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_tree_halower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_tree_halower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");















var _components;











__WEBPACK_IMPORTED_MODULE_14_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vue_tree_halower___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    mainCategoriesParent: {
      type: Array,
      required: true
    },
    productsParent: {
      type: Array,
      required: true
    },
    productsGroupedParent: {
      required: true
    },
    productOptionsParent: {
      required: true
    },
    taxesParent: {
      type: Array,
      required: true
    },
    callback: {
      required: true
    },
    callbackDelete: {
      required: true
    }
  },
  watch: {
    mainCategoriesParent: function mainCategoriesParent(value, oldVal) {
      this.mainCategories = value;
    },
    productsParent: function productsParent(value, oldVal) {
      this.products = value;
    },
    productsGroupedParent: function productsGroupedParent(value, oldVal) {
      this.productsGrouped = value;
      this.getTrees();
    },
    productOptionsParent: function productOptionsParent(value, oldVal) {
      this.productOptions = value;
    },
    taxesParent: function taxesParent(value, oldVal) {
      this.taxes = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])),
  data: function data() {
    return {
      type: '',
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      tabIndex: null,
      currentTab: '',
      pickerNames: ['date_from', 'date_to'],
      mainCategories: this.value || this.mainCategoriesParent,
      model: [],
      soldWithProducts: [],
      products: this.value || this.productsParent,
      productsGrouped: this.value || this.productsGroupedParent,
      productOptions: this.value || this.productOptionsParent,
      taxes: this.value || this.taxesParent,
      hasImages: false,
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        sku: {
          required: true
        },
        price: {
          required: true,
          min_value: 0,
          max_value: 999999.99
        },
        category_id: {
          required: true
        }
      },
      optionTypes: ['checkbox', 'radio'],
      searchword: '',
      searchwordExtra: '',
      treeData: [],
      treeDataExtra: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      loading: true
    };
  },

  created: function created() {
    this.getData();
  },
  mounted: function mounted() {
    this.mapItems();
  },

  methods: {
    isNew: function isNew() {
      if (this.$route.params.id && this.$route.params.id !== 'add') {
        this.type = this.$t('general.edit');
        return false;
      } else {
        this.type = this.$t('general.add');
        return true;
      }
    },
    getData: function getData() {
      this.$nextTick(function () {
        this.loading = true;
      });
      this.errors['items'] = this.removeErrorByName('error', this.errors['items']);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var self = this;

      var objProps = ['taxes', 'sold_with_products', 'sold_with_categories', 'extra_products', 'extra_categories', 'product_options'];

      if (self.$route.params.id && self.$route.params.id !== 'add') {
        var prodId = self.$route.params.id;

        self.apiRequest('/product/' + prodId, 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data[0].image_url) {
              response.data[0].imagelist = response.data[0].image_url;
              self.hasImages = response.data[0].images.length > 0;
            } else {
              response.data[0].imagelist = [];
            }
            for (var prop in objProps) {
              if (response.data[0][objProps[prop]] === undefined || response.data[0][objProps[prop]] === null) {
                response.data[0][objProps[prop]] = [];
              }
            }
            if (response.data[0].category.id !== undefined) {
              response.data[0].category_id = response.data[0].category.id;
            }
            self.model = response.data[0];
            self.getTrees();

            self.$nextTick(function () {
              self.loading = false;
            });
          }
        });
      } else {
        this.model = [];
        var object = {
          'taxes': [],
          'sold_with_products': [],
          'sold_with_categories': [],
          'extra_products': [],
          'extra_categories': [],
          'product_options': [],
          'active': 1,
          'type': 'single'
        };
        this.model = object;

        self.$nextTick(function () {
          self.loading = false;
        });
      }
      this.currency = this.getCurrencySymbol(this.currency);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.errors['items'] = this.removeErrorByName('error', this.errors['items']);
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveProduct();
        } else {
          console.info('is not valid', _this.errors);
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var self = this;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    mapItems: function mapItems() {
      for (var i in this.products) {
        var idx = this.getObjectByElemKeyValue('id', parseInt(this.products[i].id), this.model.sold_with_products);
        if (idx) {
          this.soldWithProducts.push(this.products[i]);
        }
      }
    },
    getTrees: function getTrees() {
      var soldWith = [];
      this.treeData = [];

      var currentProdID = null;
      if (!this.isNew()) {
        currentProdID = parseInt(this.$route.params.id);
      }

      for (var id in this.productsGrouped) {
        var idSoldCateg = this.getObjectByElemKeyValue('id', parseInt(id), this.model.sold_with_categories);
        if (idSoldCateg) {
          var data = { 'id': id, 'title': this.productsGrouped[id].details.name, 'checked': true };
          var children = [];
          for (var idx in this.productsGrouped[id].items) {
            if (currentProdID !== this.productsGrouped[id].items[idx].id) {
              children.push({ 'id': this.productsGrouped[id].items[idx].id, 'title': this.productsGrouped[id].items[idx].name, 'checked': true });
            }
          }
          data['children'] = children;
          soldWith.push(data);
        } else {
          var _children = [];
          var halfcheck = false;
          for (var _idx in this.productsGrouped[id].items) {
            var chk = false;
            var idSoldProd = this.getObjectByElemKeyValue('id', parseInt(this.productsGrouped[id].items[_idx].id), this.model.sold_with_products);
            if (idSoldProd) {
              chk = true;
              halfcheck = true;
            }
            if (currentProdID !== this.productsGrouped[id].items[_idx].id) {
              _children.push({
                'id': this.productsGrouped[id].items[_idx].id,
                'title': this.productsGrouped[id].items[_idx].name,
                'checked': chk
              });
            }
          }
          soldWith.push({ 'id': id, 'title': this.productsGrouped[id].details.name, 'children': _children, 'halfcheck': halfcheck });
        }
      }
      this.treeData = soldWith;
    },
    addNewOption: function addNewOption() {
      var newRow = {
        'id': null,
        'min_no': 0,
        'required': true,
        'values': []
      };

      this.model.product_options.push(newRow);

      this.tabIndex = this.model.product_options.length - 1;
    },
    addNewOptionValue: function addNewOptionValue(optIdx) {
      var newRow = {
        'id': null,
        'price': 0
      };
      this.model.product_options[optIdx].values.push(newRow);
    },
    showAddButton: function showAddButton(optIdx, option) {
      if (option === undefined) {
        return false;
      }
      if (option['id'] === undefined) {
        return false;
      }
      var existingOptions = option['values'].length;
      var allOptions = this.productOptions[this.getObjectByElemKeyValue('id', option['id'], this.productOptions)];
      if (allOptions === undefined) {
        return false;
      }
      allOptions = allOptions['values'].length;
      return existingOptions < allOptions;
    },
    disableOption: function disableOption(optIdx, optId, main) {
      var thisOptIdx = false;
      if (main) {
        if (this.model.product_options !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('id', optId, this.model.product_options);
        }
      } else {
        if (this.model.product_options[optIdx] !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('id', optId, this.model.product_options[optIdx]['values']);
        }
      }

      if (thisOptIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    deleteOption: function deleteOption(thisOptIdx) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: self.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          self.model.product_options.splice(thisOptIdx, 1);
        }
      });
    },
    deleteOptionValue: function deleteOptionValue(thisOptIdx, thisValIdx) {
      this.model.product_options[thisOptIdx].values.splice(thisValIdx, 1);
    },
    updateName: function updateName(thisOptIdx, optId, optName) {
      var prOptIdx = this.getObjectByElemKeyValue('id', optId, this.productOptions);
      if (this.productOptions[prOptIdx]['name'] === optName) {
        this.model.product_options[thisOptIdx]['modified'] = false;
      } else {
        this.model.product_options[thisOptIdx]['modified'] = true;
      }
    },
    getOptData: function getOptData(option, what) {
      if (option.id) {
        var prOptIdx = this.getObjectByElemKeyValue('id', option.id, this.productOptions);
        if (prOptIdx) {
          return this.productOptions[prOptIdx][what];
        }
      }
      switch (what) {
        case 'name':
          return this.$t('catalogProdOpt.new');
        default:
          return null;
      }
    },
    changeOption: function changeOption(thisOptIdx, optId, option) {
      var prOptIdx = this.getObjectByElemKeyValue('id', this.model.product_options[thisOptIdx].id, this.productOptions);
      this.model.product_options[thisOptIdx]['values'] = [];

      this.model.product_options[thisOptIdx]['required'] = true;

      this.tabIndex = thisOptIdx;
    },
    search: function search() {
      this.$refs.tree.searchNodes(this.searchword);
    },
    searchExtra: function searchExtra() {
      this.$refs.treeExtra.searchNodes(this.searchwordExtra);
    },
    handleDelete: function handleDelete(label) {
      var _this2 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + ' ' + label + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this2.isNew()) {
            self.$router.push('/products');
          } else {
            var id = _this2.$route.params.id;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/product/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', self.$t('catalogProd.prodDeleted'), 'success');
                self.callbackDelete();
                self.$router.push('/products');
              } else {
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    saveProduct: function saveProduct() {
      this.$nextTick(function () {
        this.loading = true;
      });

      if (this.model.product_options.length) {
        for (var optIdx in this.model.product_options) {
          if (this.model.product_options[optIdx]['values'].length) {
            for (var optValIdx in this.model.product_options[optIdx]['values']) {
              var valPrc = this.model.product_options[optIdx]['values'][optValIdx]['price'];
              if (valPrc === null || valPrc === '') {
                this.model.product_options[optIdx]['values'][optValIdx]['price'] = 0;
              }
            }
          }
        }
      }

      var data = this.copyObject(this.model);

      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');

      data.date_validfrom = null;
      data.date_validto = null;


      var self = this;
      if (data.type === 'single') {
        delete data.child_products;
      } else {
        data.child_products = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.child_products);
      }

      delete data.other_images;

      if (data.product_options) {
        for (var _optIdx in data.product_options) {
          delete data.product_options[_optIdx].type;
          delete data.product_options[_optIdx].name;
          delete data.product_options[_optIdx].modified;
          delete data.product_options[_optIdx].show_in_total_price;
          if (data.product_options[_optIdx]['values']) {
            for (var _optValIdx in data.product_options[_optIdx]['values']) {
              delete data.product_options[_optIdx]['values'][_optValIdx].price_details;
              delete data.product_options[_optIdx]['values'][_optValIdx].label;
            }
          }
        }
      }

      data.product_options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.product_options);

      var objProps = ['taxes'];
      for (var prop in objProps) {
        if (data[objProps[prop]] === undefined || data[objProps[prop]] === null) {} else {
          if (data[objProps[prop]] === []) {
            data[objProps[prop]] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data[objProps[prop]]);
          } else {
            var vals = [];
            var objs = data[objProps[prop]];
            for (var ii in objs) {
              vals.push(objs[ii].id);
            }
            data[objProps[prop]] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vals);
          }
        }
      }

      var categs = [];
      var prods = [];
      for (var idx in this.treeData) {
        if (this.treeData[idx]['checked'] !== undefined && this.treeData[idx]['checked'] === true && (this.treeData[idx]['halfcheck'] === false || this.treeData[idx]['halfcheck'] === undefined)) {
          categs.push(this.treeData[idx]['id']);
        } else {
          for (var idxChild in this.treeData[idx]['children']) {
            if (this.treeData[idx]['children'][idxChild] && this.treeData[idx]['children'][idxChild]['checked'] === true) {
              prods.push(this.treeData[idx]['children'][idxChild]['id']);
            }
          }
        }
      }
      data['sold_with_products'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(prods);
      data['sold_with_categories'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(categs);

      var makeNull = ['monetary_conversion', 'description', 'sku', 'pos_id'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(makeNull), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (typeof data[field] !== 'undefined' && (data[field] === '' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data[field]) === 'object')) {
            data[field] = null;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.isNew()) {
        delete data.image;
        this.apiRequest('/product', 'POST', data, function (response) {
          if (response.status === true) {
            var id = response.data[0].id;
            if (data.imagelist && data.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                self.apiRequest('/product/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogProd.prodAdded'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                    self.callbackDelete();
                    self.$router.push('/products/edit/' + id);
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogProd.prodPhotoError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                title: '',
                text: self.$t('catalogProd.prodAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
              self.callbackDelete();
              self.$router.push('/products/edit/' + id);
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      } else {
        var id = this.$route.params.id;
        delete data.parent_category;
        delete data.images;
        delete data.image_url;
        delete data.created_at;
        delete data.created_by;
        delete data.updated_at;
        delete data.updated_by;
        delete data.deleted_at;
        delete data.deleted_by;
        delete data.company;
        delete data.parent_product;
        delete data.top_category;
        delete data.category;
        delete data.price_details;
        delete data.extra_categories;
        delete data.extra_products;

        if (!data.imagelist[0]) {
          data.images = '';
        }
        var nowHasImages = !!data.imagelist[0];
        data.image_was_removed = self.hasImages && !nowHasImages;
        delete data.imagelist;
        this.apiRequest('/product/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (self.model.imagelist[0] && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                self.apiRequest('/product/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.callback(id, { 'name': self.model.name, 'price': self.model.price, 'active': self.model.active });
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogProd.prodUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogProd.prodPhotoError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            } else {
              self.callback(id, { 'name': self.model.name, 'price': self.model.price, 'active': self.model.active });
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                title: '',
                text: self.$t('catalogProd.prodUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3FB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogCateg.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('name'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.displayType')))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.displayTypes),function(opt,key){return _c('p-radio',{key:key,attrs:{"label":key,"inline":true,"disabled":key === 'grid'},model:{value:(_vm.model.display_type),callback:function ($$v) {_vm.$set(_vm.model, "display_type", $$v)},expression:"model.display_type"}},[_vm._v(_vm._s(opt))])}),_vm._v(" "),(_vm.errors.has('display_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('display_type'))+"\n            ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.shortDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":_vm.$t('catalogCateg.shortDescription')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('description'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.validFromTo')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_validfrom'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('date_validfrom'))+"\n            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer "},[_c('button',{staticClass:"btn btn-fill btn-success",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-fill ",attrs:{"title":"Delete"},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_vm._v(" "+_vm._s(_vm.$t('general.delete'))+" "+_vm._s(_vm.$t('catalogCateg.single')))]):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-fill",on:{"click":function($event){$event.preventDefault();_vm.handleDelete('cancel')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3HHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('error'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.timezone')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-12",attrs:{"placeholder":" - Select Timezone - ","filterable":""},model:{value:(_vm.model.timezone),callback:function ($$v) {_vm.$set(_vm.model, "timezone", $$v)},expression:"model.timezone"}},_vm._l((_vm.defaults.timezones),function(tz){return _c('el-option',{key:tz.select_value,attrs:{"value":tz.select_value,"label":tz.display_name}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.timeFormat')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-12",attrs:{"placeholder":" - Select Time Format - "},model:{value:(_vm.model.time_format),callback:function ($$v) {_vm.$set(_vm.model, "time_format", $$v)},expression:"model.time_format"}},_vm._l((_vm.defaults.time_formats.client),function(label,key){return _c('el-option',{key:key,attrs:{"value":key,"label":label}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.dateFormat')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-12 col-md-12",attrs:{"placeholder":" - Select Date Format - "},model:{value:(_vm.model.date_format),callback:function ($$v) {_vm.$set(_vm.model, "date_format", $$v)},expression:"model.date_format"}},_vm._l((_vm.defaults.date_formats.client),function(label,key){return _c('el-option',{key:key,attrs:{"value":key,"label":label}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();_vm.validate()}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3wER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center "},[_c('p-checkbox',{key:"COUPON",staticClass:"text-purple",attrs:{"label":"Add Coupon"},on:{"input":function($event){_vm.changeType()}},model:{value:(_vm.addcoupon),callback:function ($$v) {_vm.addcoupon=$$v},expression:"addcoupon"}},[_c('h4',{ref:"COUPON",staticClass:"coupon-selection",class:_vm.activeButton == 'COUPON' ? 'purple' : 'gray',attrs:{"name":"coupon_option"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.addCoupon')))])])],1),_vm._v(" "),_c('div',{attrs:{"disabled":_vm.model.type != 'COUPON'}},[_c('div',{staticClass:"col-md-12 pad-bt-15 text-center"},[_c('label',{staticClass:"pad-rg-5 valign-top"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.applyTo'))+":")]),_vm._v(" "),_vm._l((_vm.couponUsageTypes),function(type,key){return _c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.usage_type),expression:"modelValidations.usage_type"}],key:key,attrs:{"label":key,"inline":true,"disabled":_vm.model.type != 'COUPON'},model:{value:(_vm.coupons.usage_type),callback:function ($$v) {_vm.$set(_vm.coupons, "usage_type", $$v)},expression:"coupons.usage_type"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.'+type)))])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6 ",class:_vm.coupons.usage_type == 'PRODUCTS' ? '' : 'col-md-offset-3'},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.value'))+" ("+_vm._s(_vm.coupons.type != 'FIXED' ? '%' : _vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.discount),expression:"modelValidations.discount"},{name:"model",rawName:"v-model",value:(_vm.coupons.discount),expression:"coupons.discount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('marketingCampaigns.value'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "discount", $event.target.value)}}}),_vm._v(" "),(_vm.errors.discount)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('discount'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.couponType),function(type,key){return _c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.type),expression:"modelValidations.type"}],key:key,attrs:{"label":key,"disabled":_vm.model.type != 'COUPON',"inline":true},model:{value:(_vm.coupons.type),callback:function ($$v) {_vm.$set(_vm.coupons, "type", $$v)},expression:"coupons.type"}},[_vm._v(_vm._s(_vm.$t('couponsTypes.' + key)))])})],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.code')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.coupon_code),expression:"modelValidations.coupon_code"},{name:"model",rawName:"v-model",value:(_vm.coupons.coupon_code),expression:"coupons.coupon_code"}],ref:"couponCode",staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('marketingCampaigns.code'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.coupon_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "coupon_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.coupon_code)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('coupon_code'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.generateCode()}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.generateCode')))])])]),_vm._v(" "),(_vm.coupons.usage_type == 'PRODUCTS')?_c('div',{staticClass:"col-md-6 icon-search"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseCategProduct')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchword),expression:"searchword"}],staticClass:"form-control ",attrs:{"type":"text","placeholder":"Search"},domProps:{"value":(_vm.searchword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchword=$event.target.value},_vm.search]}}),_vm._v(" "),_c('v-tree',{ref:"tree",attrs:{"data":_vm.treeData,"multiple":true,"halfcheck":true}})],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4/sg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "41va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersForm_vue__ = __webpack_require__("9S8B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a95325_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersForm_vue__ = __webpack_require__("Holg");
function injectStyle (ssrContext) {
  __webpack_require__("Wnm7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a95325_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "43KB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'number': '000001',
  'created_date': '2018-05-01 10:09',
  'customer_name': 'Ionescu Vasile',
  'status': 'completed',
  'delivery_service': 'Pick up',
  'type': 'group',
  'total': 123.45,
  'currency': 'lei',
  'address': {
    'billing': {
      'id': 10,
      'type': 'billing',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    },
    'shipping': {
      'id': 11,
      'type': 'shipping',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    }
  }
}, {
  'id': 2,
  'number': '000002',
  'created_date': '2018-05-01 09:09',
  'customer_name': 'Vickie Kiehn',
  'status': 'new',
  'delivery_service': 'Half way',
  'type': 'single',
  'total': 52.00,
  'currency': 'lei',
  'county': 'Bihor'
}, {
  'id': 3,
  'number': '000003',
  'created_date': '2018-05-01 08:09',
  'customer_name': 'Ronny McDonalds',
  'status': 'canceled',
  'delivery_service': 'At home',
  'type': 'single',
  'total': 64.30,
  'currency': 'lei',
  'county': 'Bihor'
}]);

/***/ }),

/***/ "4DSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}))])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4KBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row reports"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{staticClass:"row reports-tabs full-height-tabs",attrs:{"direction":"vertical","value":"Description"}},[_c('v-tab',{attrs:{"title":_vm.$t('reports.trends'),"icon":"icon-report icon-report-trends"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.showLocations)?_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.trends.location),expression:"model.trends.location"}],staticClass:"form-control inline-auto white ",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.trends, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateData]}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc,key){return [_c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n                                  ")])]})],2)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pull-left "},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},on:{"change":_vm.updateData},model:{value:(_vm.model.trends.valid),callback:function ($$v) {_vm.$set(_vm.model.trends, "valid", $$v)},expression:"model.trends.valid"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.orderChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.ordersChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.completed'))+"\n                                        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"salesChart",attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.salesChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.salesChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.salesIn'))+" "+_vm._s(_vm.currency)+"\n                                    ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[(!this.model.trends.location)?_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"customersChart",attrs:{"chart-data":_vm.customersChart.data,"chart-options":_vm.customersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.customersChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.customersChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.custWithAcc'))+"\n                                        ")])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-bars-card',{ref:"deliveryChart",attrs:{"chart-data":_vm.deliveryChart.data,"chart-options":_vm.deliveryChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.orderingChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.deliveryChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.nrOfOrders'))+"\n                                    ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-bars-card',{ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.top10Chart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.topProdsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.salesIn'))+" "+_vm._s(_vm.currency)+"\n                                    ")])])])],1)]),_vm._v(" "),(!this.model.trends.location)?_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-6"},[_c('chart-pie-card',{ref:"ageChart",attrs:{"chart-data":_vm.ageChart.data,"chart-options":_vm.ageChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.customersAge')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.ageChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('p')])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-pie-card',{ref:"genderChart",attrs:{"chart-data":_vm.genderChart.data,"chart-options":_vm.genderChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.customersGender')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.genderChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('p')])])])],1)]):_vm._e()]),_vm._v(" "),(false)?_c('v-tab',{attrs:{"title":_vm.$t('reports.clients'),"icon":"icon-report icon-report-clients"}},[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[0].value),expression:"filters[0].value"}],staticClass:"form-control sml",attrs:{"name":"gender"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[0], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('gender.selectGender'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v(_vm._s(_vm.$t('gender.male')))]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v(_vm._s(_vm.$t('gender.female')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[1].value),expression:"filters[1].value"}],staticClass:"form-control sml",attrs:{"name":"age","placeholder":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[1], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('reportsAgesGroups.selectAge'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.20')))]),_vm._v(" "),_c('option',{attrs:{"value":"20-30"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.20-30')))]),_vm._v(" "),_c('option',{attrs:{"value":"30-40"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.30-40')))]),_vm._v(" "),_c('option',{attrs:{"value":"40-50"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.40-50')))]),_vm._v(" "),_c('option',{attrs:{"value":"50+"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.50')))])]),_vm._v(" "),_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},on:{"change":_vm.updateData},model:{value:(_vm.model.trends.valid),callback:function ($$v) {_vm.$set(_vm.model.trends, "valid", $$v)},expression:"model.trends.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{show: false},"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"filters":_vm.filters},on:{"row-click":_vm.goToRecordCustomer}},[_c('el-table-column',{attrs:{"min-width":80,"sortable":"","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                                        "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n                                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"created_at","label":_vm.$t('reports.appInstalls')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"gender","label":_vm.$t('reports.gender')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"location","label":_vm.$t('reports.location')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"email","label":_vm.$t('reports.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"phone","label":_vm.$t('reports.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"purchases","label":_vm.$t('reports.totalAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.sales)))])]}}])})],1)],1)])]):_vm._e(),_vm._v(" "),(false)?_c('v-tab',{attrs:{"title":_vm.$t('reports.products'),"icon":"icon-report icon-report-prod"}},[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},on:{"change":_vm.updateData},model:{value:(_vm.model.trends.valid),callback:function ($$v) {_vm.$set(_vm.model.trends, "valid", $$v)},expression:"model.trends.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.productsTableData,"search-def":{show: false},"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":100,"sortable":"","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                                        "+_vm._s(props.row.name)+"\n                                      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","label":_vm.$t('reports.itemsSold')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                                        "+_vm._s(props.row.items_sold)+"\n                                      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","label":_vm.$t('reports.totalAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.total_amount, props.row.currency_iso)))])]}}])})],1)],1)])]):_vm._e(),_vm._v(" "),(false)?_c('v-tab',{attrs:{"title":_vm.$t('reports.marketing'),"icon":"icon-report icon-report-marketing"}},[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},on:{"change":_vm.updateData},model:{value:(_vm.model.trends.valid),callback:function ($$v) {_vm.$set(_vm.model.trends, "valid", $$v)},expression:"model.trends.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"campaignsTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.campaignsTableData,"search-def":{show: false},"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"name","label":_vm.$t('reports.campaign')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"coupons_time_used","label":_vm.$t('reports.couponsTimesUsed')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"revenue","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.revenue, props.row.currency)))])]}}])})],1)],1)])]):_vm._e()],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Tim":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4U7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'id': 1,
  'number': '000001',
  'created_date': '2018-05-01 10:09',
  'pickup_time': '2018-05-01 12:00',
  'status': 'completed',
  'type': 'group',
  'reward_points': 1,
  'currency': 'lei',
  'delivery': {
    'id': 'pickup',
    'type': 'Pick up'
  },
  'payment': {
    'id': 'cash',
    'type': 'Cash on Delivery'
  },
  'totals': {
    'subtotal': '32.5',
    'discount': '-10',
    'shipping': '5',
    'total': '27.5'
  },
  'comments': '',
  'customer': {
    'id': 1,
    'name': 'Iopescu Viorel',
    'phone': '+44 777 111 222',
    'email': 'iovio@gmail.com'
  },
  'address': {
    'billing': {
      'id': 10,
      'type': 'billing',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    },
    'shipping': {
      'id': 11,
      'type': 'shipping',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    }
  },
  'products': [{
    'customer': {
      'name': 'Viorel'
    },
    'items': [{
      'id': 1,
      'name': 'Cappucinno',
      'quantity': 3,
      'price': 7.00,
      'instructions': 'Please use coconut milk.',
      'category': {
        'category_id': 7,
        'name': 'Beverages'
      },
      'options': [{
        'id': 3,
        'name': 'Extra extresso shot',
        'price': 3
      }]
    }, {
      'id': 1,
      'name': 'Chocolate Chip Cookie',
      'quantity': 1,
      'price': 4.50,
      'instructions': '',
      'category': {
        'category_id': 8,
        'name': 'Cookies'
      },
      'options': []
    }]
  }, {
    'customer': {
      'name': 'Rozi-'
    },
    'items': [{
      'id': 1,
      'name': 'Cappucinno',
      'quantity': 1,
      'price': 7.00,
      'instructions': '',
      'category': {
        'category_id': 7,
        'name': 'Beverages'
      },
      'options': []
    }]
  }],
  'history': [{
    'date': '2018-07-15',
    'status': 'pending',
    'comment': '',
    'customer_notified': 'yes'
  }, {
    'date': '2018-07-15',
    'status': 'processing',
    'comment': '',
    'customer_notified': 'no'
  }]
});

/***/ }),

/***/ "5Anz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdd_vue__ = __webpack_require__("cQcw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7094439e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdd_vue__ = __webpack_require__("qJwf");
function injectStyle (ssrContext) {
  __webpack_require__("vg2b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7094439e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5EKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__("bfzT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59781619_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__("nj1O");
function injectStyle (ssrContext) {
  __webpack_require__("bkX7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59781619_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a897e218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("EtGq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a897e218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FCe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5ObC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5sgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('error'))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control ",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('email'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password*"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('password'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("LOG IN")]),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('router-link',{attrs:{"to":"/recover"}},[_vm._v("\n                          Forgot your password?\n                        ")])],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5tB6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6CO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6HWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__ = __webpack_require__("vCTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CategoryForm', __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      categoryModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "6N/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-12 "},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right "},[_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{ path: '/marketing/offers/add'}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('marketingOffers.single')))])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table "},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingOffers.actions')))]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move"}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('img',{attrs:{"src":(item.image)?item.image : ''}})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.link_type))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.formatDate(item.date_start))+" - "+_vm._s(_vm.formatDate(item.date_end)))]),_vm._v(" "),_c('td',[_c('el-button',{on:{"click":function($event){_vm.handleDelete(index, item, $event)}}},[_vm._v("  "+_vm._s(_vm.$t('general.delete'))+" ")])],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-pencil"})])])]})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6X+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("SkgD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643b5538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("SEsb");
function injectStyle (ssrContext) {
  __webpack_require__("OzXD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643b5538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Yze":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6d4a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6gFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8TJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page reset-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.recoverMsg !== ''),expression:"recoverMsg !== ''"}],staticClass:"text-success"},[_vm._v("\n                      "+_vm._s(_vm.recoverMsg)+"\n                    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('error'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Reset Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.code),expression:"model.code"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.code),expression:"modelValidations.code"}],staticClass:"form-control",attrs:{"type":"text","name":"code","placeholder":"Reset code *"},domProps:{"value":(_vm.model.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "code", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code')),expression:"errors.has('code')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('code'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control ",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password'))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password_confirmation),expression:"modelValidations.password_confirmation"},{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation","placeholder":"Confirm Password","data-vv-as":"password"},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password_confirmation'))+"\n                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Let's go")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo.png"}})]),_vm._v(" "),_c('h4',{staticClass:"purple mar-to-0 mar-bt-25"},[_vm._v("Reset Password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8VFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);

























__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default.a
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchDef: {
        colProps: {
          span: 14
        }
      },
      searchQuery: '',
      propsToSearch: ['name'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['name', 'parent_category']
      }]
    };
  },

  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var self = this;
    console.warn(this.$store.getters.loggedInUser);
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany'),
      use_sort_order: 'asc'
    };
    this.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        self.tableData = response.data;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
  },
  methods: {
    formatCategName: function formatCategName(row) {
      if (row['parent_id']) {
        return row['parent_category']['name'];
      } else {
          return '';
        }
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/categories/edit/');
    },
    adjustSort: function adjustSort(evt) {
      if (this.tableData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          console.warn('first');
          before = 0;
          after = this.tableData[idx + 1].sort_order;
        } else if (idx + 1 === this.tableData.length) {
          console.warn('last');
          before = this.tableData[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          console.warn('middle');
          before = this.tableData[idx - 1].sort_order;
          after = this.tableData[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.tableData[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };

        var self = this;
        this.apiRequest('/category/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: self.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "8aRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__("wpqV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af27d01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__("efnO");
function injectStyle (ssrContext) {
  __webpack_require__("1/EK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af27d01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8ba9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8jhb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ueq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8yVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.model = {
      email: '',
      code: '',
      password: '',
      password_confirmation: ''
    };
  },
  data: function data() {
    return {
      model: {},
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        },
        password: {
          required: true,
          min: 6
        },
        password_confirmation: {
          required: true,
          min: 6
        },
        code: {
          required: true
        }
      },
      recoverMsg: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'code', 'password', 'password_confirmation'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.reset();
        }
      });
    },
    reset: function reset() {
      var creds = {
        email: this.model.email,
        company_id: -1,
        code: this.model.code,
        password_confirmation: this.model.password_confirmation,
        password: this.model.password
      };

      var self = this;
      this.apiRequest('/reset', 'POST', creds, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', response.data['message'] ? response.data['message'] : 'Please check your email adreess to get the reset code.', 'success').catch({});
          self.$router.push('/login');
        } else {
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              if (response.errors[prop].length === 1) {
                self.errors.add(prop, response.errors[prop][0]);
              } else {
                self.errors.add(prop, response.errors[prop]);
              }
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "93hz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.body.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"body":true,"lock":true}}],staticClass:"main-panel",attrs:{"id":"mainContainer"}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9S8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);


















var _components;







__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dialog___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])),
  data: function data() {
    return {
      pickerOptions1: {},
      pickerNames: ['date_validfrom', 'date_validto'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      model: {},
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        title: {
          required: true,
          min: 4
        }
      },
      categories: [],
      products: [],
      loading: true
    };
  },

  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    this.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        self.categories = response.data;
      }
    });
    this.apiRequest('/product', 'GET', data, function (response) {
      if (response.status === true) {
        self.products = response.data;
      }
    });

    if (this.$route.params.id) {
      var id = this.$route.params.id;

      this.apiRequest('/banner/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_start && response.data[0].date_end) {
            response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }
          self.model = response.data[0];

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    } else {
      self.$nextTick(function () {
        self.loading = false;
      });
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.errors.clear();
          _this.saveOffer();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      console.warn('handleImgChnage');

      var isOkSize = file.size / 1024 / 1024 < 1;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log('handleRemove');
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    handleDelete: function handleDelete(label) {
      var _this2 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: self.$t('marketingOffers.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this2.isNew()) {
            self.$router.push('/marketing/offers');
          } else {
            var id = _this2.$route.params.id;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/banner/' + id, 'DELETE', data, function (response) {
              console.warn(response);
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', self.$t('validations.offerDeleted'), 'success');
                self.$router.push('/marketing/offers');
              } else {
                __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    clearLinkSelection: function clearLinkSelection() {
      console.warn('clean');
      this.model.link_id = null;
      this.model.description = null;
    },
    saveOffer: function saveOffer() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        title: this.model.title,
        link_type: this.model.link_type,
        link_id: this.model.link_id,
        description: this.model.description
      };
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.date_start = this.model.fromto[0];
        data.date_end = this.model.fromto[1];
      } else {
        data.date_start = null;
        data.date_end = null;
      }

      var self = this;

      if (this.isNew()) {
        data.sort_order = 0;
        if (self.model.imagelist && self.model.imagelist[0].status === 'ready') {
          self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
            data.image = base64enc;
            self.apiRequest('/banner', 'POST', data, function (response) {
              if (response.status === true) {
                self.$nextTick(function () {
                  self.loading = false;
                });
                __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                  title: '',
                  text: self.$t('marketingOffers.offerAdded'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }).catch(function () {});
                var id = response.data[0].id;
                data.id = id;
                data.sort_order = id;
                self.apiRequest('/banner/' + id, 'PUT', data, function (response2) {});
                self.$router.push('/marketing/offers/edit/' + id);
              } else {
                self.$nextTick(function () {
                  self.loading = false;
                });
                self.handleErrors(response.errors);
              }
            });
          });
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.errors.add('image', self.$t('marketingOffers.validImg'));
        }
      } else {
        var id = this.$route.params.id;

        if (this.model.imagelist === 0) {
          data.image = '';
        }
        this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (self.model.imagelist[0] !== undefined && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                console.warn(data2);
                self.apiRequest('/banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                title: '',
                text: self.$t('marketingOffers.offerUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "9WFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductForm_vue__ = __webpack_require__("jkt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */],
    ProductForm: __WEBPACK_IMPORTED_MODULE_11__ProductForm_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    var _this = this;

    return {
      type: '',
      loaded: false,
      loading: true,
      paginationDef: {
        pageSize: 9999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      searchQuery: '',
      propsToSearch: ['name', 'price', 'status'],
      tableColumns: [],
      tableData: [],
      groupedProducts: [],
      mainCategories: [],
      productOptions: [],
      taxes: [],
      windowHeight: 0,
      tableTopHeight: 70,
      tableBottomHeight: 63,
      prodTopBarHeight: 70,
      pageTopHeight: 0,
      filters: [{
        value: '',
        prop: ['name', 'price']
      }, {
        value: [],
        prop: ['category'],
        filterFn: function filterFn(row, filter) {
          _this.$nextTick(function () {
            _this.tableTopHeight = _this.$refs.tableTop.clientHeight;
          });
          return _this.isInObject(row['category']['id'], filter.value);
        }
      }]
    };
  },

  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {}
  },
  created: function created() {
    var self = this;
    this.getProducts();
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany'),
      inactive: 1
    };
    this.apiRequest('/settings/taxes', 'GET', data, function (response) {
      if (response.status === true) {
        self.taxes = response.data;
      }
    });
    this.apiRequest('/settings/general/' + data['company_id'], 'GET', data, function (response) {
      if (response.status === true) {
        self.productOptions = response.data[0].products_options;
      }
    });

    this.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        self.mainCategories = response.data;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this2.doHeightCalculation();
      });
    });
  },

  methods: {
    showForm: function showForm() {
      if (this.$route.path.indexOf('edit') !== -1 || this.$route.path.indexOf('add') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id && this.$route.params.id !== 'add') {
        this.type = this.$t('general.edit');
        return false;
      } else {
        this.type = this.$t('general.add');
        return true;
      }
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
      this.tableTopHeight = this.$refs.tableTop && this.$refs.tableTop.clientHeight ? this.$refs.tableTop.clientHeight : 0;
      this.tableBottomHeight = this.$refs.tableBottom && this.$refs.tableBottom.clientHeight ? this.$refs.tableBottom.clientHeight : 0;
      this.prodTopBarHeight = this.$refs.prodTopBar ? this.$refs.prodTopBar.clientHeight + 1 : 0;
      if (window.innerWidth < 1200) {
        this.pageTopHeight = 75;
      } else {
        this.pageTopHeight = 0;
      }
    },
    filterChanges: function filterChanges(data) {
      this.doHeightCalculation();
    },
    goToAdd: function goToAdd() {
      this.$router.push('/products/add');
      this.$refs.prodForm.getData();
      this.$refs.prodForm.getTrees();
      this.doHeightCalculation();
    },
    getProducts: function getProducts() {
      this.loading = true;
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1
      };
      var data2 = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        grouped: 1
      };

      this.apiRequest('/product', 'GET', data2, function (response) {
        if (response.status === true) {
          var formattedProds = [];
          var prods = response.data;

          for (var idCateg in prods) {
            if (prods[idCateg].items.length) {
              formattedProds = formattedProds.concat(prods[idCateg].items);
            }
          }
          self.tableData = formattedProds;

          self.paginationDef.pageSize = self.tableData.length + 1;

          if (!self.isNew()) {
            self.$nextTick(function () {
              var el = self.$el.getElementsByClassName('current')[0];
              var container = self.$refs.tableContainerRef;
              var table = self.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody');
              var position = 1;

              for (var i = 0; i < table.children.length; i++) {
                if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                  if (i > 1) {
                    position = i;
                  }
                }
              }
              container.scrollTo({
                left: 0,
                top: el.clientHeight * position,
                behavior: 'smooth'
              });
            });
          }

          self.groupedProducts = response.data;
          self.loaded = true;
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      var _this3 = this;

      this.globalGoToRecord(row, event, column, '/products/edit/');
      if (this.$refs.prodForm) {
        this.$refs.prodForm.getData();
      }
      this.$nextTick(function () {
        _this3.doHeightCalculation();
      });
    },
    handleActive: function handleActive(index, row, e) {
      var _this4 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + ' ' + actionText + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            id: row.id,
            token: _this4.$session.get('token'),
            company_id: _this4.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          };
          _this4.apiRequest('/product/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(this.$t('general.success') + '!', '', 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        row.active = !row.active;
      });
    },
    rowClass: function rowClass(row, index) {
      if (this.$route.params.id && parseInt(row.row.id) === parseInt(this.$route.params.id)) {
        return 'current';
      } else {
        return '';
      }
    },
    handleDelete: function handleDelete(label) {
      this.$refs.prodForm.handleDelete(label);
    },
    validate: function validate() {
      this.$refs.prodForm.validate();
    },
    removeFilter: function removeFilter(filterKey, key) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_7_vue___default.a.delete(this.filters[filterKey].value, key);
      this.$nextTick(function () {
        _this5.tableTopHeight = _this5.$refs.tableTop.clientHeight;
      });
    },
    updateList: function updateList(id, data) {
      var idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData);

      if (idx) {
        this.tableData[idx]['name'] = data['name'];
        this.tableData[idx]['price'] = data['price'];
        this.tableData[idx]['active'] = data['active'];
      }
    }
  }
});

/***/ }),

/***/ "ANMc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/categories"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('category-form',{on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aa8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderEdit_vue__ = __webpack_require__("JtLQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3905a66e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderEdit_vue__ = __webpack_require__("iFs3");
function injectStyle (ssrContext) {
  __webpack_require__("CDIJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3905a66e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AdAc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B2tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAdd_vue__ = __webpack_require__("/mvQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac0087a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAdd_vue__ = __webpack_require__("ANMc");
function injectStyle (ssrContext) {
  __webpack_require__("19rj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac0087a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BEel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardNoSpacingLayout_vue__ = __webpack_require__("kyWX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bf1dc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardNoSpacingLayout_vue__ = __webpack_require__("iK4j");
function injectStyle (ssrContext) {
  __webpack_require__("8ba9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardNoSpacingLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bf1dc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardNoSpacingLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6598ff74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("YX5i");
function injectStyle (ssrContext) {
  __webpack_require__("qEKv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6598ff74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BRE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bl+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BmUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("\n            Support\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright pull-right"},[_vm._v("\n      © Coded with\n      "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n      "),_c('a',{attrs:{"href":"http://www.11digits.com","target":"_blank"}},[_vm._v("11 Digits")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BxdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 pad-bt-10"},[_c('router-link',{staticClass:"btn btn-info",attrs:{"to":"/reports"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Back")])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-7 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:" card-content"},[_c('div',{staticClass:"row pad-bt-10"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.first_name)+" "+_vm._s(_vm.customer.last_name))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.phone))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.gender))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.formatDate(_vm.customer.birth_day)))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.formatted_address))])])]),_vm._v(" "),_c('div',{staticClass:"row card-footer"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-sm-7 col-xs-12"},[_c('div',{staticClass:"card"},[_c('form',{},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row card-content"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{show: false},"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"sortable":"","prop":"price","label":"Total Amount"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.total, props.row.currency))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"status","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"label",class:_vm.statusClass(props.row.status)},[_vm._v(_vm._s(props.row.status))])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"row card-footer"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Cutomer Data\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Phone")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Gender")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Birth Day")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Location")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Sales Details \n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C2Zq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Paper Dashboard PRO")]),_vm._v(" "),_c('h4',[_vm._v("Register for free and experience the dashboard today.")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Free Account")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-bar-chart-alt"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Awesome Performances")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-headphone"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Global Support")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your First Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your Last Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Company"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation"}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"}},[_vm._v("Create Free Account")])])])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"http://11digits.com","target":"_blank"}},[_vm._v("11Digits")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CDIJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CpwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tips_vue__ = __webpack_require__("/goY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47aad659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tips_vue__ = __webpack_require__("fOVh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47aad659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "Ct+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelFromParent: {
      type: [Object, Array],
      required: true
    },
    daysParent: {
      type: Array,
      required: true
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.model = value;
    },
    daysParent: function daysParent(value, oldVal) {
      this.days = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['notification_types', 'notification_mode', 'email'])),
  data: function data() {
    return {
      model: this.value || this.modelFromParent,
      days: this.value || this.daysParent,
      modelValidations: {
        notification_type: {
          required: true
        },
        notification_mode: {
          required: true
        },
        mode: {
          required: true
        },
        time: {
          required: true
        }
      },
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      campaignsNotificationTypes: [],
      campaignsModes: [] };
  },
  created: function created() {
    this.campaignsNotificationTypes = this.$session.get('defaultData')['campaigns_notification_types'];
    this.campaignsModes = this.$session.get('defaultData')['campaigns_modes'];

    this.$nextTick(function () {
      this.model.mode = 'MANUAL';
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      console.warn(this.model.notification_types_array);
      if (this.model.notification_types_array['EMAIL'] === false && this.model.notification_types_array['PUSH'] === false) {
        this.errors.add('notification_type', 'This field is required.');
        console.warn(this.errors);
        return false;
      } else {
        return this.$validator.validateAll().then(function (isValid) {
          if (isValid) {
            _this.errors.clear();
            return true;
          } else {
            return false;
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "DZct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_vm._l((_vm.model),function(notif){return _c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('deliveryTypes.' + notif.delivery_type)))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((notif.messages),function(message){return [_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + message.status)))]),_vm._v(" "),(message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION'))?_c('div',[(notif.delivery_type === 'EAT_LOCATION')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][0]),expression:"notifBits[notif.delivery_type][message.status][0]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.persons'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][1]),expression:"notifBits[notif.delivery_type][message.status][1]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 1, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.dateTime'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][2]),expression:"notifBits[notif.delivery_type][message.status][2]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 2, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n              "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n              "),_c('span',{staticClass:"text-italic"},[_vm._v("\n              "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][0])+" \n              "+_vm._s(_vm.$t('settingsPushNotif.personsPrev'))+" \n              "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][1])+"\n              "+_vm._s(_vm.$t('settingsPushNotif.dateTimePrev'))+" \n              "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][2])+"\n            ")])])]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][0]),expression:"notifBits[notif.delivery_type][message.status][0]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.time'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][1]),expression:"notifBits[notif.delivery_type][message.status][1]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 1, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n              "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n              "),_c('span',{staticClass:"text-italic"},[_vm._v(_vm._s(_vm.notifBits[notif.delivery_type][message.status][0])+" "+_vm._s(_vm.$t('settingsPushNotif.timePrev'))+" "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][1]))])])]],2):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.message),expression:"message.message"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(message.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message, "message", $event.target.value)}}})])])]}),_vm._v(" "),_c('div',{staticClass:"pad-bt-10"})],2)}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DaTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"row order-view"},[_c('div',{staticClass:" col-lg-11 col-md-12 pad-to-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-sm-12"},[_c('h6',{},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "+_vm._s(_vm.$t('orders.updateStatus')))]),_vm._v(" "),_c('hr',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left status-line pad-to-10"},[_vm._l((_vm.orderStatuses),function(sts,i){return [(_vm.order.status.id === sts.type)?_c('span',{class:'current text-' + _vm.orderStatusClass(sts.type)},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + sts.type)))]):(sts.isBefore)?_c('span',{class:'text-' + _vm.orderStatusClass(sts.type)},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + sts.type)))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentOrdersStatus),expression:"currentOrdersStatus"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentOrdersStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){$event.preventDefault();return _vm.changeStatus($event)}]}},_vm._l((_vm.orderStatuses),function(sts,i){return _c('option',{attrs:{"disabled":!sts.isAllowed},domProps:{"value":sts.type}},[_vm._v("\n                            "+_vm._s(_vm.$t('ordersStatus.' + sts.type))+"\n                      ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-sm-12"},[_c('h6',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.$t('orders.single'))+" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("#"+_vm._s(_vm.order.token))])]),_vm._v(" "),_c('h6',{staticClass:"pull-right"},[_c('i',{staticClass:"ti-shopping-cart"}),_vm._v(" "+_vm._s(_vm.$t('orders.ordDetails')))]),_vm._v(" "),_c('hr',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.ordLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.production_details ? _vm.order.production_details.location.name : '-'))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.date')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.order.created_at)))])])]),_vm._v(" "),(_vm.order.delivery_type == 'MEET_HALF')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.meetupLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.location.name : ''))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.madeAt')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.formatTime(_vm.order.created_at)))])])]),_vm._v(" "),(_vm.order.delivery_type !== 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label pad-to-10"},[_vm._v(_vm._s(_vm.$t('orders.pickupTime')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('el-time-picker',{staticClass:"in-inline-120",attrs:{"arrow-control":"","value-format":_vm.timeFormat,"format":_vm.timeFormat,"placeholder":"Select time"},model:{value:(_vm.order.formatted_pickup_datetime),callback:function ($$v) {_vm.$set(_vm.order, "formatted_pickup_datetime", $$v)},expression:"order.formatted_pickup_datetime"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();return _vm.updateHour($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1)]):_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.reservationTime')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.formatted_pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label "},[_vm._v(_vm._s(_vm.$t('orders.rating')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_vm._l((5),function(i){return [(i <= _vm.order.star_feedback)?_c('i',{staticClass:"fa fa-star text-purple"}):_c('i',{staticClass:"fa fa-star-o"})]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.type')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('ordersTypes.' + _vm.order.order_type)))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('paymentTypes.' + _vm.order.payment_type)))]),_vm._v(" "),(_vm.order.payment_type === 'CARD')?_c('b',{domProps:{"innerHTML":_vm._s(_vm.getPaymetnStatus(_vm.order.capture_transaction_status))}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.delivery')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('deliveryTypes.' + _vm.order.delivery_type)))])])]),_vm._v(" "),(_vm.order.delivery_type === 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.reservationSeats')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.how_many : '-'))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.custComments')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.order.comments || '<small>'+_vm.$t('orders.none')+'</small>')}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card",staticStyle:{"min-height":"160px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',{staticClass:"mar-to-0"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.custDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),(_vm.order.delivery_details_firstname)?_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details_firstname)+" ")])]):_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.firstname : '')+" "+_vm._s(_vm.order.customer ? _vm.order.customer.lastname : ''))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.email : ''))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),(_vm.order.delivery_details_phone)?_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.order.delivery_details_phone))]):_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s((_vm.order.customer && _vm.order.customer.phone) ? _vm.order.customer.phone : '-'))])])])])]),_vm._v(" "),_vm._l((_vm.order.address),function(address,type){return _c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card address-box",staticStyle:{"min-height":"160px"}},[_c('div',{staticClass:"card-content"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.' + type)))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"address-content"},[(address)?[_vm._v("\n                "+_vm._s(address.address_name)+" "+_vm._s(address.street)+" "+_vm._s(address.apartment)),_c('br'),_vm._v("\n                "+_vm._s(address.city)+",\n                "+_vm._s(address.state)),_c('br'),_vm._v("\n                "+_vm._s(address.country)+"\n                ")]:[_vm._v("\n                -\n                ")]],2)])])])}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{},[_c('table',{staticClass:"table orders-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('orders.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.qty')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.unit')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.total')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.parts),function(customer){return [(_vm.order.order_type=='GROUP')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.$t('customers.single'))+": "+_vm._s(customer.customer_name))])]):_vm._e(),_vm._v(" "),_vm._l((customer.items),function(prod){return _c('tr',[_c('td',[_vm._v("\n                        "+_vm._s(prod.name)+"\n                        "),_vm._v(" "),_vm._l((prod.options),function(opt){return _c('div',[_vm._v("+ "+_vm._s(opt.name)),(opt.price>0)?_c('span',[_vm._v(" ("+_vm._s(_vm.formatMoneyAmount(opt.price, _vm.currency))+")")]):_vm._e()])}),_vm._v(" "),(prod.additional_info != '')?_c('div',{staticClass:"pad-to-10"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])])]):_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.price, _vm.currency)))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price_total_product), _vm.currency)))])])])})]})],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-5 order-comment"}),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('table',{staticClass:"table no-border totals-table"},[_c('tbody',[_vm._l((_vm.totals),function(label){return [(label == 'totals_grandtotal' || _vm.order[label] > 0)?_c('tr',{class:_vm.getRowClass(label)},[_c('td',[_vm._v(_vm._s(_vm.$t('orders.' + label)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.order[label], _vm.currency, true)))])]):_vm._e()]})],2)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/comment.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.adminComments')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.backoffice_comments),expression:"order.backoffice_comments"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('orders.none'),"rows":"5"},domProps:{"value":(_vm.order.backoffice_comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "backoffice_comments", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-success btn-fill btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.saveComment($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dmt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EWf/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EdqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['name', 'text', 'seen', 'type']
      }]
    };
  },

  created: function created() {
    var self = this;
    console.warn(this.$store.getters.loggedInUser);
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.apiRequest('/feedback', 'GET', data, function (response) {
      if (response.status === true) {
        self.tableData = response.data;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
  },
  methods: {
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: 'Are you sure you want to delete \'' + row.name + '\'?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          _this.apiRequest('/hello', 'GET', [], function (response) {
            console.warn(response);
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', 'Push Notification deleted successfully', 'success');
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
            }
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/feedback/view/');
    },
    rowClass: function rowClass(row, index) {
      if (row.row.seen) {
        return '';
      } else {
        return 'new-feedback';
      }
    }
  }
});

/***/ }),

/***/ "EtGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8ab":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FQR9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FfsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);














__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a),
  props: {},
  watch: {},
  data: function data() {
    return {
      model: [],
      modelValidate: {
        name: { required: true },
        required: { required: true }
      },
      optionTypes: {
        'checkbox': this.$t('checkbox'),
        'radio': this.$t('radio')
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true
    };
  },
  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var data = {
      token: this.$session.get('token')
    };
    var self = this;
    var companyID = this.$session.get('selectedCompany');

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.defaultData = response.data[0];
      }
    });

    this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
      if (response2.status === true) {
        self.model = response2.data[0];
        self.$nextTick(function () {
          self.loading = false;
        });
      }
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveDetails();
        }
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    addNewValue: function addNewValue(optId) {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            'id': null,
            'label': ''
          };
          newRow.id = response.data[0].id;

          var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options);

          var zElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(self.model.products_options).filter(function (element) {
            return element.id === optId;
          });

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(zElement[0].values).length === 0) {
            zElement[0].values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(zElement[0].values));
          }

          zElement[0].values.push(newRow);
        }
      });
    },
    addNewOption: function addNewOption() {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes',
        'counter': 2
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            'id': null,
            'name': '',
            'type': '',
            'values': []
          };
          newRow.id = response.data[0].id;

          var newOption = {
            'id': null,
            'label': ''
          };
          newOption.id = response.data[1].id;

          newRow.values.push(newOption);

          if (!self.model.products_options) {
            self.model.products_options = [];
          }

          self.model.products_options.push(newRow);
        }
      });
    },
    duplicateOption: function duplicateOption(optId) {
      var counter = 1;

      var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options);
      counter += this.model.products_options[optIdx].values.length;

      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes',
        'counter': counter
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newOpt = self.copyObject(self.model.products_options[optIdx]);
          console.table(newOpt);
          newOpt.id = response.data[0].id;
          var i = 1;
          for (var idx in newOpt.values) {
            newOpt.values[idx].id = response.data[i].id;
            i++;
          }
          self.model.products_options.push(newOpt);
        }
      });
    },
    deleteValue: function deleteValue(optId, valId) {
      var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options);
      var valIdx = this.getObjectByElemKeyValue('id', valId, this.model.products_options[optIdx].values);

      this.model.products_options[optIdx].values.splice(valIdx, 1);
    },
    deleteOption: function deleteOption(optId) {
      var _this3 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: self.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            product_option_id: optId
          };
          _this3.apiRequest('/settings/usage', 'POST', data, function (response) {
            if (response.status) {
              var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options);
              self.model.products_options.splice(optIdx, 1);
            } else {
              console.warn(response);
              var msg = response.errors['product_option_id'] ? response.errors['product_option_id'] : self.$t('validations.wentWrong');
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', msg, 'error');
            }
          });
        }
      }).catch(function () {});
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'products_options': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.products_options)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': self.$t('catalogProdOpt.optionSaved'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'dashboard',
  icon: 'dash',
  path: '/admin/overview'
}, {
  name: 'customers',
  icon: 'cust',
  path: '/customers'
}, {
  name: 'orders',
  icon: 'order',
  path: '/orders',
  session: 'newOrders'
}, {
  name: 'catalog',
  icon: 'catalog',
  children: [{
    name: 'products',
    path: '/products'
  }, {
    name: '',
    path: '/product/add'
  }, {
    name: '',
    path: '/product/edit',
    isRoute: false
  }, {
    name: 'categories',
    path: '/categories'
  }, {
    name: '',
    path: '/category/add'
  }, {
    name: 'productOptions',
    nameshort: 'PO',
    path: '/product-options' }]
}, {
  name: 'marketing',
  icon: 'marketing',
  children: [{
    path: '/marketing/campaigns',
    name: 'campaigns'
  }, {
    path: '/marketing/offers',
    name: 'offersSlider',
    nameshort: 'OS'
  }]
}, {
  name: 'reports',
  icon: 'report',
  path: '/reports'
}, {
  icon: 'feedback',
  name: 'feedback',
  path: '/feedback',
  session: 'newFeedback'
}, {
  name: 'settings',
  icon: 'settings',
  path: '/settings'
}]);

/***/ }),

/***/ "Fk17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vue-tabs',{staticClass:"row settings-tabs full-height-tabs",attrs:{"direction":"vertical","type":"tabs"},on:{"tab-change":_vm.handleTabChange},model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.userSettings'),"tabId":"first","disabled":""}}),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.myProfile')}},[_c('user-form',{attrs:{"callback":_vm.updateList,"userId":_vm.user.id},on:{"on-submit":_vm.onUserSubmit}})],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left active",attrs:{"title":_vm.$t('settingsPages.users')}},[(_vm.selectedUser != false)?[_c('user-form',{attrs:{"callback":_vm.updateList,"userId":_vm.selectedUser},on:{"on-submit":_vm.onUserSubmit}})]:[_c('users-list',{ref:"userList",attrs:{"callback":_vm.getUser}})]],2),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.general'),"disabled":""}}),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.companyDetails')}},[_c('company-details',{attrs:{"modeldata":_vm.model,"countries":_vm.defaultData.countries,"taxesData":_vm.taxes,"tabRefresh":_vm.tabName},on:{"updateModelData":_vm.updateModelData}})],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.dateTime')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('datetime-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.currency')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('currency-form',{attrs:{"modeldata":_vm.model,"currencylist":_vm.defaultData.currencies,"currencyformatlist":_vm.defaultData.currency_display_format}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.accounting'),"disabled":""}}),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.tax')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('tax-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData,"taxesData":_vm.taxes},on:{"setSelectedTab":_vm.setSelectedTab,"setTaxes":_vm.setTaxes}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.orderingMng')}},[_c('ordering-management',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}}),_vm._v(" "),_c('p')],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.infoPages')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('info-pages'),_vm._v(" "),_c('p')],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.loyalty')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9 col-md-10 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content "},[_c('reward-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}})],1)])])])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.push')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('push-notifications',{attrs:{"modeldata":_vm.model.push_notifications}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.tips')}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('tips-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData,"taxesData":_vm.taxes}})],1)])])],1),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer text-center"},[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GK6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("Ct+h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45d493a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("ln6l");
function injectStyle (ssrContext) {
  __webpack_require__("Bl+O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45d493a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GLZa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GgTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"col-lg-10 col-md-12 card pad-to-15"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":"Search"},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":_vm.searchDef,"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"table-props":{'row-class-name': _vm.rowClass, 'border': false},"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"type","label":_vm.$t('feedback.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"label",class:'label-' + _vm.feedbackTypeClass(props.row.type)},[_vm._v(_vm._s(_vm.$t('feedbackTypes.' + props.row.type)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"","prop":"sent_by","label":_vm.$t('feedback.sentBy')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.creater.firstname && props.row.creater.lastname)?[_vm._v("\n                "+_vm._s(props.row.creater.firstname)+" "+_vm._s(props.row.creater.lastname)+"\n              ")]:[_vm._v(_vm._s(props.row.creater.email))]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"sortable":"","prop":"text","label":_vm.$t('feedback.text')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.limitChars(props.row.text, 100))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"seen","label":_vm.$t('feedback.seen')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.seen ? 'seen' : 'new')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"","prop":"created_at","label":_vm.$t('feedback.sentAt')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":45},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"fa fa-pencil"})]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GuXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  1: {
    'id': 1,
    'name': 'Cappucinno',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 8,
    'currency': 'lei'
  },
  2: {
    'id': 2,
    'name': 'Latte Machiato',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 7.50,
    'currency': 'lei'
  },
  3: {
    'id': 3,
    'name': 'Chocolate Cookie ',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': false,
    'type': 'combo',
    'price': 10.20,
    'currency': 'lei'
  }
});

/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HOa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__ = __webpack_require__("cxx/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7059460b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__ = __webpack_require__("zeKj");
function injectStyle (ssrContext) {
  __webpack_require__("GLZa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7059460b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050a487e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("+OPE");
function injectStyle (ssrContext) {
  __webpack_require__("8ueq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050a487e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HRf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"text-center purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseTarget')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1 pad-bt-15"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.gender')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[1].value),expression:"filters[1].value"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('marketingCampaigns.gender')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[1], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v(_vm._s(_vm.$t('gender.male')))]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v(_vm._s(_vm.$t('gender.female')))])])]),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.age')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[3].value),expression:"filters[3].value"}],staticClass:"form-control",attrs:{"name":"age","placeholder":_vm.$t('marketingCampaigns.age')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[3], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.20')))]),_vm._v(" "),_c('option',{attrs:{"value":"20-30"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["20-30"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"30-40"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["30-40"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"40-50"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["40-50"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"50+"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["50"]')))])])]),_vm._v(" "),(_vm.locations.length > 1)?_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[4].value),expression:"filters[4].value"}],staticClass:"form-control",attrs:{"name":"location_id","placeholder":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[4], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.ordersAbove'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[2].value),expression:"filters[2].value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"E.g. 200"},domProps:{"value":(_vm.filters[2].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters[2], "value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%","background":"#fff"},attrs:{"data":_vm.tableData,"filters":_vm.filters,"table-props":{'border': false, 'stripe': false,}},on:{"filtered-data":_vm.dataFiltered}},[_c('el-table-column',{attrs:{"label":"","min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.firstname != null || props.row.lastname != null)?[_vm._v("\n                  "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n                ")]:[_vm._v("\n                  "+_vm._s(props.row.email)+"\n                ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","min-width":60},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.sales > 0 ? _vm.formatMoneyAmount(props.row.sales, props.row.currency) : ''))])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Holg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"},{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('marketingOffers.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('title'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_start'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('date_start'))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])]),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('image'))+"\n            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_type),expression:"model.link_type"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.clearLinkSelection()}]}},[_c('option',[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.category')))]),_vm._v(" "),_c('option',{attrs:{"value":"product"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.product')))]),_vm._v(" "),_c('option',{attrs:{"value":"page"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.page')))])]),_vm._v(" "),(_vm.errors.has('link_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_type'))+"\n            ")]):_vm._e()]),_vm._v(" "),(_vm.model.link_type == 'page')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pageText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":""},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('description'))+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'category')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickCateg')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.categories),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_id'))+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'product')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickProd')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.products),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_id'))+"\n            ")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer "},[_c('button',{staticClass:"btn btn-fill btn-success",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-fill ",attrs:{"title":""},on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.delete'))}}},[_vm._v(" "+_vm._s(_vm.$t('general.delete')))]):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-fill",on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.cancel'))}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HqqK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HuIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details"},[_c('div',{ref:"optionsTopBar",staticClass:"company-top-bar "},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-fill btn-success btn",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])])]),_vm._v(" "),_c('div',{ref:"compDetailsContainer",staticClass:"company-wrap",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix pad-bt-15 row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingCompany.title'))+"\n              "),_c('button',{staticClass:"btn btn-info pull-right",on:{"click":function($event){$event.preventDefault();return _vm.addLocation($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('settingCompany.location')))])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('settingCompany.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.lang')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.language),expression:"modelValidate.language"}],staticClass:"form-control",attrs:{"placeholder":" - Select Language - "},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.languages),function(label,key){return _c('option',{key:key,attrs:{"label":label},domProps:{"value":key}},[_vm._v(_vm._s(label))])})),_vm._v(" "),(_vm.errors.has('language'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('language'))+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-md-2 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.state')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.tips_in_use),callback:function ($$v) {_vm.$set(_vm.model, "tips_in_use", $$v)},expression:"model.tips_in_use"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-4 "},[_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.tipsTaxes')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.taxes,"value":"id","label":"name","disabled":!_vm.model.tips_in_use},model:{value:(_vm.model.tips_taxes),callback:function ($$v) {_vm.$set(_vm.model, "tips_taxes", $$v)},expression:"model.tips_taxes"}}),_vm._v(" "),(_vm.errors.has(_vm.model.tips_taxes))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError(_vm.model.tips_taxes))+"\n              ")]):_vm._e()],1)])])])])]),_vm._v(" "),_vm._l((_vm.model.locations_details),function(location){return [_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',{staticClass:"company-location"},[_c('i',{staticClass:"ti-home"}),_vm._v(" "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(location.name)+"\n                "),(_vm.showDelete || _vm.model.isNew)?_c('button',{staticClass:"btn btn-danger pull-right btn-fill mar-to--5",on:{"click":function($event){$event.preventDefault();_vm.deleteLocation(location.id)}}},[_vm._v(_vm._s(_vm.$t('general.delete')))]):_vm._e()]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.name),expression:"location.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"}],staticClass:"form-control",attrs:{"type":"text","name":"phome","placeholder":_vm.$t('settingCompany.name')},domProps:{"value":(location.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "name", $event.target.value)}}})])]),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.phone),expression:"location.phone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.phone),expression:"modelValidate.phone"}],staticClass:"form-control",attrs:{"type":"text","name":"phome","placeholder":"$t('settingCompany.phone')"},domProps:{"value":(location.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.email),expression:"location.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingCompany.email')},domProps:{"value":(location.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.street),expression:"location.street"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.street),expression:"modelValidate.street"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":_vm.$t('settingCompany.street')},domProps:{"value":(location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.city),expression:"location.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.city),expression:"modelValidate.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":_vm.$t('settingCompany.city')},domProps:{"value":(location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.country')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.country),expression:"modelValidate.country"}],ref:"country",refInFor:true,staticClass:"select-primary form-control",attrs:{"name":"country"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(location)}]}},_vm._l((_vm.countriesList),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                  ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.state')))]),_vm._v(" "),(_vm.showStateDrop(location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                    ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.state),expression:"modelValidate.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state"},domProps:{"value":(location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "state", $event.target.value)}}})]],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('h6',{staticClass:"pad-to-10"},[_vm._v(_vm._s(_vm.$t('settingCompany.availableDaysHrs')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((location.working_hours),function(day){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-4 col-sm-4 col-xs-12 padd in-inline-160"},[_c('p-checkbox',{key:day.day,attrs:{"value":day.day,"label":day.day},model:{value:(day.open),callback:function ($$v) {_vm.$set(day, "open", $$v)},expression:"day.open"}},[_vm._v(_vm._s(_vm._f("capitalize")(day.day)))])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-4 col-sm-4 col-xs-12 padd"},[_vm._v("\n                    "+_vm._s(_vm.$t('settingCompany.from'))+"\n                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.working_hours),expression:"modelValidate.working_hours"}],attrs:{"disabled":!day.open,"placeholder":"Select time","value":day.open_from,"value-format":_vm.timeFormat,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                    "+_vm._s(_vm.$t('settingCompany.to'))+"\n                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.working_hours),expression:"modelValidate.working_hours"}],attrs:{"disabled":!day.open,"placeholder":"Select time","value":day.open_to,"value-format":_vm.timeFormat,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)])}),_vm._v(" "),(_vm.errors.has('working_hours'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('working_hours'))+"\n                ")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.userTaxes')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.single')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.amount')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((location.taxes),function(tax_rate){return _c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.id),expression:"tax_rate.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax_rate, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.taxes),function(tax){return _c('option',{attrs:{"disabled":_vm.disableTaxOption(location.id, tax.id) && tax.id != tax_rate.id},domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.name))])})),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.type),expression:"tax_rate.type"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"name":'type'+tax_rate.id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax_rate, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"FIXED_INCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.FIXED_INCLUDED')))]),_vm._v(" "),_c('option',{attrs:{"value":"FIXED_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.FIXED_EXCLUDED')))]),_vm._v(" "),_c('option',{attrs:{"value":"PERCENTAGE_INCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_INCLUDED')))]),_vm._v(" "),_c('option',{attrs:{"value":"PERCENTAGE_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_EXCLUDED')))])])]),_c('td',[_c('label',{staticClass:"label-currency"},[_vm._v(_vm._s(tax_rate.type == 'FIXED' ? _vm.currency : '%'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.amount),expression:"tax_rate.amount"},{name:"validate",rawName:"v-validate",value:({required: true, min_value:0}),expression:"{required: true, min_value:0}"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'amount'+tax_rate.id},domProps:{"value":(tax_rate.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "amount", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(location.id, tax_rate.id)}}},[_c('i',{staticClass:"ti-close ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(location.taxes.length < _vm.taxes.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2)]),_vm._v(" "),(location.taxes.length < _vm.taxes.length)?_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewTax(location.id)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('settingTaxes.single'))+"\n                ")]):_vm._e()])])])])])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IERb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.isRequired),expression:"isRequired"},{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ITsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TimeLine', __WEBPACK_IMPORTED_MODULE_7__Dashboard_Stats_TimeLine_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TimeLineItem', __WEBPACK_IMPORTED_MODULE_8__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      message: {},
      loading: true
    };
  },

  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });

    if (this.$route.params.id) {
      var id = this.$route.params.id;
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/feedback/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          self.message = response.data[0];
          self.$nextTick(function () {
            self.loading = false;
          });
          if (response.data[0].seen === 0) {
            self.apiRequest('/feedback/' + id, 'DELETE', data, function (response) {
              console.warn('seen');
            });
          }
        }
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ "IZUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryEdit_vue__ = __webpack_require__("6HWz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406645ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryEdit_vue__ = __webpack_require__("h74b");
function injectStyle (ssrContext) {
  __webpack_require__("tkRG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406645ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


var _mutations;




__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token')
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN, function (state) {
    state.pending = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN_SUCCESS, function (state) {
    state.isLoggedIn = true;
    state.pending = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGOUT, function (state) {
    state.isLoggedIn = false;
  }), _mutations),
  actions: {
    login: function login(_ref, creds) {
      var commit = _ref.commit;

      commit(LOGIN);
      localStorage.setItem('token', creds.token);
      commit(LOGIN_SUCCESS);
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      localStorage.removeItem('token');
      commit(LOGOUT);
    }
  },
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return state.isLoggedIn;
    }
  }
}));

/***/ }),

/***/ "Id4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/marketing/campaigns"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('campaign-form',{on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JB9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__);











__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a),
  props: {
    currencylist: {},
    currencyformatlist: {},
    modeldata: {}
  },
  watch: {
    currencylist: function currencylist(value) {
      this.currencies = value;
    },
    currencyformatlist: function currencyformatlist(value) {
      this.currenciesformat = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    }
  },
  data: function data() {
    return {
      model: [],
      currencies: [],
      currenciesformat: [],
      modelValidate: {
        name: { required: true },
        email: { required: true, email: true },
        phone: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true }
      },
      loading: false
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    displayCurrecy: function displayCurrecy(cr) {
      var name = this.getCurrencySymbol(cr.iso);
      return name + ' - ' + cr.name;
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'currency_display_format': 1,
        'currency_iso': this.model.currency_iso
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$session.set('selectedCompanyData', response.data[0]);
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({ 'text': self.$t('settingCurrency.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "JIOi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JtLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__order__ = __webpack_require__("4U7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Customers_customers__ = __webpack_require__("qBXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DeliveryService_services__ = __webpack_require__("rat0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Products_products__ = __webpack_require__("GuXC");









var _components;









__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a), _components),
  data: function data() {
    return {
      order: __WEBPACK_IMPORTED_MODULE_10__order__["a" /* default */],
      countries: __WEBPACK_IMPORTED_MODULE_11__Customers_countries__["a" /* default */],
      customers: __WEBPACK_IMPORTED_MODULE_12__Customers_customers__["a" /* default */],
      deliveryMethods: __WEBPACK_IMPORTED_MODULE_13__DeliveryService_services__["a" /* default */],
      productsAll: __WEBPACK_IMPORTED_MODULE_14__Products_products__["a" /* default */],
      states: { billing: [], shipping: [] },
      modelValidations: {
        required: {
          required: true
        },
        product: {
          required: true
        },
        person: {
          required: true,
          min: 3
        },
        quantity: {
          required: true,
          min: 1
        }
      },
      newOrderHist: {
        'status': '',
        'comment': '',
        'customer_notified': false
      },
      modelProduct: {
        product: '',
        person: '',
        quantity: '1',
        price: 0
      },
      historyTableColumns: [{
        prop: 'date',
        label: 'Date',
        minWidth: 100
      }, {
        prop: 'comment',
        label: 'Comment',
        minWidth: 200
      }, {
        prop: 'status',
        label: 'Status',
        minWidth: 100
      }, {
        prop: 'customer_notified',
        label: 'Customer Notified',
        minWidth: 50
      }]
    };
  },
  created: function created() {},

  methods: {
    getRowClass: function getRowClass(label) {
      switch (label) {
        case 'discount':
          return 'text-danger';
        case 'total':
          return 'text-info';
        default:
          return '';
      }
    },
    addOrderHistory: function addOrderHistory() {
      var history = {
        'date': new Date().toJSON().slice(0, 10),
        'status': this.newOrderHist.status,
        'customer_notified': this.newOrderHist.customer_notified ? 'yes' : 'no',
        'comment': this.newOrderHist.comment
      };
      console.warn(this);
      this.historyTableData.push(history);
      this.newOrderHist = {
        'status': '',
        'comment': '',
        'customer_notified': false
      };
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    addProduct: function addProduct() {
      var valid = this.validate();

      if (!valid) {
        return false;
      }

      var items = this.productsAll;
      var price = items[this.modelProduct.product].price;

      var newRow = {
        'customer': {
          'name': this.modelProduct.person
        },
        'items': [{
          'product_id': this.modelProduct.product,
          'name': items[this.modelProduct.product].name,
          'quantity': this.modelProduct.quantity,
          'price': price,
          'additional_info': '',
          'options': []
        }]
      };
      this.order.products.push(newRow);

      this.modelProduct = {
        product: '',
        person: '',
        quantity: '1',
        price: 0
      };
    },
    updateCounty: function updateCounty(type) {
      var name = this.order.address[type].country.name;
      console.warn(type);
      this.states[type] = this.getCoutryStates(name);
    }
  }
});

/***/ }),

/***/ "KLaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ 'name': 'Afghanistan', 'code': 'AF' }, { 'name': 'land Islands', 'code': 'AX' }, { 'name': 'Albania', 'code': 'AL' }, { 'name': 'Algeria', 'code': 'DZ' }, { 'name': 'American Samoa', 'code': 'AS' }, { 'name': 'AndorrA', 'code': 'AD' }, { 'name': 'Angola', 'code': 'AO' }, { 'name': 'Anguilla', 'code': 'AI' }, { 'name': 'Antarctica', 'code': 'AQ' }, { 'name': 'Antigua and Barbuda', 'code': 'AG' }, { 'name': 'Argentina', 'code': 'AR' }, { 'name': 'Armenia', 'code': 'AM' }, { 'name': 'Aruba', 'code': 'AW' }, { 'name': 'Australia', 'code': 'AU' }, { 'name': 'Austria', 'code': 'AT' }, { 'name': 'Azerbaijan', 'code': 'AZ' }, { 'name': 'Bahamas', 'code': 'BS' }, { 'name': 'Bahrain', 'code': 'BH' }, { 'name': 'Bangladesh', 'code': 'BD' }, { 'name': 'Barbados', 'code': 'BB' }, { 'name': 'Belarus', 'code': 'BY' }, { 'name': 'Belgium', 'code': 'BE' }, { 'name': 'Belize', 'code': 'BZ' }, { 'name': 'Benin', 'code': 'BJ' }, { 'name': 'Bermuda', 'code': 'BM' }, { 'name': 'Bhutan', 'code': 'BT' }, { 'name': 'Bolivia', 'code': 'BO' }, { 'name': 'Bosnia and Herzegovina', 'code': 'BA' }, { 'name': 'Botswana', 'code': 'BW' }, { 'name': 'Bouvet Island', 'code': 'BV' }, { 'name': 'Brazil', 'code': 'BR' }, { 'name': 'British Indian Ocean Territory', 'code': 'IO' }, { 'name': 'Brunei Darussalam', 'code': 'BN' }, { 'name': 'Bulgaria', 'code': 'BG' }, { 'name': 'Burkina Faso', 'code': 'BF' }, { 'name': 'Burundi', 'code': 'BI' }, { 'name': 'Cambodia', 'code': 'KH' }, { 'name': 'Cameroon', 'code': 'CM' }, { 'name': 'Canada', 'code': 'CA' }, { 'name': 'Cape Verde', 'code': 'CV' }, { 'name': 'Cayman Islands', 'code': 'KY' }, { 'name': 'Central African Republic', 'code': 'CF' }, { 'name': 'Chad', 'code': 'TD' }, { 'name': 'Chile', 'code': 'CL' }, { 'name': 'China', 'code': 'CN' }, { 'name': 'Christmas Island', 'code': 'CX' }, { 'name': 'Cocos (Keeling) Islands', 'code': 'CC' }, { 'name': 'Colombia', 'code': 'CO' }, { 'name': 'Comoros', 'code': 'KM' }, { 'name': 'Congo', 'code': 'CG' }, { 'name': 'Congo, The Democratic Republic of the', 'code': 'CD' }, { 'name': 'Cook Islands', 'code': 'CK' }, { 'name': 'Costa Rica', 'code': 'CR' }, { 'name': 'Cote D\'Ivoire', 'code': 'CI' }, { 'name': 'Croatia', 'code': 'HR' }, { 'name': 'Cuba', 'code': 'CU' }, { 'name': 'Cyprus', 'code': 'CY' }, { 'name': 'Czech Republic', 'code': 'CZ' }, { 'name': 'Denmark', 'code': 'DK' }, { 'name': 'Djibouti', 'code': 'DJ' }, { 'name': 'Dominica', 'code': 'DM' }, { 'name': 'Dominican Republic', 'code': 'DO' }, { 'name': 'Ecuador', 'code': 'EC' }, { 'name': 'Egypt', 'code': 'EG' }, { 'name': 'El Salvador', 'code': 'SV' }, { 'name': 'Equatorial Guinea', 'code': 'GQ' }, { 'name': 'Eritrea', 'code': 'ER' }, { 'name': 'Estonia', 'code': 'EE' }, { 'name': 'Ethiopia', 'code': 'ET' }, { 'name': 'Falkland Islands (Malvinas)', 'code': 'FK' }, { 'name': 'Faroe Islands', 'code': 'FO' }, { 'name': 'Fiji', 'code': 'FJ' }, { 'name': 'Finland', 'code': 'FI' }, { 'name': 'France', 'code': 'FR' }, { 'name': 'French Guiana', 'code': 'GF' }, { 'name': 'French Polynesia', 'code': 'PF' }, { 'name': 'French Southern Territories', 'code': 'TF' }, { 'name': 'Gabon', 'code': 'GA' }, { 'name': 'Gambia', 'code': 'GM' }, { 'name': 'Georgia', 'code': 'GE' }, { 'name': 'Germany', 'code': 'DE' }, { 'name': 'Ghana', 'code': 'GH' }, { 'name': 'Gibraltar', 'code': 'GI' }, { 'name': 'Greece', 'code': 'GR' }, { 'name': 'Greenland', 'code': 'GL' }, { 'name': 'Grenada', 'code': 'GD' }, { 'name': 'Guadeloupe', 'code': 'GP' }, { 'name': 'Guam', 'code': 'GU' }, { 'name': 'Guatemala', 'code': 'GT' }, { 'name': 'Guernsey', 'code': 'GG' }, { 'name': 'Guinea', 'code': 'GN' }, { 'name': 'Guinea-Bissau', 'code': 'GW' }, { 'name': 'Guyana', 'code': 'GY' }, { 'name': 'Haiti', 'code': 'HT' }, { 'name': 'Heard Island and Mcdonald Islands', 'code': 'HM' }, { 'name': 'Holy See (Vatican City State)', 'code': 'VA' }, { 'name': 'Honduras', 'code': 'HN' }, { 'name': 'Hong Kong', 'code': 'HK' }, { 'name': 'Hungary', 'code': 'HU' }, { 'name': 'Iceland', 'code': 'IS' }, { 'name': 'India', 'code': 'IN' }, { 'name': 'Indonesia', 'code': 'ID' }, { 'name': 'Iran, Islamic Republic Of', 'code': 'IR' }, { 'name': 'Iraq', 'code': 'IQ' }, { 'name': 'Ireland', 'code': 'IE' }, { 'name': 'Isle of Man', 'code': 'IM' }, { 'name': 'Israel', 'code': 'IL' }, { 'name': 'Italy', 'code': 'IT' }, { 'name': 'Jamaica', 'code': 'JM' }, { 'name': 'Japan', 'code': 'JP' }, { 'name': 'Jersey', 'code': 'JE' }, { 'name': 'Jordan', 'code': 'JO' }, { 'name': 'Kazakhstan', 'code': 'KZ' }, { 'name': 'Kenya', 'code': 'KE' }, { 'name': 'Kiribati', 'code': 'KI' }, { 'name': 'Korea, Democratic People\'S Republic of', 'code': 'KP' }, { 'name': 'Korea, Republic of', 'code': 'KR' }, { 'name': 'Kuwait', 'code': 'KW' }, { 'name': 'Kyrgyzstan', 'code': 'KG' }, { 'name': 'Lao People\'S Democratic Republic', 'code': 'LA' }, { 'name': 'Latvia', 'code': 'LV' }, { 'name': 'Lebanon', 'code': 'LB' }, { 'name': 'Lesotho', 'code': 'LS' }, { 'name': 'Liberia', 'code': 'LR' }, { 'name': 'Libyan Arab Jamahiriya', 'code': 'LY' }, { 'name': 'Liechtenstein', 'code': 'LI' }, { 'name': 'Lithuania', 'code': 'LT' }, { 'name': 'Luxembourg', 'code': 'LU' }, { 'name': 'Macao', 'code': 'MO' }, { 'name': 'Macedonia, The Former Yugoslav Republic of', 'code': 'MK' }, { 'name': 'Madagascar', 'code': 'MG' }, { 'name': 'Malawi', 'code': 'MW' }, { 'name': 'Malaysia', 'code': 'MY' }, { 'name': 'Maldives', 'code': 'MV' }, { 'name': 'Mali', 'code': 'ML' }, { 'name': 'Malta', 'code': 'MT' }, { 'name': 'Marshall Islands', 'code': 'MH' }, { 'name': 'Martinique', 'code': 'MQ' }, { 'name': 'Mauritania', 'code': 'MR' }, { 'name': 'Mauritius', 'code': 'MU' }, { 'name': 'Mayotte', 'code': 'YT' }, { 'name': 'Mexico', 'code': 'MX' }, { 'name': 'Micronesia, Federated States of', 'code': 'FM' }, { 'name': 'Moldova, Republic of', 'code': 'MD' }, { 'name': 'Monaco', 'code': 'MC' }, { 'name': 'Mongolia', 'code': 'MN' }, { 'name': 'Montenegro', 'code': 'ME' }, { 'name': 'Montserrat', 'code': 'MS' }, { 'name': 'Morocco', 'code': 'MA' }, { 'name': 'Mozambique', 'code': 'MZ' }, { 'name': 'Myanmar', 'code': 'MM' }, { 'name': 'Namibia', 'code': 'NA' }, { 'name': 'Nauru', 'code': 'NR' }, { 'name': 'Nepal', 'code': 'NP' }, { 'name': 'Netherlands', 'code': 'NL' }, { 'name': 'Netherlands Antilles', 'code': 'AN' }, { 'name': 'New Caledonia', 'code': 'NC' }, { 'name': 'New Zealand', 'code': 'NZ' }, { 'name': 'Nicaragua', 'code': 'NI' }, { 'name': 'Niger', 'code': 'NE' }, { 'name': 'Nigeria', 'code': 'NG' }, { 'name': 'Niue', 'code': 'NU' }, { 'name': 'Norfolk Island', 'code': 'NF' }, { 'name': 'Northern Mariana Islands', 'code': 'MP' }, { 'name': 'Norway', 'code': 'NO' }, { 'name': 'Oman', 'code': 'OM' }, { 'name': 'Pakistan', 'code': 'PK' }, { 'name': 'Palau', 'code': 'PW' }, { 'name': 'Palestinian Territory, Occupied', 'code': 'PS' }, { 'name': 'Panama', 'code': 'PA' }, { 'name': 'Papua New Guinea', 'code': 'PG' }, { 'name': 'Paraguay', 'code': 'PY' }, { 'name': 'Peru', 'code': 'PE' }, { 'name': 'Philippines', 'code': 'PH' }, { 'name': 'Pitcairn', 'code': 'PN' }, { 'name': 'Poland', 'code': 'PL' }, { 'name': 'Portugal', 'code': 'PT' }, { 'name': 'Puerto Rico', 'code': 'PR' }, { 'name': 'Qatar', 'code': 'QA' }, { 'name': 'Reunion', 'code': 'RE' }, { 'name': 'Romania', 'code': 'RO' }, { 'name': 'Russian Federation', 'code': 'RU' }, { 'name': 'RWANDA', 'code': 'RW' }, { 'name': 'Saint Helena', 'code': 'SH' }, { 'name': 'Saint Kitts and Nevis', 'code': 'KN' }, { 'name': 'Saint Lucia', 'code': 'LC' }, { 'name': 'Saint Pierre and Miquelon', 'code': 'PM' }, { 'name': 'Saint Vincent and the Grenadines', 'code': 'VC' }, { 'name': 'Samoa', 'code': 'WS' }, { 'name': 'San Marino', 'code': 'SM' }, { 'name': 'Sao Tome and Principe', 'code': 'ST' }, { 'name': 'Saudi Arabia', 'code': 'SA' }, { 'name': 'Senegal', 'code': 'SN' }, { 'name': 'Serbia', 'code': 'RS' }, { 'name': 'Seychelles', 'code': 'SC' }, { 'name': 'Sierra Leone', 'code': 'SL' }, { 'name': 'Singapore', 'code': 'SG' }, { 'name': 'Slovakia', 'code': 'SK' }, { 'name': 'Slovenia', 'code': 'SI' }, { 'name': 'Solomon Islands', 'code': 'SB' }, { 'name': 'Somalia', 'code': 'SO' }, { 'name': 'South Africa', 'code': 'ZA' }, { 'name': 'South Georgia and the South Sandwich Islands', 'code': 'GS' }, { 'name': 'Spain', 'code': 'ES' }, { 'name': 'Sri Lanka', 'code': 'LK' }, { 'name': 'Sudan', 'code': 'SD' }, { 'name': 'Suriname', 'code': 'SR' }, { 'name': 'Svalbard and Jan Mayen', 'code': 'SJ' }, { 'name': 'Swaziland', 'code': 'SZ' }, { 'name': 'Sweden', 'code': 'SE' }, { 'name': 'Switzerland', 'code': 'CH' }, { 'name': 'Syrian Arab Republic', 'code': 'SY' }, { 'name': 'Taiwan, Province of China', 'code': 'TW' }, { 'name': 'Tajikistan', 'code': 'TJ' }, { 'name': 'Tanzania, United Republic of', 'code': 'TZ' }, { 'name': 'Thailand', 'code': 'TH' }, { 'name': 'Timor-Leste', 'code': 'TL' }, { 'name': 'Togo', 'code': 'TG' }, { 'name': 'Tokelau', 'code': 'TK' }, { 'name': 'Tonga', 'code': 'TO' }, { 'name': 'Trinidad and Tobago', 'code': 'TT' }, { 'name': 'Tunisia', 'code': 'TN' }, { 'name': 'Turkey', 'code': 'TR' }, { 'name': 'Turkmenistan', 'code': 'TM' }, { 'name': 'Turks and Caicos Islands', 'code': 'TC' }, { 'name': 'Tuvalu', 'code': 'TV' }, { 'name': 'Uganda', 'code': 'UG' }, { 'name': 'Ukraine', 'code': 'UA' }, { 'name': 'United Arab Emirates', 'code': 'AE' }, { 'name': 'United Kingdom', 'code': 'GB' }, { 'name': 'United States', 'code': 'US' }, { 'name': 'United States Minor Outlying Islands', 'code': 'UM' }, { 'name': 'Uruguay', 'code': 'UY' }, { 'name': 'Uzbekistan', 'code': 'UZ' }, { 'name': 'Vanuatu', 'code': 'VU' }, { 'name': 'Venezuela', 'code': 'VE' }, { 'name': 'Viet Nam', 'code': 'VN' }, { 'name': 'Virgin Islands, British', 'code': 'VG' }, { 'name': 'Virgin Islands, U.S.', 'code': 'VI' }, { 'name': 'Wallis and Futuna', 'code': 'WF' }, { 'name': 'Western Sahara', 'code': 'EH' }, { 'name': 'Yemen', 'code': 'YE' }, { 'name': 'Zambia', 'code': 'ZM' }, { 'name': 'Zimbabwe', 'code': 'ZW' }]);

/***/ }),

/***/ "Kf/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard pad-to-15"},[(_vm.showLocations)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control inline-auto white ",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterLocations]}},[_c('option',{attrs:{"value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_vm._l((_vm.locations),function(loc,key){return [_c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-to-15 all-cards"},_vm._l((_vm.statsCards),function(stats){return _c('div',{class:_vm.cardsClass},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('img',{attrs:{"src":("/static/img/icons/" + (stats.icon))}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n          "+_vm._s(stats.value)+"\n          "),(stats.canceled)?_c('small',[_vm._v("( "+_vm._s(stats.canceled)+" "+_vm._s(_vm.$t('ordersStatus.CANCELED'))+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "+_vm._s(stats.footerText)+"\n        ")])])],1)})),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.completed'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"salesChart",attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.salesChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.salesIn'))+" "+_vm._s(_vm.currency)+"\n          ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-6"},[_c('chart-bars-card',{ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.top5Chart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.salesIn'))+" "+_vm._s(_vm.currency)+"\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-bars-card',{ref:"deliveryChart",attrs:{"chart-data":_vm.deliveryChart.data,"chart-options":_vm.deliveryChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderingChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.nrOfOrders'))+"\n          ")])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KheQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);













var _components;








__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a), _components),
  props: {
    showLocations: {
      type: Boolean,
      required: true
    },
    callback: {
      required: true
    }
  },
  data: function data() {
    return {
      order: [],
      countries: __WEBPACK_IMPORTED_MODULE_15__Customers_countries__["a" /* default */],
      modelValidations: {
        required: {
          required: true
        }
      },
      orderStatuses: [],
      currentOrdersStatus: 'NEW',
      currecy: '',
      timeFormat: this.getTimeFormat(),
      loading: true,
      totals: ['totals_subtotals', 'totals_shipping', 'totals_tip', 'totals_discount', 'totals_discount_loyalty_points', 'totals_grandtotal']
    };
  },

  created: function created() {
    this.getData();
  },
  methods: {
    getRowClass: function getRowClass(label) {
      switch (label) {
        case 'totals_discount_loyalty_points':
        case 'totals_discount':
          return 'text-danger';
        case 'totals_grandtotal':
          return 'text-bold total-row';
        default:
          return '';
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    disabledCls: function disabledCls(isBefore) {
      if (isBefore) {
        return 'disabled';
      } else {
        return '';
      }
    },
    getPaymetnStatus: function getPaymetnStatus(status) {
      switch (status) {
        case 'OK':
          return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>';
        case 'NOT OK':
          return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>';
        default:
          return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</span>';
      }
    },
    getData: function getData() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var self = this;

      if (self.$route.params.id) {
        var id = self.$route.params.id;

        self.apiRequest('/order/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            response.data[0].formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime);
            self.order = response.data[0];
            for (var iParts in self.order.parts) {
              for (var iItem in self.order.parts[iParts].items) {
                var item = self.order.parts[iParts].items[iItem];
                var sumOptions = 0;
                if (item.options && item.options.length) {
                  sumOptions = item.options.map(function (item) {
                    return item.price;
                  }).reduce(function (prev, next) {
                    return prev + next;
                  });
                }
                self.order.parts[iParts].items[iItem].price_total_product = (parseFloat(item.price) + parseFloat(sumOptions)).toFixed(2);
              }
            }
            var statusesRaw = self.$session.get('defaultData')['order_statuses'];
            var isBefore = true;
            var isAllowed = true;
            self.orderStatuses = [];
            self.currentOrdersStatus = self.order.status.id;
            for (var ordType in statusesRaw) {
              for (var type in statusesRaw[ordType]) {
                if (ordType === self.order.delivery_type && type !== 'DRAFT') {
                  if (type === 'CANCELED' && self.order.payment_type === 'CARD' && self.order.capture_transaction_status === 'OK') {
                    isAllowed = false;
                  } else if (self.order.delivery_type === 'EAT_LOCATION') {
                    isAllowed = true;
                  } else {
                    isAllowed = self.orderStatusAllowed(self.order.status.id, type);
                  }
                  self.orderStatuses.push({
                    'type': type,
                    'text': statusesRaw[ordType][type],
                    'isBefore': isBefore,
                    'isAllowed': isAllowed
                  });
                  if (self.order.status.id === type) {
                    isBefore = false;
                  }
                }
              }
            }

            self.currency = response.data[0]['currency'];

            self.$nextTick(function () {
              self.loading = false;
            });
          }
        });
      }
    },
    heartbeat: function heartbeat(orderData) {
      var self = this;
      self.order.status = orderData.status;

      var statusesRaw = self.$session.get('defaultData')['order_statuses'];
      var isBefore = true;
      var isAllowed = true;

      self.orderStatuses = [];
      self.currentOrdersStatus = self.order.status.id;

      for (var ordType in statusesRaw) {
        for (var type in statusesRaw[ordType]) {
          if (ordType === self.order.delivery_type && type !== 'DRAFT') {
            isAllowed = self.orderStatusAllowed(self.order.status.id, type);
            self.orderStatuses.push({
              'type': type,
              'text': statusesRaw[ordType][type],
              'isBefore': isBefore,
              'isAllowed': isAllowed
            });
            if (self.order.status.id === type) {
              isBefore = false;
            }
          }
        }
      }
      this.$nextTick(function () {});
    },
    updateHour: function updateHour() {
      var id = this.$route.params.id;
      var self = this;
      if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
      } else {
        var newTime = __WEBPACK_IMPORTED_MODULE_14_moment___default()(String(this.order.pickup_datetime)).format('YYYY-MM-DD');
        newTime = __WEBPACK_IMPORTED_MODULE_14_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss');
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          pickup_datetime: newTime
        };

        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', self.$t('orders.orderHourSuccess'), 'success');
          } else {
            __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
          }
        });
      }
    },
    saveComment: function saveComment() {
      var id = this.$route.params.id;
      var data = {
        id: id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        backoffice_comments: this.order.backoffice_comments
      };
      var self = this;
      this.apiRequest('/order/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', self.$t('orders.orderCommnetSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        }
      });
    },
    updateStatus: function updateStatus(status, label, disabled) {
      var _this = this;

      var revertOnCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (disabled) {
        return false;
      }
      var self = this;
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: self.$t('validations.areYouSure') + label,
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          var id = _this.$route.params.id;
          var data = {
            id: id,
            token: _this.$session.get('token'),
            company_id: _this.$session.get('selectedCompany'),
            status: status
          };
          _this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.$session.set('refreshOrdersCount', 'refresh');
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', self.$t('orders.orderStatusSuccess'), 'success');
              self.getData();
              self.callback(id, { 'id': status, 'type': label });
            } else {
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
              if (revertOnCancel) {
                self.currentOrdersStatus = self.order.status.id;
              }
            }
          });
        }
      }).catch(function () {
        if (revertOnCancel) {
          self.currentOrdersStatus = self.order.status.id;
        }
      });
    },
    changeStatus: function changeStatus() {
      var status = this.currentOrdersStatus;
      var label = this.$t('ordersStatus.' + this.currentOrdersStatus);
      this.updateStatus(status, label, false, true);
    }
  }
});

/***/ }),

/***/ "Klnn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ko2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L07y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"mode":"vertical","default-active":"1"}},[_c('el-menu-item-group',{attrs:{"title":"Group One"}},[_c('el-menu-item',{attrs:{"index":"1"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator One")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"2"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Two")])],1),_vm._v(" "),_c('el-menu-item-group',{attrs:{"title":"Group Two"}},[_c('el-menu-item',{attrs:{"index":"3"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Three")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"4"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Four")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L7GT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LL4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LPdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__ = __webpack_require__("JB9I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fcd066c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__ = __webpack_require__("flK0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fcd066c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lh50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row orders"},[_c('div',{staticClass:"col-lg-3 col-md-4 col-xs-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"fixed",style:({height: _vm.windowHeight - _vm.pageTopHeight + 'px'})},[_c('div',{ref:"tableTop",staticClass:"table-top"},[_c('el-row',[_c('el-col',[_c('el-input',{staticClass:"sm-search icon-search",attrs:{"placeholder":_vm.$t('general.search')},on:{"input":_vm.search},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('el-dropdown',{staticClass:"dropdown-sm",attrs:{"type":"default","hide-on-click":false}},[_c('el-button',{staticClass:"filter-btn",attrs:{"type":"default"}},[_c('img',{attrs:{"src":"/static/img/icons/filter.png"}})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_vm._v("\n                    "+_vm._s(_vm.$t('orders.status'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',[_c('el-checkbox-group',{model:{value:(_vm.requestFilters[0].value),callback:function ($$v) {_vm.$set(_vm.requestFilters[0], "value", $$v)},expression:"requestFilters[0].value"}},[_vm._l((_vm.statuses),function(sts,key){return [(key !== 'DRAFT')?[_c('el-checkbox',{key:key,attrs:{"label":key,"value":key}},[_vm._v(" "+_vm._s(_vm.$t('ordersStatus.' + key))+"\n                          ")]),_vm._v(" "),_c('br')]:_vm._e()]})],2)],1),_vm._v(" "),(_vm.showLocations)?[_c('el-dropdown-item',{attrs:{"divided":""}},[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-dropdown-item',[_c('el-checkbox-group',{on:{"input":_vm.updateCookie},model:{value:(_vm.locationFilter),callback:function ($$v) {_vm.locationFilter=$$v},expression:"locationFilter"}},[_vm._l((_vm.locations),function(loc,key){return [_c('el-checkbox',{key:loc.id,attrs:{"label":loc.id,"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n                          ")]),_vm._v(" "),_c('br')]})],2)],1)]:_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"pad-to-10 text-bold"},[(_vm.customFilter)?[_vm._v("\n                  "+_vm._s(_vm.$t('orders.customFilters'))+" - "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:_vm._e(),_vm._v(" "),(!_vm.customFilter)?[_vm._v("\n                  "+_vm._s(_vm.$t('orders.filtersApplied'))+"\n                ")]:_vm._e()],2)],1)],1)],1),_vm._v(" "),_c('div',{ref:"tableContainerRef",staticClass:"table-container",style:({height: _vm.windowHeight - _vm.tableTopHeight - _vm.tableBottomHeight - _vm.pageTopHeight + 'px'})},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"detailsScrollTable",staticStyle:{"width":"100%","background":"#fff"},attrs:{"data":_vm.tableData,"current-page":1,"page-size":_vm.paginationDef.pageSize,"filters":_vm.filters,"table-props":{'row-class-name': _vm.rowClass, 'border': false, 'stripe': false,}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":100,"prop":"price","label":"Total Amount"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{domProps:{"innerHTML":_vm._s(props.row.customer_display)}}),_vm._v(" "),(_vm.showLocations)?_c('div',{staticClass:"location-info"},[_vm._v(_vm._s(props.row.production_details ? props.row.production_details.location.name : ''))]):_vm._e(),_vm._v(" "),_c('div',[_c('b',[_vm._v(_vm._s(props.row.totals_grandtotal)+" "+_vm._s(_vm.getCurrencySymbol(props.row.currency)))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"status","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"xxs-font mar-bt-40"},[_vm._v(_vm._s(_vm.$t('orders.the_order'))+" @ "+_vm._s(_vm.formatDateTime(props.row.created_at)))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(props.row.delivery_type ? _vm.$t('deliveryTypes.' + props.row.delivery_type) : '')+"\n                  "),(props.row.delivery_type !== 'EAT_LOCATION')?[_vm._v("\n                    "+_vm._s(_vm.$t('orders.at'))+" "+_vm._s(_vm._f("formatTime")(props.row.pickup_datetime))+"\n                  ")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"label",class:'label-' + _vm.orderStatusClass(props.row.status.id)},[_vm._v(_vm._s(props.row.status.type))])]}}])})],1)],1),_vm._v(" "),_c('div',{ref:"tableBottom",staticClass:"orders-table-bottom table-bottom"},[_vm._v("\n          "+_vm._s(_vm.$t('general.showing', {length: _vm.tableData.length}))+"\n          "),(_vm.showLoadMore)?_c('a',{staticClass:"btn btn-info btn-fill",on:{"click":function($event){$event.preventDefault();_vm.loadMore()}}},[_vm._v(_vm._s(_vm.$t('general.loadMore')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{ref:"detailsScroll",staticClass:"col-lg-9 col-md-8 col-xs-8 detailsScroll",style:({height: _vm.windowHeight - _vm.pageTopHeight + 'px'})},[(_vm.showForm())?_c('order-form',{ref:"orderForm",attrs:{"showLocations":_vm.showLocations,"callback":_vm.updateList}}):_vm._e(),_vm._v(" "),(!_vm.showForm())?_c('div',{staticClass:"no-element"},[_c('i',{staticClass:"shopping-cart"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('orders.noOrders')))])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b410f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("V4VE");
function injectStyle (ssrContext) {
  __webpack_require__("HqqK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b410f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MK8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'customer_id': 1,
  'first_name': 'Anca',
  'last_name': 'Breje',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'phone': '+40 777 333 444',
  'active': true,
  'gender': 'Female',
  'birth_day': '1993-06-01',
  'formatted_address': 'Zorelelor 12, Oradea, Bihor, RO',
  'push_notifications': true,
  'address': [{
    'address_id': 55,
    'type': 'billing',
    'street': 'Zorelelor 12',
    'city': 'Oradea',
    'state': 'Bihor',
    'country': 'RO'
  }, {
    'address_id': 56,
    'type': 'shipping',
    'street': 'Zorelelor 12',
    'city': 'Oradea',
    'state': 'Bihor',
    'country': 'RO'
  }]
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a78b4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("BmUp");
function injectStyle (ssrContext) {
  __webpack_require__("6d4a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a78b4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'tapTasty'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/logo-sm.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    var _this = this;

    this.minimizeSidebar();
    this.$nextTick(function () {
      _this.startPlaySound();
    });
  },
  data: function data() {
    return {
      children: [],
      collapsed: true,
      heartbeatSet: false,
      newOrdersCount: 0,
      processingOrdersCount: 0,
      audioFile: null,
      audioPlayed: true
    };
  },

  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this2.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },

    heartbeat: function heartbeat() {
      var _this3 = this;

      var self = this;

      setInterval(function () {
        if (_this3.$session.get('refreshOrdersCount') === 'refresh') {
          _this3.$session.set('refreshOrdersCount', '');
          self.getCounter();
        }
      }, 1000 * 2);

      setInterval(function () {
        self.getCounter();
      }, 1000 * 15);

      this.loadSound();
      if ((self.newOrdersCount > 0 || self.processingOrdersCount > 0) && this.$session.exists()) {
        self.playSound();
      }

      setInterval(function () {
        _this3.loadSound();
        if ((self.newOrdersCount > 0 || self.processingOrdersCount > 0) && _this3.$session.exists()) {
          self.playSound();
        }
      }, 1000 * 3);
    },
    loadSound: function loadSound() {
      console.warn('audio load');
      var sound = document.querySelector('audio');
      if (sound) {
        sound.volume = 0;
      }
    },
    playSound: function playSound() {
      console.warn('audio play');
      var sound = document.querySelector('audio');
      if (sound) {
        sound.volume = 1;
        sound.play();
      }
    },
    startPlaySound: function startPlaySound() {
      var sound = document.querySelector('audio');
      sound.volume = 1;
    },
    getCounter: function getCounter() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        status: 'NEW',
        seen: 0
      };
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        data.location_ids = filterCookie.join(',');
      }
      var self = this;
      this.apiRequest('/counters', 'GET', data, function (response) {
        var newFeedback = false;
        var newOrders = false;
        var processingOrders = false;
        if (response.status === true) {
          if (response.data['orders'] > 0) {
            newOrders = true;
            self.newOrdersCount = response.data['orders'];
          } else {
            self.newOrdersCount = 0;
          }
          self.$session.set('newOrders', newOrders);

          if (response.data['orders_processing'] > 0) {
            processingOrders = true;
            self.processingOrdersCount = response.data['orders_processing'];
          } else {
            self.processingOrdersCount = 0;
          }
          self.$session.set('processingOrders', processingOrders);

          if (response.data['feedbacks'] > 0) {
            newFeedback = true;
          }
          self.$session.set('newFeedback', true);
        }
        if (self.$refs.newFeedback[0] !== undefined) {
          if (newFeedback) {
            self.$refs.newFeedback[0].$el.classList.add('alert-menu');
          } else {
            self.$refs.newFeedback[0].$el.classList.remove('alert-menu');
          }
        }
        if (self.$refs.newOrders[0] !== undefined) {
          if (newOrders || processingOrders) {
            self.$refs.newOrders[0].$el.classList.add('alert-menu');
          } else {
            self.$refs.newOrders[0].$el.classList.remove('alert-menu');
          }
        }
      });
    },
    goToOrders: function goToOrders(status) {
      this.$session.set('temp-status', status);
      this.$nextTick(function () {
        console.warn(this.$router);
        this.$router.replace('/orders');
      });
    }
  },
  mounted: function mounted() {
    if (!this.heartbeatSet) {
      this.getCounter();
      this.heartbeat();
      this.heartbeatSet = true;
    }

    this.initScrollBarAsync();
    var newFeedback = this.$session.get('newFeedback');
    if (this.$refs.newFeedback[0] !== undefined) {
      if (newFeedback) {
        this.$refs.newFeedback[0].$el.classList.add('alert-menu');
      }
    }
    var newOrders = this.$session.get('newOrders');
    if (this.$refs.newOrders[0] !== undefined) {
      if (newOrders) {
        this.$refs.newOrders[0].$el.classList.add('alert-menu');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "Mily":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-options"},[_c('div',{ref:"optionsTopBar",staticClass:"options-top-bar "},[_c('h6',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.$t('catalogProd.single'))+" "+_vm._s(_vm.$t('catalogProdOpt.plural')))]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-fill btn-success btn",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])])]),_vm._v(" "),_c('div',{ref:"optionsContainer",staticClass:"options-content",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix "},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]),_vm._v(" "),_c('table',{staticClass:"table align-top"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"50px"}}),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.values'))+" - "+_vm._s(_vm.$t('catalogProdOpt.posid')))]),_vm._v(" "),_c('th',{attrs:{"width":"60px"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.products_options),function(option,key){return _c('tr',[_c('td',[_c('button',{staticClass:"btn btn-icon btn-danger",attrs:{"title":_vm.$t('general.remove') + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.deleteOption(option.id)}}},[_c('i',{staticClass:"ti-trash"})])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.name),expression:"option.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.name')},domProps:{"value":(option.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "name", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.optionTypes),function(opt,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(opt))])}))]),_vm._v(" "),_c('td',[_vm._l((option.values),function(val,key){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.label),expression:"val.label"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":""},domProps:{"value":(val.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "label", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.pos_id),expression:"val.pos_id"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.posid')},domProps:{"value":(val.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "pos_id", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(option.id, val.id)}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}})]),_vm._v(" "),_c('br')]}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.addNewValue(option.id)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value')))])],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.duplicate') + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.duplicateOption(option.id)}}},[_c('i',{staticClass:"ti-files"})])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('button',{staticClass:"btn btn-icon btn-info",on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single')))])])])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NE6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Steps_FirstStep_vue__ = __webpack_require__("6X+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Steps_SecondStep_vue__ = __webpack_require__("GK6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Steps_ThirdStep_vue__ = __webpack_require__("vTqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Steps_ForthStep_vue__ = __webpack_require__("c3/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_moment__);



















var _components;















__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'FormWizard', __WEBPACK_IMPORTED_MODULE_20_vue_form_wizard__["FormWizard"]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'TabContent', __WEBPACK_IMPORTED_MODULE_20_vue_form_wizard__["TabContent"]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'FirstStep', __WEBPACK_IMPORTED_MODULE_24__Steps_FirstStep_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'SecondStep', __WEBPACK_IMPORTED_MODULE_25__Steps_SecondStep_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'ThirdStep', __WEBPACK_IMPORTED_MODULE_26__Steps_ThirdStep_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'ForthStep', __WEBPACK_IMPORTED_MODULE_27__Steps_ForthStep_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vee_validate__["b" /* mapFields */])(['name', 'price', 'active', 'date_from'])),
  data: function data() {
    return {
      days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
      countries: __WEBPACK_IMPORTED_MODULE_28__Customers_countries__["a" /* default */],
      model: [],
      coupons: [],
      groupedProducts: [],
      customerList: 0,
      modelValidations: {
        name: {
          required: true,
          min: 4
        },
        active: {
          required: true
        },
        price: {
          required: true
        },
        status: {
          required: true
        },
        date_from: {},
        coupon_code: {
          required: true,
          min: 4
        },
        coupon_option: {}
      },
      wizardModel: {}
    };
  },

  created: function created() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var notifTimes = [];
      var dayData = [];
      for (var day in this.days) {
        var dayDataIdx = this.getObjectByElemKeyValue('day', this.days[day], notifTimes);
        if (dayDataIdx !== undefined && notifTimes[dayDataIdx] !== undefined) {
          notifTimes[dayDataIdx]['checked'] = true;
          dayData.push(notifTimes[dayDataIdx]);
        } else {
          dayData.push({ day: this.days[day], hour_to: '', hour_from: '', checked: false });
        }
      }
      var notifTypesArray = [];
      for (var type in this.campaignsNotificationTypes) {
        notifTypesArray[type] = false;
      }
      this.model = {
        notification_times_array: dayData,
        notification_types_array: notifTypesArray,
        user_filters: {
          age: '',
          gender: '',
          orders_above: '',
          location_id: '',
          counter_matching_users: 0
        },
        imagelist: [],
        coupons: {},
        type: 'TEXT'
      };
      this.coupons = {
        type: 'PERCENTAGE',
        usage_type: null,
        discount: null,
        coupon_code: null
      };
      var self = this;
      if (this.$route.params.id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        var id = self.$route.params.id;
        self.apiRequest('/campaign/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            data['campaign_id'] = id;
            self.apiRequest('/coupon', 'GET', data, function (response2) {
              if (response2.data[0] == null) {
                response2.data[0] = {
                  type: '',
                  usage_type: '',
                  discount: '',
                  coupon_code: ''
                };
              }
              self.coupons = response2.data[0];
            });

            if (response.data[0].datetime_validfrom && response.data[0].datetime_validto) {
              response.data[0].fromto = [response.data[0].datetime_validfrom, response.data[0].datetime_validto];
            }

            if (response.data[0]['image_url']) {
              response.data[0]['imagelist'] = response.data[0]['image_url'];
            } else {
              response.data[0]['imagelist'] = [];
            }

            var notifTimes = response.data[0]['notification_times'];
            var dayData = [];
            for (var day in self.days) {
              var checked = false;
              var hourTo = '';
              var hourFrom = '';
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(notifTimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var nTime = _step.value;

                  if (nTime.day === self.days[day]) {
                    checked = true;
                    hourTo = nTime.hour_to;
                    hourFrom = nTime.hour_from;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              dayData.push({ day: self.days[day], hour_to: hourTo, hour_from: hourFrom, checked: checked });
            }
            response.data[0]['notification_times_array'] = dayData;
            var notifTypesArray = [];
            var notifTypes = response.data[0]['notification_type'];
            for (var type in self.campaignsNotificationTypes) {
              notifTypesArray.push({ type: false });
              if (notifTypes !== null) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(notifTypes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var nType = _step2.value;

                    if (nType.type === type) {
                      notifTypesArray[type] = true;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            }
            response.data[0]['notification_types_array'] = notifTypesArray;

            self.model = response.data[0];
          }
        });
      }
      var data2 = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        grouped: 1
      };
      this.apiRequest('/product', 'GET', data2, function (response) {
        if (response.status === true) {
          self.groupedProducts = response.data;
          self.loaded = true;
        }
      });
    },
    isEdit: function isEdit() {
      if (this.$route.params.id) {
        return true;
      } else {
        return false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      this.$validator.validateAll().then(function (isValid) {});
    },
    validateFirstStep: function validateFirstStep() {
      this.model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model);
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      this.model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.secondStep.model);
      return this.$refs.secondStep.validate();
    },
    validateThirdStep: function validateThirdStep() {
      var ret = this.$refs.thirdStep.validate();
      this.model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.thirdStep.model);
      return ret;
    },
    validateForthStep: function validateForthStep() {
      this.model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.forthStep.model);
      return this.$refs.forthStep.validate();
    },
    handleRemoveImage: function handleRemoveImage(file, fileList) {},
    filterCustomers: function filterCustomers() {
      this.customerList = 30;
    },
    resetTable: function resetTable() {
      this.customerList = 0;
    },
    saveCoupons: function saveCoupons(id, goToEdit, msg) {
      var self = this;

      this.coupons = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.forthStep.coupons);
      var treeData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$refs.forthStep.treeData);

      var data = this.copyObject(this.coupons);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.campaign_id = id;

      var categs = [];
      var prods = [];
      for (var idx in treeData) {
        if (treeData[idx]['checked'] !== undefined && treeData[idx]['checked'] === true && (treeData[idx]['halfcheck'] === false || treeData[idx]['halfcheck'] === undefined)) {
          categs.push(treeData[idx]['id']);
        } else {
          for (var idxChild in treeData[idx]['children']) {
            if (treeData[idx]['children'][idxChild] && treeData[idx]['children'][idxChild]['checked'] === true) {
              prods.push(treeData[idx]['children'][idxChild]['id']);
            }
          }
        }
      }
      data['usage_for_products'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(prods);
      data['usage_for_categories'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(categs);

      if (this.coupons.id !== null && this.coupons.id !== undefined && this.coupons.id !== '') {
        if (this.model.type === 'TEXT') {
          var data2 = [];
          data2.token = this.$session.get('token');
          this.apiRequest('/coupon/' + this.coupons.id, 'DELETE', data2, function (response2) {
            if (response2.status === true) {
              __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
                title: '',
                text: msg,
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              });
            } else {}
          });
        } else {
          delete data.deleted_at;
          delete data.created_at;
          delete data.updated_at;
          delete data.created_by;
          delete data.deleted_at;
          delete data.deleted_by;
          delete data.updated_by;
          delete data.campaign;
          this.apiRequest('/coupon/' + this.coupons.id, 'PUT', data, function (response2) {
            if (response2.status === true) {
              __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
                title: '',
                text: msg,
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              });
            } else {}
          });
        }
      } else if (this.model.type === 'COUPON') {
        this.apiRequest('/coupon', 'POST', data, function (response2) {
          if (response2.status === true) {
            __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
              title: '',
              text: msg,
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {}
        });
      }

      __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
        title: '',
        text: msg,
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      });
      if (goToEdit) {
        self.$router.push('/marketing/campaigns');
      }
    },
    wizardComplete: function wizardComplete() {

      var self = this;
      var data = this.copyObject(this.model);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.datetime_validfrom = __WEBPACK_IMPORTED_MODULE_29_moment___default()(this.model.fromto[0], __WEBPACK_IMPORTED_MODULE_29_moment___default.a.ISO_8601).format();
        data.datetime_validfrom = data.datetime_validfrom.slice(0, data.datetime_validfrom.indexOf('+'));
        data.datetime_validfrom = data.datetime_validfrom.replace('T', ' ');
        data.datetime_validto = __WEBPACK_IMPORTED_MODULE_29_moment___default()(this.model.fromto[1], __WEBPACK_IMPORTED_MODULE_29_moment___default.a.ISO_8601).format();
        data.datetime_validto = data.datetime_validto.slice(0, data.datetime_validto.indexOf('+'));
        data.datetime_validto = data.datetime_validto.replace('T', ' ');
      } else {
        data.datetime_validfrom = null;
        data.datetime_validto = null;
      }

      var notificationTimes = [];
      for (var timeKey in data.notification_times_array) {
        if (data.notification_times_array[timeKey].checked === true) {
          notificationTimes.push({ day: data.notification_times_array[timeKey].day, hour_to: '', hour_from: data.notification_times_array[timeKey].hour_from });
        }
      }

      var notificationTypes = [];
      for (var type in data.notification_types_array) {
        if (data.notification_types_array[type] === true) {
          notificationTypes.push({ 'type': type });
        }
      }

      data.user_filters.counter_matching_users = data.counter_matching_users;

      if (data.description === {}) {
        data.description = '';
      }

      delete data.notification_times_array;
      delete data.notification_types_array;
      delete data.notification_times;
      delete data.notification_type;
      delete data.fromto;
      delete data.image_url;
      delete data.deleted_at;
      delete data.created_at;
      delete data.updated_at;
      delete data.created_by;
      delete data.deleted_at;
      delete data.deleted_by;
      delete data.updated_by;
      delete data.counter_matching_users;
      data.notification_times = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(notificationTimes);
      data.user_filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.user_filters);
      data.notification_type = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(notificationTypes);

      if (!this.$route.params.id) {
        this.apiRequest('/campaign', 'POST', data, function (response) {
          if (response.status === true) {
            var id = response.data[0].id;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.imagelist).length && data.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.name = data.name;
                data2.type = data.type;
                data2.mode = data.mode;
                data2.notification_type = data.notification_type;
                data2.image = base64enc;
                self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignAdded'));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingCampaigns.campaignPhotoError'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }
                });
              });
            } else {
              self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignAdded'));
            }
          }
        });
      } else {
        var id = this.$route.params.id;

        if (data.imagelist === 0) {
          data.image_url = '';
        }
        this.apiRequest('/campaign/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.imagelist).length && data.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                data2.name = data.name;
                data2.type = data.type;
                data2.mode = data.mode;
                data2.notification_type = data.notification_type;
                self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignUpdated'));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingCampaigns.campaignPhotoError'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }
                });
              });
            } else {
              self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignUpdated'));
              self.$router.push('/marketing/campaigns');
            }
          } else {}
        });
      }
    },
    addNewCoupon: function addNewCoupon() {
      var newRow = [];
      newRow.id = 'new_' + Math.random();
      if (this.model.coupons === undefined) {
        this.model.coupons = [];
      }
      this.model.coupons.push(newRow);
    },
    deleteCoupon: function deleteCoupon(id) {}
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_session__ = __webpack_require__("18Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_mixins_Inmobito__ = __webpack_require__("m0L1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_wysiwyg__ = __webpack_require__("V2hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_wysiwyg__);





































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_22__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9_axios___default.a);
__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_vue_wysiwyg___default.a, {
  hideModules: { 'image': true, 'code': true, 'table': true },
  maxHeight: '500px'
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_session___default.a, { persist: 1 });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.mixin(__WEBPACK_IMPORTED_MODULE_17_src_mixins_Inmobito__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en',
  fallbackLocale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_24__lang_lang__["a" /* default */] });

__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return i18n.t(key, value);
});

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  i18n: i18n,
  routes: __WEBPACK_IMPORTED_MODULE_16__routes_routes__["a" /* default */],
  linkActiveClass: 'active'
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_23_moment___default()(String(value)).format('DD/MM/YYYY');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_23_moment___default()(String(value)).format('DD/MM/YYYY H:mm');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_23_moment___default()(String(value)).format('H:mm');
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App_vue__["a" /* default */]);
  },
  i18n: i18n,
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_18__store_index__["a" /* default */]
});

/***/ }),

/***/ "NkIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total customers "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total app downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NyKN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O5Cj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O6iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OFEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips__ = __webpack_require__("iWxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e477f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("pcxg");
function injectStyle (ssrContext) {
  __webpack_require__("PFLc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e477f56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OzXD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PD+C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PFLc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PiIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(_vm.isEdit)?_c('div',{staticClass:"col-md-12"}):_vm._e()]),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1"},[_c('div',{staticClass:"card card-wizard marketing-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"square","step-size":"xs","error-color":"#EB5E28","color":"#5e35b1"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"before-change":_vm.validateFirstStep,"title":"Campaign Details"}},[_c('first-step',{ref:"firstStep",attrs:{"modelFromParent":_vm.model}})],1),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateSecondStep,"title":"Notifications"}},[_c('second-step',{ref:"secondStep",attrs:{"modelFromParent":_vm.model,"daysParent":_vm.days}})],1),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateThirdStep,"title":"Target"}},[_c('third-step',{ref:"thirdStep",attrs:{"modelFromParent":_vm.model,"daysParent":_vm.days}})],1),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateForthStep,"title":"Target"}},[_c('forth-step',{ref:"forthStep",attrs:{"modelFromParent":_vm.model,"daysParent":_vm.days,"couponsParent":_vm.coupons,"groupedProductsParent":_vm.groupedProducts}})],1),_vm._v(" "),_c('h2',{attrs:{"slot":"title"},slot:"title"}),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v(_vm._s(_vm.$t('general.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v(_vm._s(_vm.$t('general.next')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v(_vm._s(_vm.$t('general.finish')))])],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q9x8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__ = __webpack_require__("tLlR");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignForm', __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      campaignModel: {},
      campaign: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model, isValid) {
      this.campaignModel = model;
    }
  }
});

/***/ }),

/***/ "QJOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);









var _components;






__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), _components),
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      loading: true,
      customer: [],
      newPoints: {
        money_spent: null,
        comments: null
      },
      countries: __WEBPACK_IMPORTED_MODULE_9__countries__["a" /* default */],
      currency: '',
      modelValidations: {
        required: {
          required: true
        }
      },
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      }
    };
  },

  methods: {
    getData: function getData() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var currency = this.getCompanyDetail('currency');
      this.currency = this.getCurrencySymbol(currency);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var self = this;

      if (self.$route.params.id) {
        var id = self.$route.params.id;
        self.apiRequest('/customer/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            var goodOrders = [];
            for (var idx in response.data[0].orders) {
              if (response.data[0].orders[idx]['status'].id !== 'DRAFT') {
                goodOrders.push(response.data[0].orders[idx]);
              }
            }
            response.data[0].orders = goodOrders;
            self.customer = response.data[0];

            self.$nextTick(function () {
              self.loading = false;
            });
          }
        });
      }
    },
    addPoints: function addPoints() {
      var self = this;
      if (!this.newPoints.money_spent || !this.newPoints.comments) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.validPoinsNo'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        var id = this.$route.params.id;
        var data = {
          user_id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          money_spent: this.newPoints.money_spent,
          comments: this.newPoints.comments,
          money_spent_confirm: 1
        };
        this.apiRequest('/loyalty-points', 'POST', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response.data.message, 'success');
            self.customer.loyalty_points = parseInt(response.data.loyalty_points);
            self.newPoints.money_spent = null;
            self.newPoints.comments = null;
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'), 'error');
          }
        });
      }
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/orders/view/');
    }
  }
});

/***/ }),

/***/ "R+jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersAdd_vue__ = __webpack_require__("kbwa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e22870e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersAdd_vue__ = __webpack_require__("U78x");
function injectStyle (ssrContext) {
  __webpack_require__("yCkF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e22870e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R45N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-12 "},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":"Search"},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn btn-info ",attrs:{"title":"Add Campaign","to":{ path: '/marketing/campaigns/add'}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('marketingCampaigns.single')))])],1)]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":_vm.defaultSearchDef(),"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false},"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":40,"label":_vm.$t('marketingCampaigns.image')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('img',{attrs:{"src":(props.row.image_url)?props.row.image_url[0].url : ''}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"name","label":_vm.$t('marketingCampaigns.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"","prop":"valid","label":_vm.$t('marketingCampaigns.startEnd')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.datetime_validfrom))+" - "+_vm._s(_vm.formatDate(props.row.datetime_validto))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"name","label":_vm.$t('marketingCampaigns.daysLeft')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.getDaysLeft(props.row.datetime_validto))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingCampaigns.status'),"prop":"active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.$index, props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-button',{on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_vm._v("\n                "+_vm._s(_vm.$t('general.delete'))+"\n             ")]),_vm._v(" "),(props.row.active && props.row.mode == 'MANUAL')?_c('el-button',{on:{"click":function($event){_vm.sendNotif(props.$index, props.row)}}},[_vm._v("\n                "+_vm._s(_vm.$t('marketingCampaigns.send'))+"\n             ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":45},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"fa fa-pencil"})]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62498074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("Y1ls");
function injectStyle (ssrContext) {
  __webpack_require__("kpnw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62498074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RE7N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RLX6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RX1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__ = __webpack_require__("tLlR");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignForm', __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      campaignModel: {},
      campaign: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model, isValid) {
      this.campaignModel = model;
    }
  }
});

/***/ }),

/***/ "RYO5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramForm_vue__ = __webpack_require__("gK/d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7d1cf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramForm_vue__ = __webpack_require__("xIL6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7d1cf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RkrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RqR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RzYN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3AV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[(_vm.companyAvatar)?_c('div',{staticClass:"photo",style:('background-image: url(' + _vm.companyAvatar + ')')}):_c('div',{staticClass:"photo"}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToSettings($event)}}},[_c('span',[_vm._v("\n            "+_vm._s(_vm.companyName)+"\n         ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SEsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('h4',{staticClass:"purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.campaignDetails')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('marketingCampaigns.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.name)?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('name'))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.description'))+" "),_c('small',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.maxDescription')))])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"}],staticClass:"form-control",attrs:{"name":"description","rows":"6","placeholder":_vm.$t('marketingCampaigns.description')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),_c('div',[_c('small',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.model.description ? _vm.model.description.length : '0')+" "+_vm._s(_vm.$t('marketingCampaigns.characters')))])]),_vm._v(" "),(_vm.errors.description)?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('description'))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.validFromTo')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.date_from)?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('date_from'))+"\n        ")]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SkgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelFromParent: {
      type: [Object, Array],
      required: true
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.model = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['name'])),
  data: function data() {
    return {
      date: {
        trends: {
          'valid': ['2018-01-01', '2018-12-31']
        }
      },
      model: this.value || this.modelFromParent,
      modelValidations: {
        name: {
          required: true
        },
        description: {
          max: 255
        }
      },
      couponType: this.$session.get('defaultData')['coupons_types'],
      couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
      pickerOptions1: {},
      pickerNames: ['date_from', 'date_to'],
      desclength: 0
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log('handleRemove');
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        text: this.$t('validations.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    }
  }
});

/***/ }),

/***/ "SvXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("Y09D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5afbd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("ZK0X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5afbd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sw0U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__ = __webpack_require__("BEel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_OrderingManagement_OrderingManagement_vue__ = __webpack_require__("pznp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Customers_Customers_vue__ = __webpack_require__("5EKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Customers_CustomerView_vue__ = __webpack_require__("viQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_InfoPages_InfoPages_vue__ = __webpack_require__("TUUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Orders_Orders_vue__ = __webpack_require__("ec2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Orders_OrderEdit_vue__ = __webpack_require__("Aa8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Products_Products_vue__ = __webpack_require__("t1Mv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Settings_Tabs_ProductOptions_vue__ = __webpack_require__("soYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Categories_Categories_vue__ = __webpack_require__("pUJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Categories_CategoryAdd_vue__ = __webpack_require__("B2tR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Categories_CategoryEdit_vue__ = __webpack_require__("IZUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__ = __webpack_require__("f9hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Marketing_Campaigns_CampaignAdd_vue__ = __webpack_require__("bQaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Marketing_Campaigns_CampaignEdit_vue__ = __webpack_require__("Yvs9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__ = __webpack_require__("duJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Marketing_Offers_OffersEdit_vue__ = __webpack_require__("dRcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Marketing_Offers_OffersAdd_vue__ = __webpack_require__("R+jw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_RewardProgram_RewardProgramEdit_vue__ = __webpack_require__("zijR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Reports_Reports_vue__ = __webpack_require__("uVnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Reports_ReportsCustomerDetails_vue__ = __webpack_require__("+wRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Settings_Settings_vue__ = __webpack_require__("xXCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Settings_Users_Users_vue__ = __webpack_require__("SvXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Settings_Users_UserAdd_vue__ = __webpack_require__("5Anz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Settings_Users_UserEdit_vue__ = __webpack_require__("8aRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Settings_Feedback_Feedback_vue__ = __webpack_require__("1s1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Settings_Feedback_FeedbackView_vue__ = __webpack_require__("btJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Pages_Recover_vue__ = __webpack_require__("wiU7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Pages_Reset_vue__ = __webpack_require__("lX1G");




















































var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
};

var registerPage = {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Pages_Register_vue__["a" /* default */]
};

var recoverPage = {
  path: '/recover',
  name: 'Recover Password',
  component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Pages_Recover_vue__["a" /* default */]
};

var resetPage = {
  path: '/reset',
  name: 'Reset Password',
  component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Pages_Reset_vue__["a" /* default */]
};

var orderingMenu = {
  path: '/ordering-management',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Ordering Management',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_OrderingManagement_OrderingManagement_vue__["a" /* default */]
  }, {
    path: 'view',
    name: 'Customer Details',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Customers_CustomerView_vue__["a" /* default */]
  }]
};

var customersMenu = {
  path: '/customers',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Customers',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Customers_Customers_vue__["a" /* default */]
  }, {
    path: 'view/:id',
    name: 'Customer Details',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Customers_Customers_vue__["a" /* default */]
  }]
};

var InfoPage = {
  path: '/info-pages',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Info Pages',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_InfoPages_InfoPages_vue__["a" /* default */]
  }]
};

var ordersMenu = {
  path: '/orders',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Orders',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Orders_Orders_vue__["a" /* default */],
    session: 'newOrders'
  }, {
    path: 'view/:id',
    name: 'Order Details',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Orders_Orders_vue__["a" /* default */]
  }, {
    path: 'edit/:id',
    name: 'Edit Order',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Orders_OrderEdit_vue__["a" /* default */]
  }]
};

var productsMenu = {
  path: '/products',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/products',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Products_Products_vue__["a" /* default */]
  }, {
    path: '/products/add',
    name: 'Add Product',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Products_Products_vue__["a" /* default */]
  }, {
    path: '/products/edit/:id',
    name: 'Edit Product',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Products_Products_vue__["a" /* default */]
  }]
};

var prodOptionsMenu = {
  path: '/product-options',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/product-options',
    name: 'Product Options',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Settings_Tabs_ProductOptions_vue__["a" /* default */]
  }]
};

var categoriesMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/categories',
    name: 'Categories',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Categories_Categories_vue__["a" /* default */]
  }, {
    path: '/categories/add',
    name: 'Add Category',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Categories_CategoryAdd_vue__["a" /* default */]
  }, {
    path: '/categories/edit/:id',
    name: 'Edit Category',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Categories_CategoryEdit_vue__["a" /* default */]
  }]
};

var marketingMenu = {
  path: '/marketing',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'campaigns',
    name: 'Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__["a" /* default */]
  }, {
    path: 'campaigns/add',
    name: 'Add Campaign',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Marketing_Campaigns_CampaignAdd_vue__["a" /* default */]
  }, {
    path: 'campaigns/edit/:id',
    name: 'Edit Campaign',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Marketing_Campaigns_CampaignEdit_vue__["a" /* default */]
  }, {
    path: 'offers',
    name: 'Offers Slider',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__["a" /* default */]
  }, {
    path: 'offers/add',
    name: 'Add Offer Slider',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Marketing_Offers_OffersAdd_vue__["a" /* default */]
  }, {
    path: 'offers/edit/:id',
    name: 'Edit Offer Slider',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Marketing_Offers_OffersEdit_vue__["a" /* default */]
  }]
};

var rewardMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/reward-program',
    name: 'Edit Reward Program',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_RewardProgram_RewardProgramEdit_vue__["a" /* default */]
  }]
};

var reportsMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Reports_Reports_vue__["a" /* default */]
  }, {
    path: '/reports/customer/:id',
    name: 'Customer Details',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Reports_ReportsCustomerDetails_vue__["a" /* default */]
  }]
};

var settingsMenu = {
  path: '/settings',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Settings_Settings_vue__["a" /* default */]
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Settings_Users_Users_vue__["a" /* default */]
  }, {
    path: '/user/add',
    name: 'Add User',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Settings_Users_UserAdd_vue__["a" /* default */]
  }, {
    path: '/user/edit/:id',
    name: 'Edit User',
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Settings_Users_UserEdit_vue__["a" /* default */]
  }, {
    path: '/feedback',
    name: 'Feedback',
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Settings_Feedback_Feedback_vue__["a" /* default */],
    session: 'newFeedback'
  }, {
    path: '/feedback/view/:id',
    name: 'View Feedback',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Settings_Feedback_FeedbackView_vue__["a" /* default */]
  }]
};

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: []
}, orderingMenu, customersMenu, InfoPage, ordersMenu, productsMenu, prodOptionsMenu, categoriesMenu, marketingMenu, rewardMenu, reportsMenu, settingsMenu, loginPage, registerPage, recoverPage, resetPage, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard_Layout_DashboardNoSpacingLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: [{
    path: 'overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */]
  }, {
    path: 'stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Dashboard_Stats_vue__["a" /* default */]
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_2__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea018080_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("BRE2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea018080_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TFIm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);













__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_5__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fullscreenLoading: false
    };
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),

/***/ "TUUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPages_vue__ = __webpack_require__("gSDC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2922b748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPages_vue__ = __webpack_require__("mvUS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2922b748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ToeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RewardProgramForm_vue__ = __webpack_require__("RYO5");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'RewardForm', __WEBPACK_IMPORTED_MODULE_7__RewardProgramForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      couponModel: {},
      coupon: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onRewardSubmit: function onRewardSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "Txk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/marketing/campaigns"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('campaign-form',{on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/ZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0872ba4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("6gFo");
function injectStyle (ssrContext) {
  __webpack_require__("Dmt6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0872ba4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U78x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/marketing/offers"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('offers-form',{on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V4VE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V5v9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7efac9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("RkrC");
function injectStyle (ssrContext) {
  __webpack_require__("Ko2o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7efac9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b37e4d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("5sgJ");
function injectStyle (ssrContext) {
  __webpack_require__("a1r3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b37e4d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wnm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XWiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: false,
      companyName: this.$session.get('companyName'),
      companyAvatar: this.$session.get('companyAvatar')
    };
  },
  created: function created() {
    this.$on('companyName', function (name) {
      console.warn('the new name is: ' + name);
      this.companyName = name;
    });
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    goToSettings: function goToSettings() {
      this.$session.set('selecetdTab', 'Company Details');
      this.$router.push('/settings');
    }
  }
});

/***/ }),

/***/ "XZbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details order-mng"},[_c('div',{ref:"optionsTopBar",staticClass:"company-top-bar "},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-fill btn-success btn",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])])]),_vm._v(" "),_c('div',{ref:"compDetailsContainer",staticClass:"company-wrap",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"pad-bt-15"},[_c('i',{staticClass:"ti-align-left"}),_vm._v("  "+_vm._s(_vm.$t('settingCompany.deliveryLabels'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model.delivery_options_labels),function(labelObj){return _c('div',{staticClass:"pad-bt-15 col-md-6"},[_c('label',[_vm._v(" "+_vm._s(_vm.$t('settingCompany.' + labelObj['key']))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(labelObj['label']),expression:"labelObj['label']"}],staticClass:"form-control ",attrs:{"type":"text"},domProps:{"value":(labelObj['label'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(labelObj, 'label', $event.target.value)}}})])}))])]),_vm._v(" "),_vm._l((_vm.model.locations_details),function(bussLocation){return _c('div',{staticClass:"card pad-bt-15"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"pad-bt-15"},[_c('i',{staticClass:"ti-home"}),_vm._v(" "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(bussLocation.name)+"\n        ")]),_vm._v(" "),_c('form',[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_vm._l((bussLocation.ordering_management),function(order){return [_c('div',{staticClass:"pull-right disable-chck",on:{"click":function($event){_vm.updateTabs(bussLocation.id + order.type, order.enabled)}}},[_c('p-checkbox',{key:"order.type",attrs:{"value":true,"label":order.label},on:{"click":function($event){_vm.updateTabs(bussLocation.id + order.type)}},model:{value:(order.enabled),callback:function ($$v) {_vm.$set(order, "enabled", $$v)},expression:"order.enabled"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('el-collapse-item',{staticClass:"text-left",class:order.enabled ? '' : 'disabled',attrs:{"title":_vm.model.delivery_options_labels[_vm.getObjectByElemKeyValue('key', order.type, _vm.model.delivery_options_labels)]['label'],"name":bussLocation.id + order.type}},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.paymentOptions')))]),_vm._v(" "),_vm._l((_vm.paymentOptions),function(opt,idx){return _c('div',{staticClass:"checkbox mar-bt-20"},[(idx == 0)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + opt.payment_id}},[_vm._v(_vm._s(opt.name))])])}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'payment')),expression:"errors.has(bussLocation.id + order.type + 'payment')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsOrdering.paymentOptionsErr'))+"\n                      ")])],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.minimum_order_value),expression:"order.minimum_order_value"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'minimum_order_value',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "minimum_order_value", $event.target.value)}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.waitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.default_waiting_time),expression:"order.default_waiting_time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'default_waiting_time',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "default_waiting_time", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))])]),_vm._v(" "),(order.type === 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingCost')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.shipping_cost.cost),expression:"order.shipping_cost.cost"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'delivery_cost',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.shipping_cost.cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order.shipping_cost, "cost", $event.target.value)}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.currency))])]):_vm._e(),_vm._v(" "),(order.type === 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingTax')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.taxesPerLocation[bussLocation.id],"value":"id","label":"name"},model:{value:(order.shipping_cost.taxes),callback:function ($$v) {_vm.$set(order.shipping_cost, "taxes", $$v)},expression:"order.shipping_cost.taxes"}})],1):_vm._e(),_vm._v(" "),(order.type === 'meet_half')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.locations')))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.street')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.city')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.country')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.state')))]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((order.locations),function(location,idx){return _c('tr',[_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"},{name:"model",rawName:"v-model",value:(location.street),expression:"location.street"}],staticClass:"form-control",attrs:{"type":"text","name":bussLocation.id + order.type +'locationstr'+order.type+idx,"disabled":!order.enabled},domProps:{"value":(location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "street", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.city),expression:"location.city"}],staticClass:"form-control",attrs:{"type":"text","name":bussLocation.id + order.type +'locationcity'+order.type+idx,"disabled":!order.enabled,"vv-validate":"modelValidate.required"},domProps:{"value":(location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "city", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"select-primary form-control",attrs:{"name":bussLocation.id + order.type +'locationcountry'+order.type+idx,"disabled":!order.enabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(location)}]}},_vm._l((_vm.defaults.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                                ")])}))]),_vm._v(" "),_c('td',[(_vm.showStateDrop(location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                                  ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":_vm.$t('settingsOrdering.state')},domProps:{"value":(location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "state", $event.target.value)}}})]],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.removeLocation(bussLocation.id, idx, order.type)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.remove')}})])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewLocation(bussLocation.id, order.type)}}},[_c('i',{staticClass:"ti-plus"})])])])]],2),_vm._v(" "),_c('tfoot')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDays')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'days')),expression:"errors.has(bussLocation.id + order.type + 'days')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsOrdering.availableDaysErr'))+"\n                      ")]),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2 col-md-4 col-sm-4 col-xs-12 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-8 col-sm-8 col-xs-12 padd"},[_vm._v("\n                          from \n                          "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                          to \n                          "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)])})],2)])])]})],2)],1)])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y09D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    }
  },
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      loading: true,
      tableColumns: [{
        prop: 'firstname',
        label: this.$t('settingUsers.fn'),
        minWidth: 100
      }, {
        prop: 'lastname',
        label: this.$t('settingUsers.ln'),
        minWidth: 100
      }, {
        prop: 'role',
        label: this.$t('settingUsers.role'),
        minWidth: 150
      }],
      tableData: []
    };
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/user/edit/');
      }
    },
    getData: function getData() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/profile', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data;

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      if (typeof this.callback === 'function') {
        this.callback(null);
      }
    }
  }
});

/***/ }),

/***/ "Y1ls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"text-center logo-normal"},[_c('a',{staticClass:"show-hide-menu",on:{"click":function($event){$event.preventDefault();return _vm.minimizeSidebar($event)}}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu' : 'ti-menu'})]),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"logo-mini"})]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,ref:link.session !== undefined ? link.session : '',refInFor:true,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}))})),_vm._v(" "),_c('li',{staticClass:"logout-link"},[_c('a',{attrs:{"href":"/logout"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('i',{staticClass:"icon-menu icon-menu-logout"}),_vm._v(" "),_c('p',[_vm._v("Logout")])])])],2)],2),_vm._v(" "),_c('div',{staticClass:"alert-box-wrap"},[(_vm.newOrdersCount > 0)?_c('div',{staticClass:"alert-box",on:{"click":function($event){_vm.goToOrders('NEW')}}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.newOrdersCount)+" "+_vm._s(_vm.$t('ordersStatus.NEW')))])]):_vm._e(),_vm._v(" "),(_vm.processingOrdersCount > 0)?_c('div',{staticClass:"alert-box processing",on:{"click":function($event){_vm.goToOrders('PROCESSING')}}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.processingOrdersCount)+" "+_vm._s(_vm.$t('ordersStatus.PROCESSING')))])]):_vm._e()]),_vm._v(" "),_c('audio',{attrs:{"src":"/static/audio/alarm.mp3","muted":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y39F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YX5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:" nav-mobile-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YeLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);






var _components;







__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    countries: {},
    modeldata: {},
    taxesData: {},
    tabRefresh: {}
  },
  watch: {
    countries: function countries(value) {
      this.countriesList = value;
    },
    modeldata: function modeldata(value) {
      for (var idx in value.locations_details) {
        if (!value.locations_details[idx].working_hours) {
          value.locations_details[idx].working_hours = [];
        }
        if (!value.locations_details[idx].allow_preorder) {
          value.locations_details[idx].allow_preorder = false;
        }
        for (var iDay in this.days) {
          var day = this.days[iDay];
          var index = this.getObjectByElemKeyValue('day', day, value.locations_details[idx].working_hours);
          if (index === false) {
            value.locations_details[idx].working_hours.push({ day: day, open_to: '', open_from: '', open: false });
          } else if (value.locations_details[idx].working_hours[index].open === undefined) {}
        }
      }
      this.showDelete = value.locations_details.length > 1;
      this.model = value;
    },
    taxesData: function taxesData(value) {
      this.taxes = value;
    },
    tabRefresh: function tabRefresh(value) {
      if (value === 'Company Details') {
        this.showUpdateWarning = false;
        var data = {
          token: this.$session.get('token')
        };
        var self = this;
        var companyID = this.$session.get('selectedCompany');

        this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
          if (response.status === true) {
            self.$emit('updateModelData', response.data[0]);
          }
        });
      }
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      countriesList: this.value || this.countries,
      states: [],
      taxes: this.value || this.taxesData,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      showDelete: false,
      modelValidate: {
        name: { required: true },
        email: { required: true },
        phone: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true },
        working_hours: { required: true }
      },
      timeFormat: 'HH:mm',
      dateFormat: 'DD/MM/YYYY',
      pickerNames: ['date_from', 'date_to'],
      days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59',
        format: this.timeFormat
      },
      showUpdateWarning: false,
      languages: this.$session.get('defaultData')['available_languages'],
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true
    };
  },

  updated: function updated() {},
  computed: {},
  created: function created() {
    this.timeFormat = this.getCompanyDetail('time_format');
    this.dateFormat = this.getCompanyDetail('date_format');
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();
      _this.loading = false;

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    checkVal: function checkVal(location) {
      console.warn(location.allow_preorder);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveDetails();
        } else {
          console.warn(_this2.errors);
        }
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    disableTaxOption: function disableTaxOption(locId, taxId) {
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    addLocation: function addLocation() {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            id: null,
            city: '',
            country: '',
            email: null,
            name: null,
            taxes: [],
            ordering_management: [{
              type: 'pick_up',
              label: 'Pick-up',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false }
            }, {
              type: 'meet_half',
              label: 'Meet me half way',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false },
              locations: []
            }, {
              type: 'delivery',
              label: 'Delivery',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false },
              cost: null,
              shipping_cost: []
            }, {
              type: 'eat_location',
              label: 'Eat on location',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false }
            }],
            phone: null,
            street: null,
            working_hours: []
          };

          newRow.id = response.data[0].id;

          newRow.isNew = true;

          for (var iDay in self.days) {
            newRow.working_hours.push({ day: self.days[iDay], open_to: '', open_from: '', open: false });
          }

          for (var iOrder in newRow.ordering_management) {
            for (var _iDay in self.days) {
              newRow.ordering_management[iOrder].available_days.push({ day: self.days[_iDay], open_to: '', open_from: '', open: false });
            }
          }

          self.model.locations_details.push(newRow);

          var locationsHtml = self.$el.querySelectorAll('.location-card');
          var lastLoc = locationsHtml[locationsHtml.length - 1];
          self.$nextTick(function () {
            if (locationsHtml.length < 2) {
              self.scrollToPx(lastLoc.clientHeight - 140);
            } else {
              self.scrollToPx(lastLoc.clientHeight);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    scrollToPx: function scrollToPx(px) {
      console.warn(px);
      var elem = this.$el;
      console.warn(elem.clientHeight);
      elem.scrollTop = elem.clientHeight;
      window.scrollTo({
        left: 0,
        top: elem.clientHeight - px,
        behavior: 'smooth'
      });
    },
    deleteLocation: function deleteLocation(id) {
      var _this3 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var locIdx = _this3.getObjectByElemKeyValue('id', id, _this3.model.locations_details);
          if (locIdx) {
            _this3.model.locations_details.splice(locIdx, 1);
          }
          _this3.saveDetails();
        }
      });
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    addNewTax: function addNewTax(locId) {
      var newRow = {
        'id': null,
        'type': null,
        'amount': null
      };
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      if (locIdx) {
        if (this.model.locations_details[locIdx]['taxes'] === undefined) {
          this.model.locations_details[locIdx].push({ 'taxes': [] });
        }
        this.model.locations_details[locIdx]['taxes'].push(newRow);
        this.showUpdateWarning = true;
      }
    },
    deleteTax: function deleteTax(locId, taxId) {
      var _this4 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureTax'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var locIdx = _this4.getObjectByElemKeyValue('id', locId, _this4.model.locations_details);
          var thisTaxIdx = _this4.getObjectByElemKeyValue('id', taxId, _this4.model.locations_details[locIdx]['taxes']);
          _this4.model.locations_details[locIdx]['taxes'].splice(thisTaxIdx, 1);
          _this4.showUpdateWarning = true;
        }
      }).catch({});
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var countries = this.$session.get('defaultData').countries;
      var currentLocations = [];
      for (var locIdx in this.model.locations_details) {
        var locData = this.copyObject(this.model.locations_details[locIdx]);
        console.warn(locData);
        var countryIso = locData.country;
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
        var states = [];

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          states = countries[countryIdx].states;
        }

        if (states.length && locData.state_id) {
          var state = this.getObjectByElemKeyValue('id', locData.state_id, states);
          if (state !== undefined) {
            locData.state = states[state].name;
          } else {
            locData.state = '';
          }
        }
        delete locData.states;
        currentLocations[locIdx] = locData;
      }
      if (this.model.tips_taxes === null) {
        this.model.tips_taxes = [];
      }
      var data = {
        'token': this.$session.get('token'),
        'name': this.model.name,
        'language': this.model.language,
        'locations_details': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentLocations),
        'tips_taxes': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.tips_taxes),
        'tips_in_use': this.model.tips_in_use ? 1 : 0
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$emit('updateModelData', response.data[0]);
          self.$session.set('companyName', data.name);
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$emit('companyName', data.name);
          self.showDelete = self.model.locations_details.length > 1;
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "Yq4J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yvs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignEdit_vue__ = __webpack_require__("Q9x8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8240a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignEdit_vue__ = __webpack_require__("Id4v");
function injectStyle (ssrContext) {
  __webpack_require__("F8ab")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8240a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZK0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('a',{staticClass:"btn btn-info",on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('settingUsers.single')))])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":45},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"fa fa-pencil"})]}}])})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a359449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("mby7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a359449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zflh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zuvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.recoverMsg !== ''),expression:"recoverMsg !== ''"}],staticClass:"text-success"},[_vm._v("\n                      "+_vm._s(_vm.recoverMsg)+"\n                    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('error'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Let's go")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo.png"}})]),_vm._v(" "),_c('h4',{staticClass:"purple mar-to-0 mar-bt-25"},[_vm._v("Recover Password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a1r3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a722":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aFPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.getError('error'))+"\n      ")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.name')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.taxes),function(tax_rate){return _c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.id),expression:"tax_rate.id"}],attrs:{"type":"hidden","name":'tax_rate'+tax_rate.id},domProps:{"value":(tax_rate.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "id", $event.target.value)}}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(tax_rate.name),expression:"tax_rate.name"}],staticClass:"form-control",attrs:{"type":"text","min":"0","name":'name'+tax_rate.id},domProps:{"value":(tax_rate.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(tax_rate.id)}}},[_c('i',{staticClass:"ti-close ",attrs:{"title":_vm.$t('general.remove')}})])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info pull-right",attrs:{"title":"Add"},on:{"click":function($event){$event.preventDefault();_vm.addNewTax()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('settingTaxes.single')))])])])]],2),_vm._v(" "),_c('tfoot')]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"help-block warning"},[_vm._v(_vm._s(_vm.$t('settingTaxes.notice'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(_vm._s(_vm.$t('settingTaxes.notice2')))]),_vm._v(".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update'))+" "+_vm._s(_vm.$t('settingTaxes.single')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "agLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__);



















var _components;








__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])),
  data: function data() {
    return {
      pickerOptions1: {},
      deliveryServices: [],
      pickerNames: ['date_validfrom', 'date_validto'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      displayTypes: {
        'list': 'List',
        'grid': 'Grid'
      },
      mainCategories: [],
      model: {
        parent_id: null,
        display_type: 'list'
      },
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        name: {
          required: true,
          min: 4
        }
      },
      loading: true
    };
  },

  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    if (this.$route.params.id) {
      var id = this.$route.params.id;

      this.apiRequest('/category/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_validfrom && response.data[0].date_validto) {
            response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }

          response.data[0].display_type = 'list';
          self.model = response.data[0];

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    } else {
      self.$nextTick(function () {
        self.loading = false;
      });
    }

    var allTypes = this.$session.get('defaultData')['delivery_types'];
    var locations = this.$session.get('selectedCompanyData')['locations_details'];
    var enabled = [];
    var enabledTypes = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var loc = _step.value;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(loc['ordering_management']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var ordering = _step2.value;

            console.warn(ordering);
            if (ordering['enabled'] === true) {
              enabled[ordering['type']] = true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    console.warn(enabled);
    for (var idx in allTypes) {
      console.warn(idx);
      if (enabled[idx.toLowerCase()] !== undefined) {
        enabledTypes.push(allTypes[idx]);
      }
    }
    console.warn(enabledTypes);
    this.deliveryServices = enabledTypes;
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.errors.clear();
          _this.saveCategory();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log('handleRemove');
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    updateDates: function updateDates(dates) {
      this.model.date_validfrom = __WEBPACK_IMPORTED_MODULE_20_moment___default()(String(dates.minDate)).format('YYYY-MM-DD');
      this.model.date_validto = __WEBPACK_IMPORTED_MODULE_20_moment___default()(String(dates.maxDate)).format('YYYY-MM-DD');
    },
    handleDelete: function handleDelete(label) {
      var _this2 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
        text: this.$t('catalogCateg.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this2.isNew()) {
            self.$router.push('/categories');
          } else {
            var id = _this2.$route.params.id;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/category/' + id, 'DELETE', data, function (response) {
              console.warn(response);
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()('', self.$t('catalogCateg.categDeleted'), 'success');
                self.$router.push('/categories');
              } else {
                __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    saveCategory: function saveCategory() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = this.model;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      console.warn(data.fromto);
      if (data.fromto && data.fromto[0] && data.fromto[1]) {
        data.date_validfrom = data.fromto[0];
        data.date_validto = data.fromto[1];
      } else {
        data.date_validfrom = null;
        data.date_validto = null;
      }

      var self = this;

      if (this.isNew()) {
        delete data.parent_category;
        delete data.image;
        this.apiRequest('/category', 'POST', data, function (response) {
          if (response.status === true) {
            console.warn(response);
            var id = response.data[0].id;
            data.id = id;
            data.sort_order = id;
            self.apiRequest('/category/' + id, 'PUT', data, function (response2) {});
            if (data.imagelist && data.imagelist[0].status === 'ready') {
              self.getBase64(data.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                console.warn(data2);
                self.apiRequest('/category/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogCateg.categAdded'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                    self.$router.push('/categories/edit/' + id);
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogCateg.couldNotSave'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                title: '',
                text: self.$t('catalogCateg.categAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
              self.$router.push('/categories/edit/' + id);
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      } else {
        var id = this.$route.params.id;
        delete data.parent_category;
        delete data.image;

        if (data.imagelist === 0) {
          data.image = '';
        }
        this.apiRequest('/category/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (data.imagelist[0].status && data.imagelist[0].status === 'ready') {
              self.getBase64(data.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                console.warn(data2);
                self.apiRequest('/category/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogCateg.categUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                      title: '',
                      text: self.$t('catalogCateg.couldNotSave'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
                title: '',
                text: self.$t('catalogCateg.categUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "bQaV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignAdd_vue__ = __webpack_require__("RX1z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_482d1982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignAdd_vue__ = __webpack_require__("Txk+");
function injectStyle (ssrContext) {
  __webpack_require__("JIOi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_482d1982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bfzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CustomerView_vue__ = __webpack_require__("viQu");


























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_row___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__["a" /* default */],
    CustomerView: __WEBPACK_IMPORTED_MODULE_22__CustomerView_vue__["a" /* default */]
  },
  computed: {},
  created: function created() {
    var self = this;
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.apiRequest('/customer', 'GET', data, function (response) {
      if (response.status === true) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cust = _step.value;

            cust['fullname'] = cust['firstname'] + ' ' + cust['lastname'];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        self.tableData = response.data;
        self.paginationDef.pageSize = self.tableData.length + 1;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
  },
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 99999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [],
      tableData: [],
      windowHeight: 0,
      tableTopHeight: 70,
      filters: [{
        value: '',
        prop: ['firstname', 'lastname', 'sales', 'id', 'email', 'phone', 'fullname']
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.windowHeight = window.innerHeight;
      _this.tableTopHeight = _this.$refs.tableTop.clientHeight;

      window.addEventListener('resize', function () {
        _this.windowHeight = window.innerHeight;
        _this.tableTopHeight = _this.$refs.tableTop.clientHeight;
      });
    });
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/customers/view/');
      this.$refs.customerForm.getData();
    },
    rowClass: function rowClass(row, index) {
      if (this.$route.params.id && parseInt(row.row.id) === parseInt(this.$route.params.id)) {
        return 'current';
      } else {
        return '';
      }
    },
    showForm: function showForm() {
      if (this.$route.path.indexOf('view') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    handleActive: function handleActive(index, row, e) {
      var _this2 = this;

      var actionText = row.active ? 'activate' : 'deactivate';
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: 'Are you sure you want to ' + actionText + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          _this2.apiRequest('/hello', 'GET', [], function (response) {
            console.log(response);
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('Success!', '', 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
        row.active = !row.active;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this3 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: 'Are you sure you want to delete \'' + row.name + '\'?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        var self = _this3;
        if (result) {
          _this3.apiRequest('/hello', 'GET', [], function (response) {
            console.warn(response);
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', 'Product deleted successfully', 'success');
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
            }
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "bkX7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "btJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackView_vue__ = __webpack_require__("ITsO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149a1036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackView_vue__ = __webpack_require__("rprZ");
function injectStyle (ssrContext) {
  __webpack_require__("+DAr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149a1036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bukA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsMenu_vue__ = __webpack_require__("zATB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eadfe7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsMenu_vue__ = __webpack_require__("L07y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eadfe7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bwiK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371d172c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("lvv9");
function injectStyle (ssrContext) {
  __webpack_require__("e6s1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371d172c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "c2KQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a
  },
  watch: {},
  computed: {},
  data: function data() {
    var _this = this;

    return {
      loading: true,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: 'delete'
        }]
      },
      paginationDef: {
        pageSize: 999,
        currentPage: 1,
        pageSizes: [999],
        show: false,
        disabled: true
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['title', 'link_type', 'date_start', 'date_end']
      }]
    };
  },

  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var self = this;
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany'),
      use_sort_order: 'asc'
    };
    this.apiRequest('/banner', 'GET', data, function (response) {
      if (response.status === true) {
        self.tableData = response.data;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
  },
  methods: {
    goToRecord: function goToRecord(row, event, column) {
      if (column.label !== 'Actions' && column.label !== 'Status') {
        this.globalGoToRecord(row, event, column, '/marketing/offers/edit/');
      }
    },
    adjustSort: function adjustSort(evt) {
      if (this.tableData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          console.warn('first');
          before = 0;
          after = this.tableData[idx + 1].sort_order;
        } else if (idx + 1 === this.tableData.length) {
          console.warn('last');
          before = this.tableData[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          console.warn('middle');
          before = this.tableData[idx - 1].sort_order;
          after = this.tableData[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.tableData[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        var self = this;
        this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
              title: '',
              text: self.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    handleDelete: function handleDelete(index, row, event) {
      var _this2 = this;

      var self = this;
      event.stopPropagation();
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + row.title + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/banner/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('marketingOffers.offerDeleted'), 'success');
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + '(' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "c3/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForthStep_vue__ = __webpack_require__("ech5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e061a396_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForthStep_vue__ = __webpack_require__("3wER");
function injectStyle (ssrContext) {
  __webpack_require__("n8BA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForthStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e061a396_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForthStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cQcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__ = __webpack_require__("HOa3");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      userModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userModel = model;
    }
  }
});

/***/ }),

/***/ "cxx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);













var _components;







__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), _components),
  props: {
    userId: null,
    callback: {
      required: false
    }
  },
  watch: {
    userId: function userId(value) {
      this.id = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* mapFields */])(['name', 'last_name', 'email', 'job', 'role'])),
  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
      this.loadingReset = true;
    });
    this.$validator.localize('en', {
      en: {
        attributes: {
          firstname: this.$t('settingUsers.fn'),
          lastname: this.$t('settingUsers.ln')
        }
      }
    });

    var self = this;
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.roles = response.data[0].user_roles;
      }
    });

    if (this.$route.params.id !== undefined && this.$route.params.id || this.id !== undefined && this.id !== null) {
      this.isNew = false;
    } else {
      this.isNew = true;
    }
    if (!this.isNew) {
      var id = this.$route.params.id || this.id;
      this.apiRequest('/profile/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].avatar) {
            response.data[0].imagelist = [{ url: response.data[0].avatar }];
          } else {
            response.data[0].imagelist = [];
          }

          self.model = response.data[0];

          self.$nextTick(function () {
            self.loading = false;
            self.loadingReset = false;
          });
        }
      });
    } else {
      this.$nextTick(function () {
        this.loading = false;
        this.loadingReset = false;
      });
    }
  },
  data: function data() {
    return {
      roles: [],
      id: this.value || this.userId,
      isNew: true,
      filelist: [],
      model: {
        'lastname': '',
        'firstname': '',
        'password': '',
        'confirm_password': '',
        'role': ''
      },
      driverCode: '',
      modelValidate: {
        firstname: { required: true, min: 3 },
        lastname: { required: true, min: 3 },
        email: { required: true },
        role: { required: true },
        password: { required: true },
        password_confirmation: {
          required: true
        },
        username: { required: true },
        language: { required: true }
      },
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true,
      loadingReset: true
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.errors['items'] = this.removeErrorByName('password_confirmation', this.errors['items']);
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveUser();
        }
      });
    },
    validateReset: function validateReset() {
      if (this.model.password === undefined || this.model.password === '') {
        this.errors.add('password_2', this.$t('validations.passReq'));
      } else if (this.model.password.length < 6) {
        this.errors.add('password_2', this.$t('validations.passMin'));
      } else if (this.model.password_confirmation === undefined || this.model.password_confirmation === '') {
        this.errors.add('password_confirm_2', this.$t('validations.passReq'));
      } else if (this.model.password !== this.model.password_confirmation) {
        this.errors.add('password_confirm_2', this.$t('validations.passConf'));
      } else {
        this.resetPass();
      }
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    saveUser: function saveUser() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {};
      if (!this.isNew) {
        data = {
          id: this.model.id,
          firstname: this.model.firstname,
          lastname: this.model.lastname,
          email: this.model.email,
          language: this.model.language
        };
        if (this.model.role !== 'OWNER') {
          data['role'] = this.model.role;
        }
      } else {
        data = this.model;
      }
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;
      var self = this;

      if (this.isNew) {
        delete data.avatar;
        this.apiRequest('/profile', 'POST', data, function (response) {
          if (response.status === true) {
            var id = response.data[0].id;
            if (data.imagelist && data.imagelist[0].status === 'ready') {
              self.getBase64(data.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.avatar = base64enc;

                self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.errors.clear();
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userAdded'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                    if (typeof self.callback === 'function') {
                      self.callback();
                    } else {
                      self.$router.push('/user/edit/' + id);
                    }
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userPicError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.errors.clear();
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: '',
                text: self.$t('settingUsers.userAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {}).catch(function () {});
              if (typeof self.callback === 'function') {
                self.callback();
              } else {
                self.$router.push('/user/edit/' + id);
              }
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      } else {
        var id = this.id || this.$route.params.id;

        if (data.role === 'OWNER') {
          delete data.role;
        }

        delete data.avatar;

        if (this.model.imagelist.length === 0) {
          data.avatar = '';
        }

        var user = JSON.parse(this.$session.get('userData'));
        if (id === user.id) {
          var url = '/profile/me';
        } else {
          url = '/profile/' + id;
        }

        this.apiRequest(url, 'PUT', data, function (response) {
          if (response.status === true) {
            if (id === user.id) {
              console.warn(data.language);
              self.$i18n.locale = data.language;
              self.$session.set('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data[0]));
            }
            if (self.model.imagelist.length && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.avatar = base64enc;

                self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    var user = JSON.parse(self.$session.get('userData'));
                    if (id === user.id) {
                      self.$session.set('companyAvatar', data2.avatar);
                    }
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                    if (typeof self.callback === 'function') {
                      self.callback();
                    }
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userPicError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: '',
                text: self.$t('settingUsers.userUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {}).catch(function () {});
              if (typeof self.callback === 'function') {
                self.callback();
              }
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    },
    resetPass: function resetPass() {
      this.$nextTick(function () {
        this.loadingReset = true;
      });
      var id = this.id || this.$route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        password: this.model.password,
        password_confirmation: this.model.password_confirmation
      };

      var self = this;
      this.apiRequest('/profile/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$nextTick(function () {
            self.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': 'New password saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    getDriverCode: function getDriverCode(role) {
      if (role === 'DRIVER') {
        if (this.driverCode === '' || this.driverCode === null) {
          var id = this.$session.get('selectedCompany');
          var data = {
            company_id: id,
            token: this.$session.get('token')
          };
          var self = this;

          this.apiRequest('/settings/newdriver/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              self.driverCode = response.data['email'];
              self.model.email = self.driverCode;
            } else {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': response.error['email'] ? response.error['email'] : self.$t('validations.wentWrong'), 'type': 'error' }).catch({});
            }
          });
        } else {
          this.model.email = this.driverCode;
        }
      } else {
        this.model.email = '';
      }
    },
    cancelUser: function cancelUser() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
    }
  }
});

/***/ }),

/***/ "d7TW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersEdit_vue__ = __webpack_require__("slG6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5177966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersEdit_vue__ = __webpack_require__("uKvv");
function injectStyle (ssrContext) {
  __webpack_require__("RzYN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5177966_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b45a518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("O6iw");
function injectStyle (ssrContext) {
  __webpack_require__("5tB6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b45a518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dmRH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "duJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__ = __webpack_require__("c2KQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c30e586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__ = __webpack_require__("6N/I");
function injectStyle (ssrContext) {
  __webpack_require__("ywXP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c30e586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0Nk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Customers_customer__ = __webpack_require__("MK8T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Orders_orders__ = __webpack_require__("43KB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs__);











var _components;









__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), _components),
  data: function data() {
    return {
      paginationDef: {
        pageSize: 99999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      customer: __WEBPACK_IMPORTED_MODULE_12__Customers_customer__["a" /* default */],
      countries: __WEBPACK_IMPORTED_MODULE_13__Customers_countries__["a" /* default */],
      tableData: __WEBPACK_IMPORTED_MODULE_14__Orders_orders__["a" /* default */],
      modelValidations: {
        required: {
          required: true
        }
      },
      tableColumns: [{
        prop: 'number',
        label: 'Number',
        minWidth: 100
      }, {
        prop: 'created_date',
        label: 'Date Created',
        minWidth: 150
      }, {
        prop: 'delivery_service',
        label: 'Delivery',
        minWidth: 150
      }, {
        prop: 'type',
        label: 'Type',
        minWidth: 100
      }]
    };
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/orders/view/');
    },
    statusClass: function statusClass(status) {}
  }
});

/***/ }),

/***/ "e6s1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceeebaea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("93hz");
function injectStyle (ssrContext) {
  __webpack_require__("r4QW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceeebaea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "ec2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__("2OT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f638b19a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__("Lh50");
function injectStyle (ssrContext) {
  __webpack_require__("AdAc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f638b19a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ech5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tree_halower_dist_halower_tree_min_css__ = __webpack_require__("ug9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tree_halower_dist_halower_tree_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_tree_halower_dist_halower_tree_min_css__);













__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_radio___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelFromParent: {
      type: [Object, Array],
      required: true
    },
    couponsParent: {
      type: [Object, Array],
      required: true
    },
    groupedProductsParent: {
      type: [Object, Array],
      required: true
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.activeButton = value.type;
      this.addcoupon = value.type === 'COUPON';
      this.model = value;
    },
    couponsParent: function couponsParent(value, oldVal) {
      console.warn('----coupons----');
      console.warn(value);
      this.coupons = value;
      this.getTrees();
    },
    groupedProductsParent: function groupedProductsParent(value, oldVal) {
      this.groupedProducts = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
  },
  data: function data() {
    return {
      model: this.value || this.modelFromParent,
      groupedProducts: this.value || this.groupedProductsParent,
      modelValidations: {
        type: {
          required: true
        },
        usage_type: {
          required: true
        },
        discount: {
          required: true,
          min_value: 1
        },
        coupon_code: {
          required: true,
          min: 4
        }
      },
      coupons: this.value || this.couponsParent,
      couponType: this.$session.get('defaultData')['coupons_types'],
      couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
      pickerOptions1: {},
      pickerNames: ['date_from', 'date_to'],
      searchword: '',
      activeButton: 0,
      addcoupon: false,
      treeData: [],
      currency: ''
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    changeType: function changeType() {
      var newType = 'TEXT';
      if (this.addcoupon) {
        newType = 'COUPON';
        this.getTrees();
      }
      this.model['type'] = newType;
      this.activeButton = newType;
    },
    search: function search() {
      this.$refs.tree.searchNodes(this.searchword);
    },
    generateCode: function generateCode() {
      console.warn(this.coupons);
      var random = Math.random().toString(36).substring(7);
      var value = this.model.coupon_value;

      if (this.coupons['type'] === undefined) {
        this.coupons['type'] = 'PERCENTAGE';
      }
      this.coupons['coupon_code'] = '';
      this.coupons['coupon_code'] = random;

      this.$nextTick(function () {
        console.warn(this.coupons);
      });
    },
    getTrees: function getTrees() {
      this.$nextTick(function () {
        var catProdTree = [];
        this.treeData = [];
        console.warn('-----------TREE----------');
        console.warn(this.groupedProducts);
        console.warn(this.coupons.usage_for_categories);
        for (var id in this.groupedProducts) {
          console.warn(id);
          var idCateg = this.isInObject(parseInt(id), this.coupons.usage_for_categories);
          if (idCateg) {
            var data = { 'id': id, 'title': this.groupedProducts[id].details.name, 'checked': true };
            var children = [];
            for (var idx in this.groupedProducts[id].items) {
              children.push({ 'id': this.groupedProducts[id].items[idx].id, 'title': this.groupedProducts[id].items[idx].name, 'checked': true });
            }
            data['children'] = children;
            catProdTree.push(data);
          } else {
            var _children = [];
            var halfcheck = false;
            for (var _idx in this.groupedProducts[id].items) {
              var chk = false;
              var idProd = this.isInObject(parseInt(this.groupedProducts[id].items[_idx].id), this.coupons.usage_for_products);
              if (idProd) {
                chk = true;
                halfcheck = true;
              }
              _children.push({
                'id': this.groupedProducts[id].items[_idx].id,
                'title': this.groupedProducts[id].items[_idx].name,
                'checked': chk
              });
            }
            catProdTree.push({ 'id': id, 'title': this.groupedProducts[id].details.name, 'children': _children, 'halfcheck': halfcheck });
          }
        }
        this.treeData = catProdTree;
      });
    }
  }
});

/***/ }),

/***/ "edxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row products"},[_c('div',{staticClass:"col-lg-3 col-md-4 col-xs-4"},[_c('div',{staticClass:" row"},[_c('div',{staticClass:"fixed",style:({height: _vm.windowHeight - _vm.pageTopHeight + 'px'})},[_c('div',{ref:"tableTop",staticClass:"table-top"},[_c('el-row',[_c('el-col',[(_vm.mainCategories.length > 0)?_c('el-input',{staticClass:"sm-search col-md-6 icon-search",attrs:{"placeholder":"Search"},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}}):_c('el-input',{staticClass:"col-md-6 icon-search",attrs:{"placeholder":"Search"},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}}),_vm._v(" "),(_vm.mainCategories.length > 0)?_c('el-dropdown',{staticClass:"dropdown-sm",attrs:{"type":"default","hide-on-click":false}},[_c('el-button',{staticClass:"filter-btn",attrs:{"type":"default"}},[_c('img',{attrs:{"src":"/static/img/icons/filter.png"}})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('el-checkbox-group',{on:{"change":function($event){_vm.filterChanges()}},model:{value:(_vm.filters[1].value),callback:function ($$v) {_vm.$set(_vm.filters[1], "value", $$v)},expression:"filters[1].value"}},[_vm._l((_vm.mainCategories),function(loc,key){return [_c('el-checkbox',{key:loc.id,attrs:{"label":loc.id,"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n                        ")]),_vm._v(" "),_c('br')]})],2)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filters-wrapper"},[_vm._l((_vm.filters[1].value),function(sts,key){return [_c('span',{staticClass:"filter-selection"},[_vm._v(_vm._s(_vm.mainCategories[_vm.getObjectByElemKeyValue('id', sts, _vm.mainCategories)].name)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeFilter(1, key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]})],2)],1)],1)],1),_vm._v(" "),_c('div',{ref:"tableContainerRef",staticClass:"table-container",style:({height: _vm.windowHeight - _vm.tableTopHeight - _vm.tableBottomHeight - _vm.pageTopHeight + 'px'})},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"detailsScrollTable",staticStyle:{"width":"100%"},attrs:{"current-page":1,"page-size":_vm.paginationDef.pageSize,"data":_vm.tableData,"action-def":_vm.defaultActionDef,"border":false,"table-props":{'border': false, 'stripe': false, 'row-class-name': _vm.rowClass},"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":120,"sortable":"","prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('div',[_c('b',[_vm._v(_vm._s(props.row.price_details ? _vm.decodeHtml(props.row.price_details.formatted_price) : ''))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"active","label":"Active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"label label-primary mar-bt-15 inline-auto"},[_vm._v(_vm._s(props.row.category.name))]),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.$index, props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])})],1)],1),_vm._v(" "),_c('div',{ref:"tableBottom",staticClass:"table-bottom"},[_c('el-row',[_c('el-col',[_c('a',{staticClass:"btn btn-info btn-fill",attrs:{"title":""},on:{"click":function($event){$event.preventDefault();_vm.goToAdd()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProd.single')))])])],1)],1)])])]),_vm._v(" "),(_vm.showForm())?_c('div',{ref:"prodTopBar",staticClass:"prod-top-bar col-lg-9 col-md-8 col-xs-8"},[_c('h6',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.type)+" "+_vm._s(_vm.$t('catalogProd.single')))]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-fill btn-success btn",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger  btn-fill",on:{"click":function($event){$event.preventDefault();_vm.handleDelete('cancel')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]):_c('a',{staticClass:"btn btn-danger btn-fill btn",on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete this product')}}},[_vm._v(_vm._s(_vm.$t('general.delete'))+" "+_vm._s(_vm.$t('catalogProd.single')))])])])]):_vm._e(),_vm._v(" "),_c('div',{ref:"detailsScroll",staticClass:"col-lg-9 col-md-8 col-xs-8 detailsScroll",style:({height: _vm.windowHeight - (_vm.pageTopHeight + _vm.prodTopBarHeight) + 'px'})},[(_vm.showForm())?[_c('product-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],ref:"prodForm",attrs:{"mainCategoriesParent":_vm.mainCategories,"productsParent":_vm.tableData,"productsGroupedParent":_vm.groupedProducts,"taxesParent":_vm.taxes,"productOptionsParent":_vm.productOptions,"callback":_vm.updateList,"callbackDelete":_vm.getProducts}})]:_vm._e(),_vm._v(" "),(!_vm.showForm())?_c('div',{staticClass:"no-element"},[_c('i',{staticClass:"shopping-cart"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('catalogProd.noProducts')))])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "efnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-form',{on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eh/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_select__);
















var _components;








__WEBPACK_IMPORTED_MODULE_15_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_20_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])),
  props: {
    defaultData: {},
    modeldata: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      for (var iLocation in value.locations_details) {
        for (var iOrder in value.locations_details[iLocation].ordering_management) {
          if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].locations = [];
          }

          if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = [];
          }

          for (var iDay in this.days) {
            var day = this.days[iDay];
            if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days = [];
            }
            var index = this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days);
            if (index === false) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days.push({ day: day, open_to: '', open_from: '', open: false });
            } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' && value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true;
              } else {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false;
              }
            }
          }
        }
      }

      this.model = value;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var self = this;

      this.apiRequest('/settings/taxes', 'GET', data, function (response) {
        if (response.status === true) {
          self.taxes = response.data;
          var _value = self.model;
          var taxesPerLocation = [];

          for (var iLocation in _value.locations_details) {
            var ordMng = _value.locations_details[iLocation].ordering_management;
            for (var iOrder in ordMng) {
              if (ordMng[iOrder].type === 'delivery') {
                taxesPerLocation[_value.locations_details[iLocation].id] = [];
                for (var iTax in _value.locations_details[iLocation].taxes) {
                  var iTaxData = self.getObjectByElemKeyValue('id', _value.locations_details[iLocation].taxes[iTax].id, self.taxes);
                  if (iTaxData !== false) {
                    taxesPerLocation[_value.locations_details[iLocation].id].push(self.taxes[iTaxData]);
                  }
                }
              }
            }
          }
          self.taxesPerLocation = taxesPerLocation;
        }
      });
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      pickerOptions1: {},
      tabIndex: 0,
      taxes: [],
      taxesPerLocation: [],
      activeNames: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      modelValidate: {
        'available_days': { required: true },
        'required': { required: true }
      },
      paymentOptions: [{
        'payment_id': 'credit_card',
        'name': this.$t('paymentTypes.CARD')
      }, {
        'payment_id': 'cash',
        'name': this.$t('paymentTypes.CASH')
      }],
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      newLocation: {
        street: '',
        city: '',
        state: '',
        country: ''
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true
    };
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.currency);
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();
      _this.loading = false;

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.errors.clear();
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveDetails();
        } else {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.model.locations_details), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var bussLocation = _step.value;
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(bussLocation.ordering_management), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var order = _step2.value;

                  var tabTtl = bussLocation.id + order.type;
                  if (order.enabled && _this2.errors.items.length) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.errors.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var err = _step3.value;

                        if (err.field.includes(tabTtl)) {
                          _this2.activeNames.push(tabTtl);
                        }
                      }
                    } catch (err) {
                      _didIteratorError3 = true;
                      _iteratorError3 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                          _iterator3.return();
                        }
                      } finally {
                        if (_didIteratorError3) {
                          throw _iteratorError3;
                        }
                      }
                    }
                  }
                  console.warn(tabTtl);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var self = _this2;
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': self.$t('settingsOrdering.notice'), 'type': 'error' });
        }
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    addNewLocation: function addNewLocation(locId, type) {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = [];
          newRow = self.newLocation;
          newRow.id = response.data[0].id;

          var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details);
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management);

          self.model.locations_details[locIdx].ordering_management[typeIdx].locations.push(newRow);
          console.warn(self.model[typeIdx].locations);
        } else {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    updateTabs: function updateTabs(name, enabled) {
      this.$nextTick(function () {
        if (!enabled) {
          this.activeNames = [name];
        } else {
          this.activeNames = [];
        }
      });
    },
    removeLocation: function removeLocation(locId, idx, type) {

      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management);

      this.model.locations_details[locIdx].ordering_management[typeIdx].locations.splice(idx, 1);
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var currentLocations = [];
      var countries = this.$session.get('defaultData').countries;
      for (var locIdx in this.model.locations_details) {
        var locData = this.copyObject(this.model.locations_details[locIdx]);

        for (var orMngIdx in locData.ordering_management) {
          if (locData.ordering_management[orMngIdx].type === 'meet_half') {
            for (var idx in locData.ordering_management[orMngIdx].locations) {
              var countryIso = locData.ordering_management[orMngIdx].locations[idx].country;
              var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
              var states = [];

              if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
                states = countries[countryIdx].states;
              }

              if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
                var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states);
                if (state !== undefined) {
                  locData.ordering_management[orMngIdx].locations[idx].state = states[state].name;
                } else {
                  locData.ordering_management[orMngIdx].locations[idx].state = null;
                }
              }
              delete locData.ordering_management[orMngIdx].locations[idx].states;
            }
          }
        }
        currentLocations[locIdx] = locData;
      }
      var data = {
        'token': this.$session.get('token'),
        'locations_details': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentLocations),
        'delivery_options_labels': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.delivery_options_labels)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': self.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000 }).catch(function () {});
          self.$session.set('selectedCompanyData', response.data[0]);
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "f9hE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__ = __webpack_require__("mY1+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006bb28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__ = __webpack_require__("R45N");
function injectStyle (ssrContext) {
  __webpack_require__("gk3p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_006bb28f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fOVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.state')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive($event)}},model:{value:(_vm.model.tips_in_use),callback:function ($$v) {_vm.$set(_vm.model, "tips_in_use", $$v)},expression:"model.tips_in_use"}})],1),_vm._v(" "),(_vm.model.tips_in_use)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.tipsTaxes')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.taxes,"value":"id","label":"name"},model:{value:(_vm.model.tips_taxes),callback:function ($$v) {_vm.$set(_vm.model, "tips_taxes", $$v)},expression:"model.tips_taxes"}}),_vm._v(" "),(_vm.errors.has(_vm.model.tips_taxes))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError(_vm.model.tips_taxes))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mar-bt-5"},[_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fUd2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row categories"},[_c('div',{staticClass:"col-lg-9 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info",attrs:{"title":"","to":{ path: 'categories/add'}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogCateg.single')))])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table "},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move"}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('img',{attrs:{"src":(item.image)?item.image : ''}})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-pencil"})])])]})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "flK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCurrency.currency')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{staticClass:"col-md-12",attrs:{"placeholder":" - Select Currency - ","filterable":""},model:{value:(_vm.model.currency_iso),callback:function ($$v) {_vm.$set(_vm.model, "currency_iso", $$v)},expression:"model.currency_iso"}},_vm._l((_vm.currencies),function(cr){return _c('el-option',{key:cr.iso,attrs:{"value":cr.iso,"label":_vm.displayCurrecy(cr)}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3b23d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("6CO4");
function injectStyle (ssrContext) {
  __webpack_require__("O5Cj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3b23d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gK/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);









var _components;







__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    defaultData: {},
    modeldata: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      value.loyalty_value_one_point_amount = Math.round(value.loyalty_value_one_point_amount * 10) / 10;
      this.model = value;
    }
  },
  data: function data() {
    return {
      model: [],
      defaults: this.value || this.defaultData,
      modelValidations: {
        loyalty_value_one_point: { required: true },
        loyalty_value_one_point_amount: { required: true },
        loyalty_value_one_currency: { required: true }
      },
      currency: ''
    };
  },
  created: function created() {
    var currency = this.$session.get('selectedCompanyData').price_details;
    if (currency !== undefined) {
      this.currency = this.decodeHtml(currency.symbol);
    }
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'loyalty_value_one_currency': this.model.loyalty_value_one_currency,
        'loyalty_value_one_point_amount': this.model.loyalty_value_one_point_amount,
        'loyalty_value_one_point': this.model.loyalty_value_one_point
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', response.data[0]);
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    handleActive: function handleActive(e) {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'loyalty_in_use': this.model.loyalty_in_use ? 1 : 0
      };
      var actionText = this.model.loyalty_in_use ? 'enabled' : 'disabled';
      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.handleErrors(response.errors);
          self.model.loyalty_in_use = !self.model.loyalty_in_use;
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }
      });
    }
  }
});

/***/ }),

/***/ "gSDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__);














__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a),
  data: function data() {
    return {
      pages: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  created: function created() {
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    this.apiRequest('/settings/infopages', 'GET', data, function (response) {
      if (response.status === true) {
        self.pages = response.data;
      }
    });
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.savePage(pageId);
        }
      });
    },
    savePage: function savePage(pageId) {
      console.warn(pageId);
      var thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages);
      var data = this.pages[thisPageIdx];
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      delete data.company;
      var method = 'PUT';
      var linkId = '/' + data.id;

      if (pageId === undefined || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(pageId) && pageId.indexOf('new') === 0) {
        if (data.id) {
          delete data.id;
        }
        method = 'POST';
        linkId = '';
      }
      var self = this;
      this.apiRequest('/settings/infopages' + linkId, method, data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.addedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          if (method === 'POST') {
            self.pages[thisPageIdx].id = response.data[0].id;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    addNewPage: function addNewPage() {
      var newPg = {
        'id': 'new_' + Math.floor(Math.random() * 10000),
        'title': this.$t('settingsInfoPages.newPage'),
        'description': ''
      };
      this.pages.push(newPg);
    },
    deletePage: function deletePage(pageId) {
      var _this2 = this;

      var thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages);

      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('settingsInfoPages.deleteMsg'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(pageId) && pageId.indexOf('new') === 0) {
            _this2.pages.splice(thisPageIdx, 1);
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          } else {
            var id = pageId;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/settings/infopages/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                self.pages.splice(thisPageIdx, 1);
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
              } else {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "gT0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentNoSpacing_vue__ = __webpack_require__("mrs5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c5d28e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentNoSpacing_vue__ = __webpack_require__("yJjF");
function injectStyle (ssrContext) {
  __webpack_require__("Y39F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentNoSpacing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c5d28e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentNoSpacing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gZBb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gk3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h74b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/categories"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('category-form',{on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean, Number],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");







__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        company_id: 8
      },
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        },
        password: {
          required: true,
          min: 6
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.login();
      });
    },
    login: function login() {
      var self = this;
      var creds = {
        email: this.model.email,
        password: this.model.password
      };
      console.warn(self.$session);
      this.apiRequest('/login', 'POST', creds, function (response) {
        if (response.status === true) {
          var usersCompanies = [];
          var hasCompany = false;
          var companies = response.data.user.companies;
          for (var key in companies) {
            if (companies[key].role === 'OWNER') {
              usersCompanies.push(companies[key]);
              hasCompany = true;
            }
          }

          if (!hasCompany) {
            self.errors.add('email', 'Failed to login, please try again.');
          } else {
            self.$session.start();
            self.$session.set('token', response.data.token);
            if (usersCompanies[0].id) {
              self.$session.set('selectedCompany', usersCompanies[0].id);
              self.$session.set('selectedCompanyData', usersCompanies[0]);
              self.$session.set('companyName', usersCompanies[0].name);
              self.$session.set('companyAvatar', response.data.user.avatar);
            } else {
              self.$session.set('selectedCompany', null);
              self.$session.set('selectedCompanyData', null);
              self.$session.set('companyName', null);
              self.$session.set('companyAvatar', null);
              self.$session.set('companyAvatar', null);
            }
            self.$session.set('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user));
            self.$i18n.locale = response.data.user.language;

            self.apiRequest('/listdefaults', 'GET', { token: response.data.token }, function (response) {
              if (response.status === true) {
                self.$session.set('defaultData', response.data[0]);
              }

              self.$router.push('/');
            });
          }
        } else {
          console.warn(response.errors);
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              console.warn(prop);
              self.errors.add(prop, response.errors[prop]);
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "hZ/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      model: {
        email: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.recover();
        }
      });
    },
    recover: function recover() {
      var self = this;
      var creds = {
        email: this.model.email,
        company_id: -1
      };

      this.apiRequest('/recover', 'POST', creds, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', response.data['message'] ? response.data['message'] : 'Please check your email adreess to get the reset code.', 'success').catch({});

          self.$router.push('/reset');
        } else {
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              console.warn(prop);
              self.errors.add(prop, response.errors[prop]);
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "hvya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-bars-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Bar' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions).on('draw', function (data) {
        if (data.type === 'bar') {
          data.element.attr({
            style: 'stroke-width: 30px'
          });
        }
      });
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "i2PC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");











__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a),
  props: {
    defaultData: {},
    modeldata: {
      type: [Object, Array],
      required: true
    }
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      console.warn(this.days);


      this.model = value;

      this.errors.clear();

      this.$nextTick(function () {});
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      modelValidate: {
        timezone: { required: true },
        time_format: { required: true },
        date_format: { required: true }
      },
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      loading: false
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
          console.warn(this.errors);
        }
      }
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'timezone': this.model.timezone,
        'date_format': this.model.date_format,
        'time_format': this.model.time_format
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({ 'text': self.$t('settingDateTime.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.handleErrors(response.errors);
        }
      });
    }
  }
});

/***/ }),

/***/ "iFs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9 col-md-12 col-sm-12"},[_c('div',{staticClass:"pull-left "},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Edit","to":{ path: '/orders/view/123', params: { id: 123 }}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Back")])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"card col-lg-9 col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('form',[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-bt-15"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.formatDateTime(_vm.order.created_date)))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('el-time-select',{staticClass:"in-inline",attrs:{"type":"time","value":_vm.order.pickup_time,"placeholder":""},model:{value:(_vm.order.pickup_time),callback:function ($$v) {_vm.$set(_vm.order, "pickup_time", $$v)},expression:"order.pickup_time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.type),expression:"order.type"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"group"}},[_vm._v("Group")]),_vm._v(" "),_c('option',{attrs:{"value":"sigle"}},[_vm._v("Sigle")])])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.payment.id),expression:"order.payment.id"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order.payment, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"card"}},[_vm._v("Card")]),_vm._v(" "),_c('option',{attrs:{"value":"cash"}},[_vm._v("Cash on delivery")])])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.delivery.id),expression:"order.delivery.id"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order.delivery, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.deliveryMethods),function(del){return _c('option',{domProps:{"value":del.id}},[_vm._v(_vm._s(del.type))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-bt-15"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('el-select',{attrs:{"name":"customer","filterable":""},model:{value:(_vm.order.customer.id),callback:function ($$v) {_vm.$set(_vm.order.customer, "id", $$v)},expression:"order.customer.id"}},[_c('el-option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.customers),function(cust){return _c('el-option',{key:cust.id,attrs:{"value":cust.id,"label":cust.name}},[_vm._v(_vm._s(cust.name))])})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_vm._l((_vm.order.address),function(address){return _c('div',{staticClass:"col-md-6 pad-bt-15"},[_c('h6',[_c('i',{staticClass:"ti-world"}),_vm._v(" "+_vm._s(_vm._f("capitalize")(address.type))+" Address")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 pad-bt-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(address.street),expression:"address.street"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.street),expression:"modelValidations.street"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":"Street"},domProps:{"value":(address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(address, "street", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pad-bt-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(address.city),expression:"address.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"City"},domProps:{"value":(address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(address, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 pad-bt-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(address.country),expression:"address.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"select-primary form-control",attrs:{"name":"country"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCounty(address.type)}]}},_vm._l((_vm.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country}},[_vm._v(_vm._s(country.name)+"\n                ")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 pad-bt-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(address.state),expression:"address.state"}],staticClass:"select-primary form-control",attrs:{"name":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.states[address.type]),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state}},[_vm._v(_vm._s(state)+"\n                ")])})],2)])])])}),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-bt-15"},[_vm._m(8),_vm._v(" "),_c('hr'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.comments),expression:"order.comments"}],staticClass:"form-control",domProps:{"value":(_vm.order.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "comments", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._m(9),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(10),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.products),function(customer){return [(_vm.order.type=='group')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"5"}},[_vm._v("Customer: "+_vm._s(customer.customer.name))])]):_vm._e(),_vm._v(" "),_vm._l((customer.items),function(prod){return _c('tr',[_c('td',[_vm._v("\n                    "+_vm._s(prod.name)+"\n                    "),_c('ul',{directives:[{name:"id",rawName:"v-id",value:(prod.options),expression:"prod.options"}]},_vm._l((prod.options),function(opt){return _c('li',[_vm._v("\n                        "+_vm._s(opt.name)),(opt.price>0)?_c('span',[_vm._v(" +"+_vm._s(_vm.formatMoneyAmount(opt.price, _vm.order.currency)))]):_vm._e()])})),_vm._v(" "),_c('span',{},[_c('i',[_vm._v(_vm._s(prod.additional_info))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.price, _vm.order.currency)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.quantity * prod.price, _vm.order.currency)))]),_vm._v(" "),_vm._m(11,true)])})]}),_vm._v(" "),_vm._l((_vm.order.totals),function(total,label){return [_c('tr',{class:_vm.getRowClass(label)},[_c('td',{staticStyle:{"border-top":"0px solid black"}}),_vm._v(" "),_c('td',{staticStyle:{"border-top":"0px solid black"}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(label)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(total, _vm.order.currency)))])]),_vm._v(" "),_c('td')])]})],2)])]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Person")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.person),expression:"modelValidations.person"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.person),expression:"modelProduct.person"}],staticClass:"form-control",attrs:{"type":"text","name":"person","placeholder":""},domProps:{"value":(_vm.modelProduct.person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "person", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Product\n            ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.product),expression:"modelValidations.product"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.product),expression:"modelProduct.product"}],staticClass:"form-control",attrs:{"name":"product"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modelProduct, "product", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- products -")]),_vm._v(" "),_vm._l((_vm.productsAll),function(prod){return _c('option',{ref:"productOpt",refInFor:true,domProps:{"value":prod.product_id}},[_vm._v(_vm._s(prod.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelProduct.quantity),expression:"modelProduct.quantity"}],staticClass:"form-control",attrs:{"type":"number","name":"quantity","value":"1","placeholder":""},domProps:{"value":(_vm.modelProduct.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 pad-to-5"},[_c('label'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info ",on:{"click":function($event){$event.preventDefault();_vm.addProduct()}}},[_vm._v("Add")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pad-bt-15"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Coupon code")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.person),expression:"modelValidations.person"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.person),expression:"modelProduct.person"}],staticClass:"form-control",attrs:{"type":"text","name":"person","placeholder":""},domProps:{"value":(_vm.modelProduct.person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "person", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-info ",on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Apply")])])])])]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"clearfix"})],2)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_c('i',{staticClass:"ti-shopping-cart"}),_vm._v(" Order Details")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Order made at")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Order pickup time")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Type")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Payment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Delivery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_c('i',{staticClass:"ti-user"}),_vm._v(" Customer Details")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Customer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',[_c('i',{staticClass:"ti-comment"}),_vm._v(" Customer Comments")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h4',[_vm._v("Products")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Qty")]),_vm._v(" "),_c('th',[_vm._v("Unit Price")]),_vm._v(" "),_c('th',[_vm._v("Total")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{staticClass:"ti-close text-danger",attrs:{"title":"Remove"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-to-15"},[_c('h6',[_c('i',{staticClass:"ti-plus"}),_vm._v(" ADD PRODUCT(S)")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12 pad-to-15"},[_c('h6',[_vm._v("% Apply coupon")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-bt-15 pad-to-15"},[_c('a',{staticClass:"btn btn-info",attrs:{"href":"","title":"Save"}},[_vm._v(" Update Order")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iK4j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.body.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"body":true,"lock":true}}],staticClass:"main-panel",attrs:{"id":"mainContainer"}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iUyg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c285e5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("S3AV");
function injectStyle (ssrContext) {
  __webpack_require__("oreA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c285e5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jAzQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jkt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__ = __webpack_require__("2mRZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ec4e00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__ = __webpack_require__("wRw/");
function injectStyle (ssrContext) {
  __webpack_require__("0rqh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ec4e00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54407b02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("XWiO");
function injectStyle (ssrContext) {
  __webpack_require__("+ZBl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54407b02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cad6fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("IERb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cad6fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__ = __webpack_require__("41va");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OffersForm', __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      offerModel: {},
      offer: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "koIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);












var _components;










__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse_item___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  created: function created() {
    this.locations = this.$session.get('selectedCompanyData').locations_details;
    if (this.locations.length > 1) {
      this.showLocations = true;
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.model.trends.location = filterCookie[0];
      }
    }

    this.getData();

    this.filters[3]['value'] = [this.model.trends.valid[0], this.model.trends.valid[1]];
  },
  data: function data() {
    var _this = this;

    return {
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      model: {
        trends: {
          'valid': [__WEBPACK_IMPORTED_MODULE_16_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_16_moment___default()().endOf('month').format('YYYY-MM-DD')],
          location: ''
        }
      },
      locations: [],
      showLocations: false,
      selectedLocation: '',
      todaysDate: this.currentDate(),
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      filters: [{
        default: 'Select gender',
        value: '',
        filterFn: function filterFn(row, filter) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            if (row.gender.toLowerCase() === filter.value.toLowerCase()) {
              return filter.value;
            }
          });
        }
      }, {
        value: '',
        filterFn: function filterFn(row, filter) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            var age = _this.getAge(row.birthdate);
            switch (filter.value) {
              case '20':
                if (age < 20) {
                  return row;
                }
                break;
              case '20-30':
                if (age >= 20 && age <= 30) {
                  return row;
                }
                break;
              case '30-40':
                if (age >= 30 && age <= 40) {
                  return row;
                }
                break;
              case '40-50':
                if (age >= 40 && age <= 50) {
                  return row;
                }
                break;
              case '50+':
                if (age > 50) {
                  return row;
                }
                break;
            }
          });
        }
      }, {
        value: '',
        prop: 'location'
      }, {
        value: [],
        filterFn: function filterFn(row, filter) {
          var date1 = __WEBPACK_IMPORTED_MODULE_16_moment___default()(filter.value[0]).format('X');
          var date2 = __WEBPACK_IMPORTED_MODULE_16_moment___default()(filter.value[1]).format('X');
          var installedDate = row.created_at ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(row.created_at).format('X') : '';
          var productDate = row.date ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(row.date).format('X') : '';
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            if (installedDate >= date1 && installedDate <= date2) {
              return row;
            }
            if (productDate >= date1 && productDate <= date2) {
              return row;
            }
          });
        }
      }],
      paginationDef: {
        pageSize: 99999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions1: {},
      activeName: 'first',
      productsTableData: [],
      campaignsTableData: [],
      clientsTableData: [],
      clientsExportData: [],
      ordersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '200px'
        }
      },
      customersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '200px'
        }
      },
      salesChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '300px',
          axisX: {
            showGrid: false
          }
        }
      },
      deliveryChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '300px',
          axisX: {
            showGrid: false
          }
        }
      },
      ageChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px'
        }
      },
      genderChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px'
        }
      }
    };
  },

  methods: {
    getData: function getData() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.model.trends.valid[0],
        end_date: this.model.trends.valid[1]
      };
      if (this.model.trends.location && this.model.trends.location !== '') {
        data.location_id = this.model.trends.location;
      }
      self.loading = true;
      this.apiRequest('/reports/trends', 'GET', data, function (response) {
        if (response.status === true) {
          self.ordersChart.data.labels = response.data.orders.labels;
          self.ordersChart.data.series = [response.data.orders.delivered];
          self.ordersChart.title = self.$t('reports.total') + ' ' + response.data.counters.total_orders;

          self.$refs.refOrdersChart.initChart();

          self.customersChart.data.labels = response.data.customers.labels;
          self.customersChart.data.series = [response.data.customers.values];
          self.customersChart.title = self.$t('reports.total') + ' ' + response.data.counters.customers;
          self.$refs.customersChart.initChart();

          self.salesChart.data.labels = response.data.sales.labels;
          self.salesChart.data.series = [response.data.sales.values];
          self.salesChart.title = self.$t('reports.total') + ' ' + response.data.counters.revenue;
          self.$refs.salesChart.initChart();

          self.topProdsChart.data.labels = response.data.top_products['labels'];
          self.topProdsChart.data.series = [response.data.top_products['values']];
          self.$refs.topProdsChart.initChart();

          self.deliveryChart.data.labels = response.data.delivery_types.labels;
          self.deliveryChart.data.series = [response.data.delivery_types.values];
          self.$refs.deliveryChart.initChart();

          var customersAgeLb = [];
          if (response.data.customers_age.labels.length) {
            customersAgeLb = response.data.customers_age.labels.map(function (val) {
              val = self.$t('reportsAgesGroups.' + val);
              return val;
            });
          }
          self.ageChart.data.labels = customersAgeLb;
          self.ageChart.data.series = response.data.customers_age.series;
          if (response.data.customers_age.labels.length) {
            self.$refs.ageChart.initChart();
          }

          var customersGenderLb = [];
          if (response.data.customers_gender.labels.length) {
            customersGenderLb = response.data.customers_gender.labels.map(function (val) {
              val = self.$t('gender.' + val);
              return val;
            });
          }
          console.warn(self.$refs);
          self.genderChart.data.labels = customersGenderLb;
          self.genderChart.data.series = response.data.customers_gender.series;
          if (response.data.customers_gender.labels.length) {
            self.$refs.genderChart.initChart();
          }

          self.productsTableData = response.data.products;
          self.campaignsTableData = response.data.marketing;
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });

      this.apiRequest('/customer', 'GET', data, function (response) {
        if (response.status === true) {
          console.log(response.data);
          self.clientsTableData = response.data;

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var customer = _step.value;

              self.clientsExportData.push({
                'FirstName': customer.firstname,
                'LastName': customer.lastname,
                'Email': customer.email,
                'Phone': customer.phone,
                'Gender': customer.gender,
                'Birthdate': customer.birthdate,
                'Sales': self.formatMoneyAmount(customer.sales, '')
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getData();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.model.trends.location]), 1);
    },
    goToRecordCustomer: function goToRecordCustomer(row, event, column) {
      this.globalGoToRecord(row, event, column, '/reports/customer/');
    },
    daysBetween: function daysBetween(date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24;
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();
      var differenceMs = date2Ms - date1Ms;
      return Math.round(differenceMs / oneDay);
    },
    firstDayofMonth: function firstDayofMonth() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    },
    lastDayofMonth: function lastDayofMonth() {
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    tabClicked: function tabClicked(selectedTab) {
      console.warn('test');
      console.warn('Current tab re-clicked:' + selectedTab.tab.title);
    },
    tabChanged: function tabChanged(selectedTab) {
      console.warn('Tab changed to:' + selectedTab.tab.title);
    }
  }
});

/***/ }),

/***/ "kpnw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentNoSpacing_vue__ = __webpack_require__("gT0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);













__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_5__ContentNoSpacing_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fullscreenLoading: false,
      rName: this.$route.name
    };
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),

/***/ "kzgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__ = __webpack_require__("i2PC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddfeb236_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__ = __webpack_require__("3HHx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddfeb236_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lX1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("8yVT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135b7627_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("8TJq");
function injectStyle (ssrContext) {
  __webpack_require__("iUyg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135b7627_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ln6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.notif')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_vm._l((_vm.campaignsNotificationTypes),function(type,key){return _c('p-checkbox',{key:key,attrs:{"label":key,"inline":true,"name":"notification_type"},on:{"input":_vm.validate},model:{value:(_vm.model.notification_types_array[key]),callback:function ($$v) {_vm.$set(_vm.model.notification_types_array, key, $$v)},expression:"model.notification_types_array[key]"}},[_vm._v(_vm._s(_vm.$t('campaignsNotificationTypes.' + key)))])}),_vm._v(" "),(_vm.errors.has('notification_type'))?_c('small',{staticClass:"text-danger",staticStyle:{"display":"block"}},[_vm._v("\n          "+_vm._s(_vm.getError('notification_type'))+"\n        ")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-1 inline-auto pad-rg-0"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label inline"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.model')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.mode),expression:"model.mode"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.mode),expression:"modelValidations.mode"}],staticClass:"form-control notof-mode",attrs:{"placeholder":"Model","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.select'))+" - ")]),_vm._v(" "),_vm._l((_vm.campaignsModes),function(type,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(_vm.$t('campaignsModes.' + key)))])})],2)])]),_vm._v(" "),(_vm.model.mode == 'AUTO')?_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.setHours')))]),_vm._v(" "),_c('hr',{staticClass:"sm mar-to-0 mar-bt-0"}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model.notification_times_array),function(dayData){return _c('div',{staticClass:"col-md-4 col-sm-4 col-xs-12 padd"},[_c('p-checkbox',{key:dayData.day,staticClass:"text-purple",attrs:{"label":dayData.day},model:{value:(dayData.checked),callback:function ($$v) {_vm.$set(dayData, "checked", $$v)},expression:"dayData.checked"}},[_vm._v(_vm._s(_vm._f("capitalize")(dayData.day)))]),_vm._v(" "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.time),expression:"modelValidations.time"}],attrs:{"disabled":!dayData.checked,"placeholder":_vm.$t('marketingCampaigns.selectTime'),"value":dayData.hour_from,"picker-options":_vm.pickerOptions},model:{value:(dayData.hour_from),callback:function ($$v) {_vm.$set(dayData, "hour_from", $$v)},expression:"dayData.hour_from"}})],1)}))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqCJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvv9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m0L1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Customers_states__ = __webpack_require__("myZ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoading: true
  },
  data: function data() {
    return {
      apiResponse: [],
      statesData: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Customers_states__["a" /* default */]
    };
  },

  methods: {
    getAppIsLoading: function getAppIsLoading() {
      return this.isLoading;
    },
    setAppIsLoading: function setAppIsLoading(newVal) {
      this.isLoading = newVal;
    },
    apiRequest: function apiRequest() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/hello';
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

      var _this = this;

      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var callback = arguments[3];

      var authToken = '';
      if (data.token) {
        authToken = 'Bearer ' + data.token;
      } else {
        authToken = '';
      }
      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*',
        'Authorization': authToken
      };

      var instance = this.axios.create({
        baseURL: "https://gateway.taptasty.com/",
        timeout: 90000,
        headers: apiRequestHeader
      });

      switch (method) {
        case 'GET':
          instance.get(url, { params: data }).then(function (response) {
            if (response.data.status === false && response.data.errors.error === 'Token has expired') {
              _this.logout();
            } else {
              callback(response.data);
            }
          });

          break;
        case 'POST':
          instance.post(url, data).then(function (response) {
            if (response.data.status === false && response.data.errors.error === 'Token has expired') {
              _this.logout();
            } else {
              callback(response.data);
            }
          });
          break;
        case 'PUT':
          instance.put(url, data).then(function (response) {
            if (response.data.status === false && response.data.errors.error === 'Token has expired') {
              _this.logout();
            } else {
              callback(response.data);
            }
          });
          break;
        case 'DELETE':
          instance.delete(url, data).then(function (response) {
            if (response.data.status === false && response.data.errors.error === 'Token has expired') {
              _this.logout();
            } else {
              callback(response.data);
            }
          });
          break;
      }
    },
    logout: function logout() {
      this.$session.destroy();
      this.$router.push('/login');
      this.$i18n.locale = 'en';
    },
    getCompanyDetail: function getCompanyDetail(key) {
      var companyID = this.$session.get('selectedCompany');

      var companyDetails = this.$session.get('selectedCompanyData');

      switch (key) {
        case 'currency':
          return companyDetails.currency_iso;
        case 'currency_display_format':
          return companyDetails.currency_display_format;
        case 'time_format':
        case 'date_format':
          return companyDetails[key];
      }

      return '';
    },
    formatMoneyAmount: function formatMoneyAmount(amount) {
      var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var removezero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (currency === '') {
        currency = this.getCompanyDetail('currency');
      }
      var position = this.getCurrencyPosition(currency);
      currency = this.getCurrencySymbol(currency);
      var space = ' ';

      if (removezero && amount % 1 === 0) {
        amount = Math.abs(amount);
      }


      if (position === 'left') {
        return currency + amount;
      } else {
        return amount + space + currency;
      }
    },
    getTimeFormat: function getTimeFormat() {
      var format = this.getCompanyDetail('time_format');
      var formatTime = format !== '' ? format : 'H:mm';
      return formatTime;
    },
    formatTime: function formatTime(value) {
      if (value) {
        var format = this.getCompanyDetail('time_format');
        var formatTime = format !== '' ? format : 'H:mm';
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(value)).format(formatTime);
      }
    },
    formatDate: function formatDate(value) {
      if (value) {
        var format = this.getCompanyDetail('date_format');
        var formatDate = format !== '' ? format : 'DD/MM/YYYY';
        var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(value)).format(formatDate);
        return date;
      }
    },
    formatDateTime: function formatDateTime(value) {
      if (value) {
        var format1 = this.getCompanyDetail('time_format');
        var format2 = this.getCompanyDetail('date_format');
        var format = format1 + ' ' + format2;
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(value)).format(format);
      }
    },
    limitChars: function limitChars(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      } else {
        return text;
      }
    },
    getObjectByElemKeyValue: function getObjectByElemKeyValue(key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return index;
        }
      }
      return false;
    },
    getObjectByElemKeyValueBool: function getObjectByElemKeyValueBool(key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return true;
        }
      }
      return false;
    },
    isInObject: function isInObject(value, object) {
      for (var index in object) {
        if (parseInt(object[index]) === parseInt(value)) {
          return true;
        }
      }
      return false;
    },
    globalGoToRecord: function globalGoToRecord(row, event, column) {
      var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      if (column.property !== 'actions' && column.property !== 'active') {
        this.$router.push(baseUrl + row.id);
      }
    },
    defaultActionDef: function defaultActionDef() {
      return {
        show: false,
        colProps: {
          span: 0
        },
        def: []
      };
    },
    defaultSearchDef: function defaultSearchDef() {
      return {
        colProps: {
          span: 14
        }
      };
    },
    orderStatusClass: function orderStatusClass(type) {
      switch (type) {
        case 'DELIVERED':
          return 'success';
        case 'CANCELED':
          return 'danger';
        case 'NOT_DELIVERED':
          return 'danger';
        case 'NEW':
          return 'info';
        case 'PROCESSING':
          return 'warning';
        case 'AWAITING_TRANSPORT':
          return 'info';
        case 'TRANSPORT':
          return 'info';
        default:
          return 'primary';
      }
    },
    orderStatusAllowed: function orderStatusAllowed(currentSts, otherSts) {
      switch (currentSts) {
        case 'NEW':
          if (otherSts === 'NEW' || otherSts === 'PROCESSING' || otherSts === 'CANCELED') {
            return true;
          } else {
            return false;
          }
        default:
          return true;
      }
    },
    feedbackTypeClass: function feedbackTypeClass(type) {
      switch (type) {
        case 'feedback':
          return 'success';
        case 'issue':
          return 'danger';
        case 'suggestion':
          return 'warning';
        default:
          return 'info';
      }
    },
    getBase64: function getBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    getCoutryStates: function getCoutryStates(country) {
      var countryArr = this.statesData.countries;
      var stateArr = this.statesData.states;
      var index = 0;
      var i = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(countryArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var name = _step.value;

          i++;
          if (name === country) {
            index = i;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var states = stateArr[index].split('|');

      return states;
    },
    getDaysLeft: function getDaysLeft(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      var timeDiff = date1.getTime() - date2.getTime();
      var diffDays = timeDiff / (1000 * 3600 * 24);

      return diffDays > 0 ? Math.ceil(diffDays) : 0;
    },
    copyObject: function copyObject(o) {
      var output, v, key;
      output = {};
      for (key in o) {
        v = o[key];
        output[key] = (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v)) === 'object' ? this.copyObject(v) : v;
      }
      return output;
    },
    removeErrorByName: function removeErrorByName(name, errors) {
      var returnErr = [];
      if (errors.length) {
        for (var idx in errors) {
          if (errors[idx]['field'] !== name) {
            returnErr.push(errors[idx]);
          }
        }
      }
      return returnErr;
    },
    getAge: function getAge(birthdate) {
      var timestamp = Math.floor(new Date().getTime() / 1000);
      return Math.floor((timestamp - __WEBPACK_IMPORTED_MODULE_4_moment___default()(birthdate).format('X')) / 31556926);
    },
    getCurrencyPosition: function getCurrencyPosition(iso) {
      var currencies = this.$session.get('defaultData')['currencies'];
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies);

      return currencies[currency]['symbol_position'] ? currencies[currency]['symbol_position'] : 'right';
    },
    getCurrencySymbol: function getCurrencySymbol(iso) {
      var currencies = this.$session.get('defaultData')['currencies'];
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies);

      if (!currency) {
        return iso;
      }

      return currencies[currency]['symbol'] ? this.decodeHtml(currencies[currency]['symbol']) : iso;
    },
    decodeHtml: function decodeHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }
});

/***/ }),

/***/ "mG7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mY1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  watch: {},
  computed: {},
  data: function data() {
    var _this = this;

    return {
      loading: true,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: this.$t('general.delete')
        }]
      },
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['name', 'status', 'type']
      }]
    };
  },

  created: function created() {
    var self = this;
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.apiRequest('/campaign', 'GET', data, function (response) {
      if (response.status === true) {
        self.tableData = response.data;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
  },
  methods: {
    goToRecord: function goToRecord(row, event, column) {
      if (column.property !== 'actions' && column.property !== 'active') {
        this.globalGoToRecord(row, event, column, '/marketing/campaigns/edit/');
      }
    },
    handleActive: function handleActive(index, row, e) {
      var _this2 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany'),

            name: row.name,
            type: row.type,
            mode: row.mode,
            notification_type: row.notification_type[0].type,
            active: row.active ? 1 : 0
          };
          var self = _this2;
          _this2.apiRequest('/campaign/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    sendNotif: function sendNotif(index, row) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('marketingCampaigns.areYouSureNotif'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        _this3.$nextTick(function () {
          this.loading = true;
        });
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            campaign_id: row.id
          };
          var self = _this3;
          _this3.apiRequest('/queues/notifications', 'POST', data, function (response) {
            self.$nextTick(function () {
              this.loading = false;
            });
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('marketingCampaigns.notifSent'), 'success').catch(function () {});
            } else {
              var msg = self.$t('validations.wentWrong');
              if (response.errors.campaign_id !== undefined) {
                msg = response.errors.campaign_id;
              }
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', msg, 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    handleDelete: function handleDelete(index, row) {
      var _this4 = this;

      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('marketingCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this4.$session.get('token'),
            company_id: _this4.$session.get('selectedCompany')
          };
          _this4.apiRequest('/campaign/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('marketingCampaigns.campaignDeleted'), 'success').catch(function () {});
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "mby7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731cbeac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("wi/z");
function injectStyle (ssrContext) {
  __webpack_require__("Zflh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731cbeac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mhKA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mjPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPieCard_vue__ = __webpack_require__("uWep");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1318c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPieCard_vue__ = __webpack_require__("5FCe");
function injectStyle (ssrContext) {
  __webpack_require__("4Tim")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPieCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1318c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPieCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mrs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "mvUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"info-pages"},[_c('el-collapse',{attrs:{"accordion":""}},[(_vm.pages.length == 0)?_c('p',{staticClass:"pull-left pad-to-15"},[_vm._v(_vm._s(_vm.$t('settingsInfoPages.noPage')))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_vm._l((_vm.pages),function(page){return [_c('el-collapse-item',{attrs:{"title":_vm.$t('settingsInfoPages.' + page.type),"name":page.id}},[_c('label',{staticClass:"pad-to-10"},[_vm._v(_vm._s(_vm.$t('settingsInfoPages.content')))]),_vm._v(" "),_c('wysiwyg',{model:{value:(page.description),callback:function ($$v) {_vm.$set(page, "description", $$v)},expression:"page.description"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill mar-to-10",on:{"click":function($event){$event.preventDefault();_vm.validate(page.id)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1)]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "myZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countries = ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Angola', 'Anguilla', 'Antartica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Ashmore and Cartier Island', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Clipperton Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo, Democratic Republic of the', 'Congo, Republic of the', 'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czeck Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Europa Island', 'Falkland Islands (Islas Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern and Antarctic Lands', 'Gabon', 'Gambia, The', 'Gaza Strip', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Glorioso Islands', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City)', 'Honduras', 'Hong Kong', 'Howland Island', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Ireland, Northern', 'Israel', 'Italy', 'Jamaica', 'Jan Mayen', 'Japan', 'Jarvis Island', 'Jersey', 'Johnston Atoll', 'Jordan', 'Juan de Nova Island', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia, Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Man, Isle of', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Midway Islands', 'Moldova', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcaim Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Scotland', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and South Sandwich Islands', 'Spain', 'Spratly Islands', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Tobago', 'Toga', 'Tokelau', 'Tonga', 'Trinidad', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'USA', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands', 'Wales', 'Wallis and Futuna', 'West Bank', 'Western Sahara', 'Yemen', 'Yugoslavia', 'Zambia', 'Zimbabwe'];

var states = [];
states[0] = '';
states[1] = 'Badakhshan|Badghis|Baghlan|Balkh|Bamian|Farah|Faryab|Ghazni|Ghowr|Helmand|Herat|Jowzjan|Kabol|Kandahar|Kapisa|Konar|Kondoz|Laghman|Lowgar|Nangarhar|Nimruz|Oruzgan|Paktia|Paktika|Parvan|Samangan|Sar-e Pol|Takhar|Vardak|Zabol';
states[2] = 'Berat|Bulqize|Delvine|Devoll (Bilisht)|Diber (Peshkopi)|Durres|Elbasan|Fier|Gjirokaster|Gramsh|Has (Krume)|Kavaje|Kolonje (Erseke)|Korce|Kruje|Kucove|Kukes|Kurbin|Lezhe|Librazhd|Lushnje|Malesi e Madhe (Koplik)|Mallakaster (Ballsh)|Mat (Burrel)|Mirdite (Rreshen)|Peqin|Permet|Pogradec|Puke|Sarande|Shkoder|Skrapar (Corovode)|Tepelene|Tirane (Tirana)|Tirane (Tirana)|Tropoje (Bajram Curri)|Vlore';
states[3] = 'Adrar|Ain Defla|Ain Temouchent|Alger|Annaba|Batna|Bechar|Bejaia|Biskra|Blida|Bordj Bou Arreridj|Bouira|Boumerdes|Chlef|Constantine|Djelfa|El Bayadh|El Oued|El Tarf|Ghardaia|Guelma|Illizi|Jijel|Khenchela|Laghouat|M\'\'Sila|Mascara|Medea|Mila|Mostaganem|Naama|Oran|Ouargla|Oum el Bouaghi|Relizane|Saida|Setif|Sidi Bel Abbes|Skikda|Souk Ahras|Tamanghasset|Tebessa|Tiaret|Tindouf|Tipaza|Tissemsilt|Tizi Ouzou|Tlemcen';
states[4] = 'Eastern|Manu\'a|Rose Island|Swains Island|Western';
states[5] = 'Andorra la Vella|Bengo|Benguela|Bie|Cabinda|Canillo|Cuando Cubango|Cuanza Norte|Cuanza Sul|Cunene|Encamp|Escaldes-Engordany|Huambo|Huila|La Massana|Luanda|Lunda Norte|Lunda Sul|Malanje|Moxico|Namibe|Ordino|Sant Julia de Loria|Uige|Zaire';
states[6] = 'Anguilla';
states[7] = 'Antartica';
states[8] = 'Barbuda|Redonda|Saint George|Saint John|Saint Mary|Saint Paul|Saint Peter|Saint Philip';
states[9] = 'Antartica e Islas del Atlantico Sur|Buenos Aires|Buenos Aires Capital Federal|Catamarca|Chaco|Chubut|Cordoba|Corrientes|Entre Rios|Formosa|Jujuy|La Pampa|La Rioja|Mendoza|Misiones|Neuquen|Rio Negro|Salta|San Juan|San Luis|Santa Cruz|Santa Fe|Santiago del Estero|Tierra del Fuego|Tucuman';
states[10] = 'Aragatsotn|Ararat|Armavir|Geghark\'unik\'|Kotayk\'|Lorri|Shirak|Syunik\'|Tavush|Vayots\' Dzor|Yerevan';
states[11] = 'Aruba';
states[12] = 'Ashmore and Cartier Island';
states[13] = 'Australian Capital Territory|New South Wales|Northern Territory|Queensland|South Australia|Tasmania|Victoria|Western Australia';
states[14] = 'Burgenland|Kaernten|Niederoesterreich|Oberoesterreich|Salzburg|Steiermark|Tirol|Vorarlberg|Wien';
states[15] = 'Abseron Rayonu|Agcabadi Rayonu|Agdam Rayonu|Agdas Rayonu|Agstafa Rayonu|Agsu Rayonu|Ali Bayramli Sahari|Astara Rayonu|Baki Sahari|Balakan Rayonu|Barda Rayonu|Beylaqan Rayonu|Bilasuvar Rayonu|Cabrayil Rayonu|Calilabad Rayonu|Daskasan Rayonu|Davaci Rayonu|Fuzuli Rayonu|Gadabay Rayonu|Ganca Sahari|Goranboy Rayonu|Goycay Rayonu|Haciqabul Rayonu|Imisli Rayonu|Ismayilli Rayonu|Kalbacar Rayonu|Kurdamir Rayonu|Lacin Rayonu|Lankaran Rayonu|Lankaran Sahari|Lerik Rayonu|Masalli Rayonu|Mingacevir Sahari|Naftalan Sahari|Naxcivan Muxtar Respublikasi|Neftcala Rayonu|Oguz Rayonu|Qabala Rayonu|Qax Rayonu|Qazax Rayonu|Qobustan Rayonu|Quba Rayonu|Qubadli Rayonu|Qusar Rayonu|Saatli Rayonu|Sabirabad Rayonu|Saki Rayonu|Saki Sahari|Salyan Rayonu|Samaxi Rayonu|Samkir Rayonu|Samux Rayonu|Siyazan Rayonu|Sumqayit Sahari|Susa Rayonu|Susa Sahari|Tartar Rayonu|Tovuz Rayonu|Ucar Rayonu|Xacmaz Rayonu|Xankandi Sahari|Xanlar Rayonu|Xizi Rayonu|Xocali Rayonu|Xocavand Rayonu|Yardimli Rayonu|Yevlax Rayonu|Yevlax Sahari|Zangilan Rayonu|Zaqatala Rayonu|Zardab Rayonu';
states[16] = 'Acklins and Crooked Islands|Bimini|Cat Island|Exuma|Freeport|Fresh Creek|Governor\'s Harbour|Green Turtle Cay|Harbour Island|High Rock|Inagua|Kemps Bay|Long Island|Marsh Harbour|Mayaguana|New Providence|Nicholls Town and Berry Islands|Ragged Island|Rock Sound|San Salvador and Rum Cay|Sandy Point';
states[17] = 'Al Hadd|Al Manamah|Al Mintaqah al Gharbiyah|Al Mintaqah al Wusta|Al Mintaqah ash Shamaliyah|Al Muharraq|Ar Rifa\' wa al Mintaqah al Janubiyah|Jidd Hafs|Juzur Hawar|Madinat \'Isa|Madinat Hamad|Sitrah';
states[18] = 'Barguna|Barisal|Bhola|Jhalokati|Patuakhali|Pirojpur|Bandarban|Brahmanbaria|Chandpur|Chittagong|Comilla|Cox\'s Bazar|Feni|Khagrachari|Lakshmipur|Noakhali|Rangamati|Dhaka|Faridpur|Gazipur|Gopalganj|Jamalpur|Kishoreganj|Madaripur|Manikganj|Munshiganj|Mymensingh|Narayanganj|Narsingdi|Netrokona|Rajbari|Shariatpur|Sherpur|Tangail|Bagerhat|Chuadanga|Jessore|Jhenaidah|Khulna|Kushtia|Magura|Meherpur|Narail|Satkhira|Bogra|Dinajpur|Gaibandha|Jaipurhat|Kurigram|Lalmonirhat|Naogaon|Natore|Nawabganj|Nilphamari|Pabna|Panchagarh|Rajshahi|Rangpur|Sirajganj|Thakurgaon|Habiganj|Maulvi bazar|Sunamganj|Sylhet';
states[19] = 'Bridgetown|Christ Church|Saint Andrew|Saint George|Saint James|Saint John|Saint Joseph|Saint Lucy|Saint Michael|Saint Peter|Saint Philip|Saint Thomas';
states[20] = 'Brestskaya (Brest)|Homyel\'skaya (Homyel\')|Horad Minsk|Hrodzyenskaya (Hrodna)|Mahilyowskaya (Mahilyow)|Minskaya|Vitsyebskaya (Vitsyebsk)';
states[21] = 'Antwerpen|Brabant Wallon|Brussels Capitol Region|Hainaut|Liege|Limburg|Luxembourg|Namur|Oost-Vlaanderen|Vlaams Brabant|West-Vlaanderen';
states[22] = 'Belize|Cayo|Corozal|Orange Walk|Stann Creek|Toledo';
states[23] = 'Alibori|Atakora|Atlantique|Borgou|Collines|Couffo|Donga|Littoral|Mono|Oueme|Plateau|Zou';
states[24] = 'Devonshire|Hamilton|Hamilton|Paget|Pembroke|Saint George|Saint Georges|Sandys|Smiths|Southampton|Warwick';
states[25] = 'Bumthang|Chhukha|Chirang|Daga|Geylegphug|Ha|Lhuntshi|Mongar|Paro|Pemagatsel|Punakha|Samchi|Samdrup Jongkhar|Shemgang|Tashigang|Thimphu|Tongsa|Wangdi Phodrang';
states[26] = 'Beni|Chuquisaca|Cochabamba|La Paz|Oruro|Pando|Potosi|Santa Cruz|Tarija';
states[27] = 'Federation of Bosnia and Herzegovina|Republika Srpska';
states[28] = 'Central|Chobe|Francistown|Gaborone|Ghanzi|Kgalagadi|Kgatleng|Kweneng|Lobatse|Ngamiland|North-East|Selebi-Pikwe|South-East|Southern';
states[29] = 'Acre|Alagoas|Amapa|Amazonas|Bahia|Ceara|Distrito Federal|Espirito Santo|Goias|Maranhao|Mato Grosso|Mato Grosso do Sul|Minas Gerais|Para|Paraiba|Parana|Pernambuco|Piaui|Rio de Janeiro|Rio Grande do Norte|Rio Grande do Sul|Rondonia|Roraima|Santa Catarina|Sao Paulo|Sergipe|Tocantins';
states[30] = 'Anegada|Jost Van Dyke|Tortola|Virgin Gorda';
states[31] = 'Belait|Brunei and Muara|Temburong|Tutong';
states[32] = 'Blagoevgrad|Burgas|Dobrich|Gabrovo|Khaskovo|Kurdzhali|Kyustendil|Lovech|Montana|Pazardzhik|Pernik|Pleven|Plovdiv|Razgrad|Ruse|Shumen|Silistra|Sliven|Smolyan|Sofiya|Sofiya-Grad|Stara Zagora|Turgovishte|Varna|Veliko Turnovo|Vidin|Vratsa|Yambol';
states[33] = 'Bale|Bam|Banwa|Bazega|Bougouriba|Boulgou|Boulkiemde|Comoe|Ganzourgou|Gnagna|Gourma|Houet|Ioba|Kadiogo|Kenedougou|Komandjari|Kompienga|Kossi|Koupelogo|Kouritenga|Kourweogo|Leraba|Loroum|Mouhoun|Nahouri|Namentenga|Naumbiel|Nayala|Oubritenga|Oudalan|Passore|Poni|Samentenga|Sanguie|Seno|Sissili|Soum|Sourou|Tapoa|Tuy|Yagha|Yatenga|Ziro|Zondomo|Zoundweogo';
states[34] = 'Ayeyarwady|Bago|Chin State|Kachin State|Kayah State|Kayin State|Magway|Mandalay|Mon State|Rakhine State|Sagaing|Shan State|Tanintharyi|Yangon';
states[35] = 'Bubanza|Bujumbura|Bururi|Cankuzo|Cibitoke|Gitega|Karuzi|Kayanza|Kirundo|Makamba|Muramvya|Muyinga|Mwaro|Ngozi|Rutana|Ruyigi';
states[36] = 'Banteay Mean Cheay|Batdambang|Kampong Cham|Kampong Chhnang|Kampong Spoe|Kampong Thum|Kampot|Kandal|Kaoh Kong|Keb|Kracheh|Mondol Kiri|Otdar Mean Cheay|Pailin|Phnum Penh|Pouthisat|Preah Seihanu (Sihanoukville)|Preah Vihear|Prey Veng|Rotanah Kiri|Siem Reab|Stoeng Treng|Svay Rieng|Takev';
states[37] = 'Adamaoua|Centre|Est|Extreme-Nord|Littoral|Nord|Nord-Ouest|Ouest|Sud|Sud-Ouest';
states[38] = 'Alberta|British Columbia|Manitoba|New Brunswick|Newfoundland|Northwest Territories|Nova Scotia|Nunavut|Ontario|Prince Edward Island|Quebec|Saskatchewan|Yukon Territory';
states[39] = 'Boa Vista|Brava|Maio|Mosteiros|Paul|Porto Novo|Praia|Ribeira Grande|Sal|Santa Catarina|Santa Cruz|Sao Domingos|Sao Filipe|Sao Nicolau|Sao Vicente|Tarrafal';
states[40] = 'Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western';
states[41] = 'Bamingui-Bangoran|Bangui|Basse-Kotto|Gribingui|Haut-Mbomou|Haute-Kotto|Haute-Sangha|Kemo-Gribingui|Lobaye|Mbomou|Nana-Mambere|Ombella-Mpoko|Ouaka|Ouham|Ouham-Pende|Sangha|Vakaga';
states[42] = 'Batha|Biltine|Borkou-Ennedi-Tibesti|Chari-Baguirmi|Guera|Kanem|Lac|Logone Occidental|Logone Oriental|Mayo-Kebbi|Moyen-Chari|Ouaddai|Salamat|Tandjile';
states[43] = 'Aisen del General Carlos Ibanez del Campo|Antofagasta|Araucania|Atacama|Bio-Bio|Coquimbo|Libertador General Bernardo O\'Higgins|Los Lagos|Magallanes y de la Antartica Chilena|Maule|Region Metropolitana (Santiago)|Tarapaca|Valparaiso';
states[44] = 'Anhui|Beijing|Chongqing|Fujian|Gansu|Guangdong|Guangxi|Guizhou|Hainan|Hebei|Heilongjiang|Henan|Hubei|Hunan|Jiangsu|Jiangxi|Jilin|Liaoning|Nei Mongol|Ningxia|Qinghai|Shaanxi|Shandong|Shanghai|Shanxi|Sichuan|Tianjin|Xinjiang|Xizang (Tibet)|Yunnan|Zhejiang';
states[45] = 'Christmas Island';
states[46] = 'Clipperton Island';
states[47] = 'Direction Island|Home Island|Horsburgh Island|North Keeling Island|South Island|West Island';
states[48] = 'Amazonas|Antioquia|Arauca|Atlantico|Bolivar|Boyaca|Caldas|Caqueta|Casanare|Cauca|Cesar|Choco|Cordoba|Cundinamarca|Distrito Capital de Santa Fe de Bogota|Guainia|Guaviare|Huila|La Guajira|Magdalena|Meta|Narino|Norte de Santander|Putumayo|Quindio|Risaralda|San Andres y Providencia|Santander|Sucre|Tolima|Valle del Cauca|Vaupes|Vichada';

states[49] = 'Anjouan (Nzwani)|Domoni|Fomboni|Grande Comore (Njazidja)|Moheli (Mwali)|Moroni|Moutsamoudou';
states[50] = 'Bandundu|Bas-Congo|Equateur|Kasai-Occidental|Kasai-Oriental|Katanga|Kinshasa|Maniema|Nord-Kivu|Orientale|Sud-Kivu';
states[51] = 'Bouenza|Brazzaville|Cuvette|Kouilou|Lekoumou|Likouala|Niari|Plateaux|Pool|Sangha';
states[52] = 'Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Manuae|Mauke|Mitiaro|Nassau Island|Palmerston|Penrhyn|Pukapuka|Rakahanga|Rarotonga|Suwarrow|Takutea';
states[53] = 'Alajuela|Cartago|Guanacaste|Heredia|Limon|Puntarenas|San Jose';
states[54] = 'Abengourou|Abidjan|Aboisso|Adiake\'|Adzope|Agboville|Agnibilekrou|Ale\'pe\'|Bangolo|Beoumi|Biankouma|Bocanda|Bondoukou|Bongouanou|Bouafle|Bouake|Bouna|Boundiali|Dabakala|Dabon|Daloa|Danane|Daoukro|Dimbokro|Divo|Duekoue|Ferkessedougou|Gagnoa|Grand Bassam|Grand-Lahou|Guiglo|Issia|Jacqueville|Katiola|Korhogo|Lakota|Man|Mankono|Mbahiakro|Odienne|Oume|Sakassou|San-Pedro|Sassandra|Seguela|Sinfra|Soubre|Tabou|Tanda|Tiassale|Tiebissou|Tingrela|Touba|Toulepleu|Toumodi|Vavoua|Yamoussoukro|Zuenoula';
states[55] = 'Bjelovarsko-Bilogorska Zupanija|Brodsko-Posavska Zupanija|Dubrovacko-Neretvanska Zupanija|Istarska Zupanija|Karlovacka Zupanija|Koprivnicko-Krizevacka Zupanija|Krapinsko-Zagorska Zupanija|Licko-Senjska Zupanija|Medimurska Zupanija|Osjecko-Baranjska Zupanija|Pozesko-Slavonska Zupanija|Primorsko-Goranska Zupanija|Sibensko-Kninska Zupanija|Sisacko-Moslavacka Zupanija|Splitsko-Dalmatinska Zupanija|Varazdinska Zupanija|Viroviticko-Podravska Zupanija|Vukovarsko-Srijemska Zupanija|Zadarska Zupanija|Zagreb|Zagrebacka Zupanija';
states[56] = 'Camaguey|Ciego de Avila|Cienfuegos|Ciudad de La Habana|Granma|Guantanamo|Holguin|Isla de la Juventud|La Habana|Las Tunas|Matanzas|Pinar del Rio|Sancti Spiritus|Santiago de Cuba|Villa Clara';
states[57] = 'Famagusta|Kyrenia|Larnaca|Limassol|Nicosia|Paphos';
states[58] = 'Brnensky|Budejovicky|Jihlavsky|Karlovarsky|Kralovehradecky|Liberecky|Olomoucky|Ostravsky|Pardubicky|Plzensky|Praha|Stredocesky|Ustecky|Zlinsky';
states[59] = 'Arhus|Bornholm|Fredericksberg|Frederiksborg|Fyn|Kobenhavn|Kobenhavns|Nordjylland|Ribe|Ringkobing|Roskilde|Sonderjylland|Storstrom|Vejle|Vestsjalland|Viborg';
states[60] = '\'Ali Sabih|Dikhil|Djibouti|Obock|Tadjoura';
states[61] = 'Saint Andrew|Saint David|Saint George|Saint John|Saint Joseph|Saint Luke|Saint Mark|Saint Patrick|Saint Paul|Saint Peter';
states[62] = 'Azua|Baoruco|Barahona|Dajabon|Distrito Nacional|Duarte|El Seibo|Elias Pina|Espaillat|Hato Mayor|Independencia|La Altagracia|La Romana|La Vega|Maria Trinidad Sanchez|Monsenor Nouel|Monte Cristi|Monte Plata|Pedernales|Peravia|Puerto Plata|Salcedo|Samana|San Cristobal|San Juan|San Pedro de Macoris|Sanchez Ramirez|Santiago|Santiago Rodriguez|Valverde';

states[63] = 'Azuay|Bolivar|Canar|Carchi|Chimborazo|Cotopaxi|El Oro|Esmeraldas|Galapagos|Guayas|Imbabura|Loja|Los Rios|Manabi|Morona-Santiago|Napo|Orellana|Pastaza|Pichincha|Sucumbios|Tungurahua|Zamora-Chinchipe';
states[64] = 'Ad Daqahliyah|Al Bahr al Ahmar|Al Buhayrah|Al Fayyum|Al Gharbiyah|Al Iskandariyah|Al Isma\'iliyah|Al Jizah|Al Minufiyah|Al Minya|Al Qahirah|Al Qalyubiyah|Al Wadi al Jadid|As Suways|Ash Sharqiyah|Aswan|Asyut|Bani Suwayf|Bur Sa\'id|Dumyat|Janub Sina\'|Kafr ash Shaykh|Matruh|Qina|Shamal Sina\'|Suhaj';
states[65] = 'Ahuachapan|Cabanas|Chalatenango|Cuscatlan|La Libertad|La Paz|La Union|Morazan|San Miguel|San Salvador|San Vicente|Santa Ana|Sonsonate|Usulutan';
states[66] = 'Annobon|Bioko Norte|Bioko Sur|Centro Sur|Kie-Ntem|Litoral|Wele-Nzas';
states[67] = 'Akale Guzay|Barka|Denkel|Hamasen|Sahil|Semhar|Senhit|Seraye';
states[68] = 'Harjumaa (Tallinn)|Hiiumaa (Kardla)|Ida-Virumaa (Johvi)|Jarvamaa (Paide)|Jogevamaa (Jogeva)|Laane-Virumaa (Rakvere)|Laanemaa (Haapsalu)|Parnumaa (Parnu)|Polvamaa (Polva)|Raplamaa (Rapla)|Saaremaa (Kuessaare)|Tartumaa (Tartu)|Valgamaa (Valga)|Viljandimaa (Viljandi)|Vorumaa (Voru)';
states[69] = 'Adis Abeba (Addis Ababa)|Afar|Amara|Dire Dawa|Gambela Hizboch|Hareri Hizb|Oromiya|Sumale|Tigray|YeDebub Biheroch Bihereseboch na Hizboch';
states[70] = 'Europa Island';
states[71] = 'Falkland Islands (Islas Malvinas)';
states[72] = 'Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar';
states[73] = 'Central|Eastern|Northern|Rotuma|Western';
states[74] = 'Aland|Etela-Suomen Laani|Ita-Suomen Laani|Lansi-Suomen Laani|Lappi|Oulun Laani';
states[75] = 'Alsace|Aquitaine|Auvergne|Basse-Normandie|Bourgogne|Bretagne|Centre|Champagne-Ardenne|Corse|Franche-Comte|Haute-Normandie|Ile-de-France|Languedoc-Roussillon|Limousin|Lorraine|Midi-Pyrenees|Nord-Pas-de-Calais|Pays de la Loire|Picardie|Poitou-Charentes|Provence-Alpes-Cote d\'Azur|Rhone-Alpes';
states[76] = 'French Guiana';
states[77] = 'Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent';
states[78] = 'Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam';
states[79] = 'Estuaire|Haut-Ogooue|Moyen-Ogooue|Ngounie|Nyanga|Ogooue-Ivindo|Ogooue-Lolo|Ogooue-Maritime|Woleu-Ntem';
states[80] = 'Banjul|Central River|Lower River|North Bank|Upper River|Western';
states[81] = 'Gaza Strip';
states[82] = 'Abashis|Abkhazia or Ap\'khazet\'is Avtonomiuri Respublika (Sokhumi)|Adigenis|Ajaria or Acharis Avtonomiuri Respublika (Bat\'umi)|Akhalgoris|Akhalk\'alak\'is|Akhalts\'ikhis|Akhmetis|Ambrolauris|Aspindzis|Baghdat\'is|Bolnisis|Borjomis|Ch\'khorotsqus|Ch\'okhatauris|Chiat\'ura|Dedop\'listsqaros|Dmanisis|Dushet\'is|Gardabanis|Gori|Goris|Gurjaanis|Javis|K\'arelis|K\'ut\'aisi|Kaspis|Kharagaulis|Khashuris|Khobis|Khonis|Lagodekhis|Lanch\'khut\'is|Lentekhis|Marneulis|Martvilis|Mestiis|Mts\'khet\'is|Ninotsmindis|Onis|Ozurget\'is|P\'ot\'i|Qazbegis|Qvarlis|Rust\'avi|Sach\'kheris|Sagarejos|Samtrediis|Senakis|Sighnaghis|T\'bilisi|T\'elavis|T\'erjolis|T\'et\'ritsqaros|T\'ianet\'is|Tqibuli|Ts\'ageris|Tsalenjikhis|Tsalkis|Tsqaltubo|Vanis|Zestap\'onis|Zugdidi|Zugdidis';
states[83] = 'Baden-Wuerttemberg|Bayern|Berlin|Brandenburg|Bremen|Hamburg|Hessen|Mecklenburg-Vorpommern|Niedersachsen|Nordrhein-Westfalen|Rheinland-Pfalz|Saarland|Sachsen|Sachsen-Anhalt|Schleswig-Holstein|Thueringen';
states[84] = 'Ashanti|Brong-Ahafo|Central|Eastern|Greater Accra|Northern|Upper East|Upper West|Volta|Western';
states[85] = 'Gibraltar';
states[86] = 'Ile du Lys|Ile Glorieuse';
states[87] = 'Aitolia kai Akarnania|Akhaia|Argolis|Arkadhia|Arta|Attiki|Ayion Oros (Mt. Athos)|Dhodhekanisos|Drama|Evritania|Evros|Evvoia|Florina|Fokis|Fthiotis|Grevena|Ilia|Imathia|Ioannina|Irakleion|Kardhitsa|Kastoria|Kavala|Kefallinia|Kerkyra|Khalkidhiki|Khania|Khios|Kikladhes|Kilkis|Korinthia|Kozani|Lakonia|Larisa|Lasithi|Lesvos|Levkas|Magnisia|Messinia|Pella|Pieria|Preveza|Rethimni|Rodhopi|Samos|Serrai|Thesprotia|Thessaloniki|Trikala|Voiotia|Xanthi|Zakinthos';
states[88] = 'Avannaa (Nordgronland)|Kitaa (Vestgronland)|Tunu (Ostgronland)';
states[89] = 'Carriacou and Petit Martinique|Saint Andrew|Saint David|Saint George|Saint John|Saint Mark|Saint Patrick';
states[90] = 'Basse-Terre|Grande-Terre|Iles de la Petite Terre|Iles des Saintes|Marie-Galante';
states[91] = 'Guam';
states[92] = 'Alta Verapaz|Baja Verapaz|Chimaltenango|Chiquimula|El Progreso|Escuintla|Guatemala|Huehuetenango|Izabal|Jalapa|Jutiapa|Peten|Quetzaltenango|Quiche|Retalhuleu|Sacatepequez|San Marcos|Santa Rosa|Solola|Suchitepequez|Totonicapan|Zacapa';
states[93] = 'Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale';
states[94] = 'Beyla|Boffa|Boke|Conakry|Coyah|Dabola|Dalaba|Dinguiraye|Dubreka|Faranah|Forecariah|Fria|Gaoual|Gueckedou|Kankan|Kerouane|Kindia|Kissidougou|Koubia|Koundara|Kouroussa|Labe|Lelouma|Lola|Macenta|Mali|Mamou|Mandiana|Nzerekore|Pita|Siguiri|Telimele|Tougue|Yomou';
states[95] = 'Bafata|Biombo|Bissau|Bolama-Bijagos|Cacheu|Gabu|Oio|Quinara|Tombali';
states[96] = 'Barima-Waini|Cuyuni-Mazaruni|Demerara-Mahaica|East Berbice-Corentyne|Essequibo Islands-West Demerara|Mahaica-Berbice|Pomeroon-Supenaam|Potaro-Siparuni|Upper Demerara-Berbice|Upper Takutu-Upper Essequibo';
states[97] = 'Artibonite|Centre|Grand\'Anse|Nord|Nord-Est|Nord-Ouest|Ouest|Sud|Sud-Est';
states[98] = 'Heard Island and McDonald Islands';
states[99] = 'Holy See (Vatican City)';
states[100] = 'Atlantida|Choluteca|Colon|Comayagua|Copan|Cortes|El Paraiso|Francisco Morazan|Gracias a Dios|Intibuca|Islas de la Bahia|La Paz|Lempira|Ocotepeque|Olancho|Santa Barbara|Valle|Yoro';
states[101] = 'Hong Kong';
states[102] = 'Howland Island';
states[103] = 'Bacs-Kiskun|Baranya|Bekes|Bekescsaba|Borsod-Abauj-Zemplen|Budapest|Csongrad|Debrecen|Dunaujvaros|Eger|Fejer|Gyor|Gyor-Moson-Sopron|Hajdu-Bihar|Heves|Hodmezovasarhely|Jasz-Nagykun-Szolnok|Kaposvar|Kecskemet|Komarom-Esztergom|Miskolc|Nagykanizsa|Nograd|Nyiregyhaza|Pecs|Pest|Somogy|Sopron|Szabolcs-Szatmar-Bereg|Szeged|Szekesfehervar|Szolnok|Szombathely|Tatabanya|Tolna|Vas|Veszprem|Veszprem|Zala|Zalaegerszeg';
states[104] = 'Akranes|Akureyri|Arnessysla|Austur-Bardhastrandarsysla|Austur-Hunavatnssysla|Austur-Skaftafellssysla|Borgarfjardharsysla|Dalasysla|Eyjafjardharsysla|Gullbringusysla|Hafnarfjordhur|Husavik|Isafjordhur|Keflavik|Kjosarsysla|Kopavogur|Myrasysla|Neskaupstadhur|Nordhur-Isafjardharsysla|Nordhur-Mulasys-la|Nordhur-Thingeyjarsysla|Olafsfjordhur|Rangarvallasysla|Reykjavik|Saudharkrokur|Seydhisfjordhur|Siglufjordhur|Skagafjardharsysla|Snaefellsnes-og Hnappadalssysla|Strandasysla|Sudhur-Mulasysla|Sudhur-Thingeyjarsysla|Vesttmannaeyjar|Vestur-Bardhastrandarsysla|Vestur-Hunavatnssysla|Vestur-Isafjardharsysla|Vestur-Skaftafellssysla';
states[105] = 'Andaman and Nicobar Islands|Andhra Pradesh|Arunachal Pradesh|Assam|Bihar|Chandigarh|Chhattisgarh|Dadra and Nagar Haveli|Daman and Diu|Delhi|Goa|Gujarat|Haryana|Himachal Pradesh|Jammu and Kashmir|Jharkhand|Karnataka|Kerala|Lakshadweep|Madhya Pradesh|Maharashtra|Manipur|Meghalaya|Mizoram|Nagaland|Orissa|Pondicherry|Punjab|Rajasthan|Sikkim|Tamil Nadu|Tripura|Uttar Pradesh|Uttaranchal|West Bengal';
states[106] = 'Aceh|Bali|Banten|Bengkulu|East Timor|Gorontalo|Irian Jaya|Jakarta Raya|Jambi|Jawa Barat|Jawa Tengah|Jawa Timur|Kalimantan Barat|Kalimantan Selatan|Kalimantan Tengah|Kalimantan Timur|Kepulauan Bangka Belitung|Lampung|Maluku|Maluku Utara|Nusa Tenggara Barat|Nusa Tenggara Timur|Riau|Sulawesi Selatan|Sulawesi Tengah|Sulawesi Tenggara|Sulawesi Utara|Sumatera Barat|Sumatera Selatan|Sumatera Utara|Yogyakarta';
states[107] = 'Ardabil|Azarbayjan-e Gharbi|Azarbayjan-e Sharqi|Bushehr|Chahar Mahall va Bakhtiari|Esfahan|Fars|Gilan|Golestan|Hamadan|Hormozgan|Ilam|Kerman|Kermanshah|Khorasan|Khuzestan|Kohgiluyeh va Buyer Ahmad|Kordestan|Lorestan|Markazi|Mazandaran|Qazvin|Qom|Semnan|Sistan va Baluchestan|Tehran|Yazd|Zanjan';
states[108] = 'Al Anbar|Al Basrah|Al Muthanna|Al Qadisiyah|An Najaf|Arbil|As Sulaymaniyah|At Ta\'mim|Babil|Baghdad|Dahuk|Dhi Qar|Diyala|Karbala\'|Maysan|Ninawa|Salah ad Din|Wasit';
states[109] = 'Carlow|Cavan|Clare|Cork|Donegal|Dublin|Galway|Kerry|Kildare|Kilkenny|Laois|Leitrim|Limerick|Longford|Louth|Mayo|Meath|Monaghan|Offaly|Roscommon|Sligo|Tipperary|Waterford|Westmeath|Wexford|Wicklow';
states[110] = 'Antrim|Ards|Armagh|Ballymena|Ballymoney|Banbridge|Belfast|Carrickfergus|Castlereagh|Coleraine|Cookstown|Craigavon|Derry|Down|Dungannon|Fermanagh|Larne|Limavady|Lisburn|Magherafelt|Moyle|Newry and Mourne|Newtownabbey|North Down|Omagh|Strabane';
states[111] = 'Central|Haifa|Jerusalem|Northern|Southern|Tel Aviv';
states[112] = 'Abruzzo|Basilicata|Calabria|Campania|Emilia-Romagna|Friuli-Venezia Giulia|Lazio|Liguria|Lombardia|Marche|Molise|Piemonte|Puglia|Sardegna|Sicilia|Toscana|Trentino-Alto Adige|Umbria|Valle d\'Aosta|Veneto';
states[113] = 'Clarendon|Hanover|Kingston|Manchester|Portland|Saint Andrew|Saint Ann|Saint Catherine|Saint Elizabeth|Saint James|Saint Mary|Saint Thomas|Trelawny|Westmoreland';
states[114] = 'Jan Mayen';
states[115] = 'Aichi|Akita|Aomori|Chiba|Ehime|Fukui|Fukuoka|Fukushima|Gifu|Gumma|Hiroshima|Hokkaido|Hyogo|Ibaraki|Ishikawa|Iwate|Kagawa|Kagoshima|Kanagawa|Kochi|Kumamoto|Kyoto|Mie|Miyagi|Miyazaki|Nagano|Nagasaki|Nara|Niigata|Oita|Okayama|Okinawa|Osaka|Saga|Saitama|Shiga|Shimane|Shizuoka|Tochigi|Tokushima|Tokyo|Tottori|Toyama|Wakayama|Yamagata|Yamaguchi|Yamanashi';
states[116] = 'Jarvis Island';
states[117] = 'Jersey';
states[118] = 'Johnston Atoll';
states[119] = '\'Amman|Ajlun|Al \'Aqabah|Al Balqa\'|Al Karak|Al Mafraq|At Tafilah|Az Zarqa\'|Irbid|Jarash|Ma\'an|Madaba';
states[120] = 'Juan de Nova Island';
states[121] = 'Almaty|Aqmola|Aqtobe|Astana|Atyrau|Batys Qazaqstan|Bayqongyr|Mangghystau|Ongtustik Qazaqstan|Pavlodar|Qaraghandy|Qostanay|Qyzylorda|Shyghys Qazaqstan|Soltustik Qazaqstan|Zhambyl';
states[122] = 'Central|Coast|Eastern|Nairobi Area|North Eastern|Nyanza|Rift Valley|Western';
states[123] = 'Abaiang|Abemama|Aranuka|Arorae|Banaba|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands|Kanton|Kiritimati|Kuria|Line Islands|Line Islands|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Tarawa|Teraina';
states[124] = 'Chagang-do (Chagang Province)|Hamgyong-bukto (North Hamgyong Province)|Hamgyong-namdo (South Hamgyong Province)|Hwanghae-bukto (North Hwanghae Province)|Hwanghae-namdo (South Hwanghae Province)|Kaesong-si (Kaesong City)|Kangwon-do (Kangwon Province)|Namp\'o-si (Namp\'o City)|P\'yongan-bukto (North P\'yongan Province)|P\'yongan-namdo (South P\'yongan Province)|P\'yongyang-si (P\'yongyang City)|Yanggang-do (Yanggang Province)';
states[125] = 'Ch\'ungch\'ong-bukto|Ch\'ungch\'ong-namdo|Cheju-do|Cholla-bukto|Cholla-namdo|Inch\'on-gwangyoksi|Kangwon-do|Kwangju-gwangyoksi|Kyonggi-do|Kyongsang-bukto|Kyongsang-namdo|Pusan-gwangyoksi|Soul-t\'ukpyolsi|Taegu-gwangyoksi|Taejon-gwangyoksi|Ulsan-gwangyoksi';
states[126] = 'Al \'Asimah|Al Ahmadi|Al Farwaniyah|Al Jahra\'|Hawalli';
states[127] = 'Batken Oblasty|Bishkek Shaary|Chuy Oblasty (Bishkek)|Jalal-Abad Oblasty|Naryn Oblasty|Osh Oblasty|Talas Oblasty|Ysyk-Kol Oblasty (Karakol)';
states[128] = 'Attapu|Bokeo|Bolikhamxai|Champasak|Houaphan|Khammouan|Louangnamtha|Louangphabang|Oudomxai|Phongsali|Salavan|Savannakhet|Viangchan|Viangchan|Xaignabouli|Xaisomboun|Xekong|Xiangkhoang';
states[129] = 'Aizkraukles Rajons|Aluksnes Rajons|Balvu Rajons|Bauskas Rajons|Cesu Rajons|Daugavpils|Daugavpils Rajons|Dobeles Rajons|Gulbenes Rajons|Jekabpils Rajons|Jelgava|Jelgavas Rajons|Jurmala|Kraslavas Rajons|Kuldigas Rajons|Leipaja|Liepajas Rajons|Limbazu Rajons|Ludzas Rajons|Madonas Rajons|Ogres Rajons|Preilu Rajons|Rezekne|Rezeknes Rajons|Riga|Rigas Rajons|Saldus Rajons|Talsu Rajons|Tukuma Rajons|Valkas Rajons|Valmieras Rajons|Ventspils|Ventspils Rajons';
states[130] = 'Beyrouth|Ech Chimal|Ej Jnoub|El Bekaa|Jabal Loubnane';
states[131] = 'Berea|Butha-Buthe|Leribe|Mafeteng|Maseru|Mohales Hoek|Mokhotlong|Qacha\'s Nek|Quthing|Thaba-Tseka';
states[132] = 'Bomi|Bong|Grand Bassa|Grand Cape Mount|Grand Gedeh|Grand Kru|Lofa|Margibi|Maryland|Montserrado|Nimba|River Cess|Sinoe';
states[133] = 'Ajdabiya|Al \'Aziziyah|Al Fatih|Al Jabal al Akhdar|Al Jufrah|Al Khums|Al Kufrah|An Nuqat al Khams|Ash Shati\'|Awbari|Az Zawiyah|Banghazi|Darnah|Ghadamis|Gharyan|Misratah|Murzuq|Sabha|Sawfajjin|Surt|Tarabulus|Tarhunah|Tubruq|Yafran|Zlitan';
states[134] = 'Balzers|Eschen|Gamprin|Mauren|Planken|Ruggell|Schaan|Schellenberg|Triesen|Triesenberg|Vaduz';
states[135] = 'Akmenes Rajonas|Alytaus Rajonas|Alytus|Anyksciu Rajonas|Birstonas|Birzu Rajonas|Druskininkai|Ignalinos Rajonas|Jonavos Rajonas|Joniskio Rajonas|Jurbarko Rajonas|Kaisiadoriu Rajonas|Kaunas|Kauno Rajonas|Kedainiu Rajonas|Kelmes Rajonas|Klaipeda|Klaipedos Rajonas|Kretingos Rajonas|Kupiskio Rajonas|Lazdiju Rajonas|Marijampole|Marijampoles Rajonas|Mazeikiu Rajonas|Moletu Rajonas|Neringa Pakruojo Rajonas|Palanga|Panevezio Rajonas|Panevezys|Pasvalio Rajonas|Plunges Rajonas|Prienu Rajonas|Radviliskio Rajonas|Raseiniu Rajonas|Rokiskio Rajonas|Sakiu Rajonas|Salcininku Rajonas|Siauliai|Siauliu Rajonas|Silales Rajonas|Silutes Rajonas|Sirvintu Rajonas|Skuodo Rajonas|Svencioniu Rajonas|Taurages Rajonas|Telsiu Rajonas|Traku Rajonas|Ukmerges Rajonas|Utenos Rajonas|Varenos Rajonas|Vilkaviskio Rajonas|Vilniaus Rajonas|Vilnius|Zarasu Rajonas';
states[136] = 'Diekirch|Grevenmacher|Luxembourg';
states[137] = 'Macau';
states[138] = 'Aracinovo|Bac|Belcista|Berovo|Bistrica|Bitola|Blatec|Bogdanci|Bogomila|Bogovinje|Bosilovo|Brvenica|Cair (Skopje)|Capari|Caska|Cegrane|Centar (Skopje)|Centar Zupa|Cesinovo|Cucer-Sandevo|Debar|Delcevo|Delogozdi|Demir Hisar|Demir Kapija|Dobrusevo|Dolna Banjica|Dolneni|Dorce Petrov (Skopje)|Drugovo|Dzepciste|Gazi Baba (Skopje)|Gevgelija|Gostivar|Gradsko|Ilinden|Izvor|Jegunovce|Kamenjane|Karbinci|Karpos (Skopje)|Kavadarci|Kicevo|Kisela Voda (Skopje)|Klecevce|Kocani|Konce|Kondovo|Konopiste|Kosel|Kratovo|Kriva Palanka|Krivogastani|Krusevo|Kuklis|Kukurecani|Kumanovo|Labunista|Lipkovo|Lozovo|Lukovo|Makedonska Kamenica|Makedonski Brod|Mavrovi Anovi|Meseista|Miravci|Mogila|Murtino|Negotino|Negotino-Poloska|Novaci|Novo Selo|Oblesevo|Ohrid|Orasac|Orizari|Oslomej|Pehcevo|Petrovec|Plasnia|Podares|Prilep|Probistip|Radovis|Rankovce|Resen|Rosoman|Rostusa|Samokov|Saraj|Sipkovica|Sopiste|Sopotnika|Srbinovo|Star Dojran|Staravina|Staro Nagoricane|Stip|Struga|Strumica|Studenicani|Suto Orizari (Skopje)|Sveti Nikole|Tearce|Tetovo|Topolcani|Valandovo|Vasilevo|Veles|Velesta|Vevcani|Vinica|Vitoliste|Vranestica|Vrapciste|Vratnica|Vrutok|Zajas|Zelenikovo|Zileno|Zitose|Zletovo|Zrnovci';
states[139] = 'Antananarivo|Antsiranana|Fianarantsoa|Mahajanga|Toamasina|Toliara';
states[140] = 'Balaka|Blantyre|Chikwawa|Chiradzulu|Chitipa|Dedza|Dowa|Karonga|Kasungu|Likoma|Lilongwe|Machinga (Kasupe)|Mangochi|Mchinji|Mulanje|Mwanza|Mzimba|Nkhata Bay|Nkhotakota|Nsanje|Ntcheu|Ntchisi|Phalombe|Rumphi|Salima|Thyolo|Zomba';
states[141] = 'Johor|Kedah|Kelantan|Labuan|Melaka|Negeri Sembilan|Pahang|Perak|Perlis|Pulau Pinang|Sabah|Sarawak|Selangor|Terengganu|Wilayah Persekutuan';
states[142] = 'Alifu|Baa|Dhaalu|Faafu|Gaafu Alifu|Gaafu Dhaalu|Gnaviyani|Haa Alifu|Haa Dhaalu|Kaafu|Laamu|Lhaviyani|Maale|Meemu|Noonu|Raa|Seenu|Shaviyani|Thaa|Vaavu';
states[143] = 'Gao|Kayes|Kidal|Koulikoro|Mopti|Segou|Sikasso|Tombouctou';
states[144] = 'Valletta';
states[145] = 'Man, Isle of';
states[146] = 'Ailinginae|Ailinglaplap|Ailuk|Arno|Aur|Bikar|Bikini|Bokak|Ebon|Enewetak|Erikub|Jabat|Jaluit|Jemo|Kili|Kwajalein|Lae|Lib|Likiep|Majuro|Maloelap|Mejit|Mili|Namorik|Namu|Rongelap|Rongrik|Toke|Ujae|Ujelang|Utirik|Wotho|Wotje';
states[147] = 'Martinique';
states[148] = 'Adrar|Assaba|Brakna|Dakhlet Nouadhibou|Gorgol|Guidimaka|Hodh Ech Chargui|Hodh El Gharbi|Inchiri|Nouakchott|Tagant|Tiris Zemmour|Trarza';
states[149] = 'Agalega Islands|Black River|Cargados Carajos Shoals|Flacq|Grand Port|Moka|Pamplemousses|Plaines Wilhems|Port Louis|Riviere du Rempart|Rodrigues|Savanne';
states[150] = 'Mayotte';
states[151] = 'Aguascalientes|Baja California|Baja California Sur|Campeche|Chiapas|Chihuahua|Coahuila de Zaragoza|Colima|Distrito Federal|Durango|Guanajuato|Guerrero|Hidalgo|Jalisco|Mexico|Michoacan de Ocampo|Morelos|Nayarit|Nuevo Leon|Oaxaca|Puebla|Queretaro de Arteaga|Quintana Roo|San Luis Potosi|Sinaloa|Sonora|Tabasco|Tamaulipas|Tlaxcala|Veracruz-Llave|Yucatan|Zacatecas';
states[152] = 'Chuuk (Truk)|Kosrae|Pohnpei|Yap';
states[153] = 'Midway Islands';
states[154] = 'Balti|Cahul|Chisinau|Chisinau|Dubasari|Edinet|Gagauzia|Lapusna|Orhei|Soroca|Tighina|Ungheni';
states[155] = 'Fontvieille|La Condamine|Monaco-Ville|Monte-Carlo';
states[156] = 'Arhangay|Bayan-Olgiy|Bayanhongor|Bulgan|Darhan|Dornod|Dornogovi|Dundgovi|Dzavhan|Erdenet|Govi-Altay|Hentiy|Hovd|Hovsgol|Omnogovi|Ovorhangay|Selenge|Suhbaatar|Tov|Ulaanbaatar|Uvs';
states[157] = 'Saint Anthony|Saint Georges|Saint Peter\'s';
states[158] = 'Agadir|Al Hoceima|Azilal|Ben Slimane|Beni Mellal|Boulemane|Casablanca|Chaouen|El Jadida|El Kelaa des Srarhna|Er Rachidia|Essaouira|Fes|Figuig|Guelmim|Ifrane|Kenitra|Khemisset|Khenifra|Khouribga|Laayoune|Larache|Marrakech|Meknes|Nador|Ouarzazate|Oujda|Rabat-Sale|Safi|Settat|Sidi Kacem|Tan-Tan|Tanger|Taounate|Taroudannt|Tata|Taza|Tetouan|Tiznit';
states[159] = 'Cabo Delgado|Gaza|Inhambane|Manica|Maputo|Nampula|Niassa|Sofala|Tete|Zambezia';
states[160] = 'Caprivi|Erongo|Hardap|Karas|Khomas|Kunene|Ohangwena|Okavango|Omaheke|Omusati|Oshana|Oshikoto|Otjozondjupa';
states[161] = 'Aiwo|Anabar|Anetan|Anibare|Baiti|Boe|Buada|Denigomodu|Ewa|Ijuw|Meneng|Nibok|Uaboe|Yaren';
states[162] = 'Bagmati|Bheri|Dhawalagiri|Gandaki|Janakpur|Karnali|Kosi|Lumbini|Mahakali|Mechi|Narayani|Rapti|Sagarmatha|Seti';
states[163] = 'Drenthe|Flevoland|Friesland|Gelderland|Groningen|Limburg|Noord-Brabant|Noord-Holland|Overijssel|Utrecht|Zeeland|Zuid-Holland';
states[164] = 'Netherlands Antilles';
states[165] = 'Iles Loyaute|Nord|Sud';
states[166] = 'Akaroa|Amuri|Ashburton|Bay of Islands|Bruce|Buller|Chatham Islands|Cheviot|Clifton|Clutha|Cook|Dannevirke|Egmont|Eketahuna|Ellesmere|Eltham|Eyre|Featherston|Franklin|Golden Bay|Great Barrier Island|Grey|Hauraki Plains|Hawera|Hawke\'s Bay|Heathcote|Hikurangi|Hobson|Hokianga|Horowhenua|Hurunui|Hutt|Inangahua|Inglewood|Kaikoura|Kairanga|Kiwitea|Lake|Mackenzie|Malvern|Manaia|Manawatu|Mangonui|Maniototo|Marlborough|Masterton|Matamata|Mount Herbert|Ohinemuri|Opotiki|Oroua|Otamatea|Otorohanga|Oxford|Pahiatua|Paparua|Patea|Piako|Pohangina|Raglan|Rangiora|Rangitikei|Rodney|Rotorua|Runanga|Saint Kilda|Silverpeaks|Southland|Stewart Island|Stratford|Strathallan|Taranaki|Taumarunui|Taupo|Tauranga|Thames-Coromandel|Tuapeka|Vincent|Waiapu|Waiheke|Waihemo|Waikato|Waikohu|Waimairi|Waimarino|Waimate|Waimate West|Waimea|Waipa|Waipawa|Waipukurau|Wairarapa South|Wairewa|Wairoa|Waitaki|Waitomo|Waitotara|Wallace|Wanganui|Waverley|Westland|Whakatane|Whangarei|Whangaroa|Woodville';
states[167] = 'Atlantico Norte|Atlantico Sur|Boaco|Carazo|Chinandega|Chontales|Esteli|Granada|Jinotega|Leon|Madriz|Managua|Masaya|Matagalpa|Nueva Segovia|Rio San Juan|Rivas';
states[168] = 'Agadez|Diffa|Dosso|Maradi|Niamey|Tahoua|Tillaberi|Zinder';
states[169] = 'Abia|Abuja Federal Capital Territory|Adamawa|Akwa Ibom|Anambra|Bauchi|Bayelsa|Benue|Borno|Cross River|Delta|Ebonyi|Edo|Ekiti|Enugu|Gombe|Imo|Jigawa|Kaduna|Kano|Katsina|Kebbi|Kogi|Kwara|Lagos|Nassarawa|Niger|Ogun|Ondo|Osun|Oyo|Plateau|Rivers|Sokoto|Taraba|Yobe|Zamfara';
states[170] = 'Niue';
states[171] = 'Norfolk Island';
states[172] = 'Northern Islands|Rota|Saipan|Tinian';
states[173] = 'Akershus|Aust-Agder|Buskerud|Finnmark|Hedmark|Hordaland|More og Romsdal|Nord-Trondelag|Nordland|Oppland|Oslo|Ostfold|Rogaland|Sogn og Fjordane|Sor-Trondelag|Telemark|Troms|Vest-Agder|Vestfold';
states[174] = 'Ad Dakhiliyah|Al Batinah|Al Wusta|Ash Sharqiyah|Az Zahirah|Masqat|Musandam|Zufar';
states[175] = 'Balochistan|Federally Administered Tribal Areas|Islamabad Capital Territory|North-West Frontier Province|Punjab|Sindh';
states[176] = 'Aimeliik|Airai|Angaur|Hatobohei|Kayangel|Koror|Melekeok|Ngaraard|Ngarchelong|Ngardmau|Ngatpang|Ngchesar|Ngeremlengui|Ngiwal|Palau Island|Peleliu|Sonsoral|Tobi';
states[177] = 'Bocas del Toro|Chiriqui|Cocle|Colon|Darien|Herrera|Los Santos|Panama|San Blas|Veraguas';
states[178] = 'Bougainville|Central|Chimbu|East New Britain|East Sepik|Eastern Highlands|Enga|Gulf|Madang|Manus|Milne Bay|Morobe|National Capital|New Ireland|Northern|Sandaun|Southern Highlands|West New Britain|Western|Western Highlands';
states[179] = 'Alto Paraguay|Alto Parana|Amambay|Asuncion (city)|Boqueron|Caaguazu|Caazapa|Canindeyu|Central|Concepcion|Cordillera|Guaira|Itapua|Misiones|Neembucu|Paraguari|Presidente Hayes|San Pedro';
states[180] = 'Amazonas|Ancash|Apurimac|Arequipa|Ayacucho|Cajamarca|Callao|Cusco|Huancavelica|Huanuco|Ica|Junin|La Libertad|Lambayeque|Lima|Loreto|Madre de Dios|Moquegua|Pasco|Piura|Puno|San Martin|Tacna|Tumbes|Ucayali';
states[181] = 'Abra|Agusan del Norte|Agusan del Sur|Aklan|Albay|Angeles|Antique|Aurora|Bacolod|Bago|Baguio|Bais|Basilan|Basilan City|Bataan|Batanes|Batangas|Batangas City|Benguet|Bohol|Bukidnon|Bulacan|Butuan|Cabanatuan|Cadiz|Cagayan|Cagayan de Oro|Calbayog|Caloocan|Camarines Norte|Camarines Sur|Camiguin|Canlaon|Capiz|Catanduanes|Cavite|Cavite City|Cebu|Cebu City|Cotabato|Dagupan|Danao|Dapitan|Davao City Davao|Davao del Sur|Davao Oriental|Dipolog|Dumaguete|Eastern Samar|General Santos|Gingoog|Ifugao|Iligan|Ilocos Norte|Ilocos Sur|Iloilo|Iloilo City|Iriga|Isabela|Kalinga-Apayao|La Carlota|La Union|Laguna|Lanao del Norte|Lanao del Sur|Laoag|Lapu-Lapu|Legaspi|Leyte|Lipa|Lucena|Maguindanao|Mandaue|Manila|Marawi|Marinduque|Masbate|Mindoro Occidental|Mindoro Oriental|Misamis Occidental|Misamis Oriental|Mountain|Naga|Negros Occidental|Negros Oriental|North Cotabato|Northern Samar|Nueva Ecija|Nueva Vizcaya|Olongapo|Ormoc|Oroquieta|Ozamis|Pagadian|Palawan|Palayan|Pampanga|Pangasinan|Pasay|Puerto Princesa|Quezon|Quezon City|Quirino|Rizal|Romblon|Roxas|Samar|San Carlos (in Negros Occidental)|San Carlos (in Pangasinan)|San Jose|San Pablo|Silay|Siquijor|Sorsogon|South Cotabato|Southern Leyte|Sultan Kudarat|Sulu|Surigao|Surigao del Norte|Surigao del Sur|Tacloban|Tagaytay|Tagbilaran|Tangub|Tarlac|Tawitawi|Toledo|Trece Martires|Zambales|Zamboanga|Zamboanga del Norte|Zamboanga del Sur';
states[182] = 'Pitcaim Islands';
states[183] = 'Dolnoslaskie|Kujawsko-Pomorskie|Lodzkie|Lubelskie|Lubuskie|Malopolskie|Mazowieckie|Opolskie|Podkarpackie|Podlaskie|Pomorskie|Slaskie|Swietokrzyskie|Warminsko-Mazurskie|Wielkopolskie|Zachodniopomorskie';
states[184] = 'Acores (Azores)|Aveiro|Beja|Braga|Braganca|Castelo Branco|Coimbra|Evora|Faro|Guarda|Leiria|Lisboa|Madeira|Portalegre|Porto|Santarem|Setubal|Viana do Castelo|Vila Real|Viseu';
states[185] = 'Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Catano|Cayey|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabela|Jayuya|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las Piedras|Loiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana Grande|Salinas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega Baja|Vieques|Villalba|Yabucoa|Yauco';
states[186] = 'Ad Dawhah|Al Ghuwayriyah|Al Jumayliyah|Al Khawr|Al Wakrah|Ar Rayyan|Jarayan al Batinah|Madinat ash Shamal|Umm Salal';
states[187] = 'Reunion';
states[188] = 'Alba|Arad|Arges|Bacau|Bihor|Bistrita-Nasaud|Botosani|Braila|Brasov|Bucuresti|Buzau|Calarasi|Caras-Severin|Cluj|Constanta|Covasna|Dimbovita|Dolj|Galati|Giurgiu|Gorj|Harghita|Hunedoara|Ialomita|Iasi|Maramures|Mehedinti|Mures|Neamt|Olt|Prahova|Salaj|Satu Mare|Sibiu|Suceava|Teleorman|Timis|Tulcea|Vaslui|Vilcea|Vrancea';
states[189] = 'Adygeya (Maykop)|Aginskiy Buryatskiy (Aginskoye)|Altay (Gorno-Altaysk)|Altayskiy (Barnaul)|Amurskaya (Blagoveshchensk)|Arkhangel\'skaya|Astrakhanskaya|Bashkortostan (Ufa)|Belgorodskaya|Bryanskaya|Buryatiya (Ulan-Ude)|Chechnya (Groznyy)|Chelyabinskaya|Chitinskaya|Chukotskiy (Anadyr\')|Chuvashiya (Cheboksary)|Dagestan (Makhachkala)|Evenkiyskiy (Tura)|Ingushetiya (Nazran\')|Irkutskaya|Ivanovskaya|Kabardino-Balkariya (Nal\'chik)|Kaliningradskaya|Kalmykiya (Elista)|Kaluzhskaya|Kamchatskaya (Petropavlovsk-Kamchatskiy)|Karachayevo-Cherkesiya (Cherkessk)|Kareliya (Petrozavodsk)|Kemerovskaya|Khabarovskiy|Khakasiya (Abakan)|Khanty-Mansiyskiy (Khanty-Mansiysk)|Kirovskaya|Komi (Syktyvkar)|Komi-Permyatskiy (Kudymkar)|Koryakskiy (Palana)|Kostromskaya|Krasnodarskiy|Krasnoyarskiy|Kurganskaya|Kurskaya|Leningradskaya|Lipetskaya|Magadanskaya|Mariy-El (Yoshkar-Ola)|Mordoviya (Saransk)|Moskovskaya|Moskva (Moscow)|Murmanskaya|Nenetskiy (Nar\'yan-Mar)|Nizhegorodskaya|Novgorodskaya|Novosibirskaya|Omskaya|Orenburgskaya|Orlovskaya (Orel)|Penzenskaya|Permskaya|Primorskiy (Vladivostok)|Pskovskaya|Rostovskaya|Ryazanskaya|Sakha (Yakutsk)|Sakhalinskaya (Yuzhno-Sakhalinsk)|Samarskaya|Sankt-Peterburg (Saint Petersburg)|Saratovskaya|Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)|Smolenskaya|Stavropol\'skiy|Sverdlovskaya (Yekaterinburg)|Tambovskaya|Tatarstan (Kazan\')|Taymyrskiy (Dudinka)|Tomskaya|Tul\'skaya|Tverskaya|Tyumenskaya|Tyva (Kyzyl)|Udmurtiya (Izhevsk)|Ul\'yanovskaya|Ust\'-Ordynskiy Buryatskiy (Ust\'-Ordynskiy)|Vladimirskaya|Volgogradskaya|Vologodskaya|Voronezhskaya|Yamalo-Nenetskiy (Salekhard)|Yaroslavskaya|Yevreyskaya';
states[190] = 'Butare|Byumba|Cyangugu|Gikongoro|Gisenyi|Gitarama|Kibungo|Kibuye|Kigali Rurale|Kigali-ville|Ruhengeri|Umutara';
states[191] = 'Ascension|Saint Helena|Tristan da Cunha';
states[192] = 'Christ Church Nichola Town|Saint Anne Sandy Point|Saint George Basseterre|Saint George Gingerland|Saint James Windward|Saint John Capisterre|Saint John Figtree|Saint Mary Cayon|Saint Paul Capisterre|Saint Paul Charlestown|Saint Peter Basseterre|Saint Thomas Lowland|Saint Thomas Middle Island|Trinity Palmetto Point';
states[193] = 'Anse-la-Raye|Castries|Choiseul|Dauphin|Dennery|Gros Islet|Laborie|Micoud|Praslin|Soufriere|Vieux Fort';
states[194] = 'Miquelon|Saint Pierre';
states[195] = 'Charlotte|Grenadines|Saint Andrew|Saint David|Saint George|Saint Patrick';
states[196] = 'A\'ana|Aiga-i-le-Tai|Atua|Fa\'asaleleaga|Gaga\'emauga|Gagaifomauga|Palauli|Satupa\'itea|Tuamasaga|Va\'a-o-Fonoti|Vaisigano';
states[197] = 'Acquaviva|Borgo Maggiore|Chiesanuova|Domagnano|Faetano|Fiorentino|Monte Giardino|San Marino|Serravalle';
states[198] = 'Principe|Sao Tome';
states[199] = '\'Asir|Al Bahah|Al Hudud ash Shamaliyah|Al Jawf|Al Madinah|Al Qasim|Ar Riyad|Ash Sharqiyah (Eastern Province)|Ha\'il|Jizan|Makkah|Najran|Tabuk';
states[200] = 'Aberdeen City|Aberdeenshire|Angus|Argyll and Bute|City of Edinburgh|Clackmannanshire|Dumfries and Galloway|Dundee City|East Ayrshire|East Dunbartonshire|East Lothian|East Renfrewshire|Eilean Siar (Western Isles)|Falkirk|Fife|Glasgow City|Highland|Inverclyde|Midlothian|Moray|North Ayrshire|North Lanarkshire|Orkney Islands|Perth and Kinross|Renfrewshire|Shetland Islands|South Ayrshire|South Lanarkshire|Stirling|The Scottish Borders|West Dunbartonshire|West Lothian';
states[201] = 'Dakar|Diourbel|Fatick|Kaolack|Kolda|Louga|Saint-Louis|Tambacounda|Thies|Ziguinchor';
states[202] = 'Anse aux Pins|Anse Boileau|Anse Etoile|Anse Louis|Anse Royale|Baie Lazare|Baie Sainte Anne|Beau Vallon|Bel Air|Bel Ombre|Cascade|Glacis|Grand\' Anse (on Mahe)|Grand\' Anse (on Praslin)|La Digue|La Riviere Anglaise|Mont Buxton|Mont Fleuri|Plaisance|Pointe La Rue|Port Glaud|Saint Louis|Takamaka';
states[203] = 'Eastern|Northern|Southern|Western';
states[204] = 'Singapore';
states[205] = 'Banskobystricky|Bratislavsky|Kosicky|Nitriansky|Presovsky|Trenciansky|Trnavsky|Zilinsky';
states[206] = 'Ajdovscina|Beltinci|Bled|Bohinj|Borovnica|Bovec|Brda|Brezice|Brezovica|Cankova-Tisina|Celje|Cerklje na Gorenjskem|Cerknica|Cerkno|Crensovci|Crna na Koroskem|Crnomelj|Destrnik-Trnovska Vas|Divaca|Dobrepolje|Dobrova-Horjul-Polhov Gradec|Dol pri Ljubljani|Domzale|Dornava|Dravograd|Duplek|Gorenja Vas-Poljane|Gorisnica|Gornja Radgona|Gornji Grad|Gornji Petrovci|Grosuplje|Hodos Salovci|Hrastnik|Hrpelje-Kozina|Idrija|Ig|Ilirska Bistrica|Ivancna Gorica|Izola|Jesenice|Jursinci|Kamnik|Kanal|Kidricevo|Kobarid|Kobilje|Kocevje|Komen|Koper|Kozje|Kranj|Kranjska Gora|Krsko|Kungota|Kuzma|Lasko|Lenart|Lendava|Litija|Ljubljana|Ljubno|Ljutomer|Logatec|Loska Dolina|Loski Potok|Luce|Lukovica|Majsperk|Maribor|Medvode|Menges|Metlika|Mezica|Miren-Kostanjevica|Mislinja|Moravce|Moravske Toplice|Mozirje|Murska Sobota|Muta|Naklo|Nazarje|Nova Gorica|Novo Mesto|Odranci|Ormoz|Osilnica|Pesnica|Piran|Pivka|Podcetrtek|Podvelka-Ribnica|Postojna|Preddvor|Ptuj|Puconci|Race-Fram|Radece|Radenci|Radlje ob Dravi|Radovljica|Ravne-Prevalje|Ribnica|Rogasevci|Rogaska Slatina|Rogatec|Ruse|Semic|Sencur|Sentilj|Sentjernej|Sentjur pri Celju|Sevnica|Sezana|Skocjan|Skofja Loka|Skofljica|Slovenj Gradec|Slovenska Bistrica|Slovenske Konjice|Smarje pri Jelsah|Smartno ob Paki|Sostanj|Starse|Store|Sveti Jurij|Tolmin|Trbovlje|Trebnje|Trzic|Turnisce|Velenje|Velike Lasce|Videm|Vipava|Vitanje|Vodice|Vojnik|Vrhnika|Vuzenica|Zagorje ob Savi|Zalec|Zavrc|Zelezniki|Ziri|Zrece';
states[207] = 'Bellona|Central|Choiseul (Lauru)|Guadalcanal|Honiara|Isabel|Makira|Malaita|Rennell|Temotu|Western';
states[208] = 'Awdal|Bakool|Banaadir|Bari|Bay|Galguduud|Gedo|Hiiraan|Jubbada Dhexe|Jubbada Hoose|Mudug|Nugaal|Sanaag|Shabeellaha Dhexe|Shabeellaha Hoose|Sool|Togdheer|Woqooyi Galbeed';
states[209] = 'Eastern Cape|Free State|Gauteng|KwaZulu-Natal|Mpumalanga|North-West|Northern Cape|Northern Province|Western Cape';
states[210] = 'Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands';
states[211] = 'Andalucia|Aragon|Asturias|Baleares (Balearic Islands)|Canarias (Canary Islands)|Cantabria|Castilla y Leon|Castilla-La Mancha|Cataluna|Ceuta|Communidad Valencian|Extremadura|Galicia|Islas Chafarinas|La Rioja|Madrid|Melilla|Murcia|Navarra|Pais Vasco (Basque Country)|Penon de Alhucemas|Penon de Velez de la Gomera';
states[212] = 'Spratly Islands';
states[213] = 'Central|Eastern|North Central|North Eastern|North Western|Northern|Sabaragamuwa|Southern|Uva|Western';
states[214] = 'A\'ali an Nil|Al Bahr al Ahmar|Al Buhayrat|Al Jazirah|Al Khartum|Al Qadarif|Al Wahdah|An Nil al Abyad|An Nil al Azraq|Ash Shamaliyah|Bahr al Jabal|Gharb al Istiwa\'iyah|Gharb Bahr al Ghazal|Gharb Darfur|Gharb Kurdufan|Janub Darfur|Janub Kurdufan|Junqali|Kassala|Nahr an Nil|Shamal Bahr al Ghazal|Shamal Darfur|Shamal Kurdufan|Sharq al Istiwa\'iyah|Sinnar|Warab';
states[215] = 'Brokopondo|Commewijne|Coronie|Marowijne|Nickerie|Para|Paramaribo|Saramacca|Sipaliwini|Wanica';
states[216] = 'Barentsoya|Bjornoya|Edgeoya|Hopen|Kvitoya|Nordaustandet|Prins Karls Forland|Spitsbergen';
states[217] = 'Hhohho|Lubombo|Manzini|Shiselweni';
states[218] = 'Blekinge|Dalarnas|Gavleborgs|Gotlands|Hallands|Jamtlands|Jonkopings|Kalmar|Kronobergs|Norrbottens|Orebro|Ostergotlands|Skane|Sodermanlands|Stockholms|Uppsala|Varmlands|Vasterbottens|Vasternorrlands|Vastmanlands|Vastra Gotalands';
states[219] = 'Aargau|Ausser-Rhoden|Basel-Landschaft|Basel-Stadt|Bern|Fribourg|Geneve|Glarus|Graubunden|Inner-Rhoden|Jura|Luzern|Neuchatel|Nidwalden|Obwalden|Sankt Gallen|Schaffhausen|Schwyz|Solothurn|Thurgau|Ticino|Uri|Valais|Vaud|Zug|Zurich';
states[220] = 'Al Hasakah|Al Ladhiqiyah|Al Qunaytirah|Ar Raqqah|As Suwayda\'|Dar\'a|Dayr az Zawr|Dimashq|Halab|Hamah|Hims|Idlib|Rif Dimashq|Tartus';
states[221] = 'Chang-hua|Chi-lung|Chia-i|Chia-i|Chung-hsing-hsin-ts\'un|Hsin-chu|Hsin-chu|Hua-lien|I-lan|Kao-hsiung|Kao-hsiung|Miao-li|Nan-t\'ou|P\'eng-hu|P\'ing-tung|T\'ai-chung|T\'ai-chung|T\'ai-nan|T\'ai-nan|T\'ai-pei|T\'ai-pei|T\'ai-tung|T\'ao-yuan|Yun-lin';
states[222] = 'Viloyati Khatlon|Viloyati Leninobod|Viloyati Mukhtori Kuhistoni Badakhshon';
states[223] = 'Arusha|Dar es Salaam|Dodoma|Iringa|Kagera|Kigoma|Kilimanjaro|Lindi|Mara|Mbeya|Morogoro|Mtwara|Mwanza|Pemba North|Pemba South|Pwani|Rukwa|Ruvuma|Shinyanga|Singida|Tabora|Tanga|Zanzibar Central/South|Zanzibar North|Zanzibar Urban/West';
states[224] = 'Amnat Charoen|Ang Thong|Buriram|Chachoengsao|Chai Nat|Chaiyaphum|Chanthaburi|Chiang Mai|Chiang Rai|Chon Buri|Chumphon|Kalasin|Kamphaeng Phet|Kanchanaburi|Khon Kaen|Krabi|Krung Thep Mahanakhon (Bangkok)|Lampang|Lamphun|Loei|Lop Buri|Mae Hong Son|Maha Sarakham|Mukdahan|Nakhon Nayok|Nakhon Pathom|Nakhon Phanom|Nakhon Ratchasima|Nakhon Sawan|Nakhon Si Thammarat|Nan|Narathiwat|Nong Bua Lamphu|Nong Khai|Nonthaburi|Pathum Thani|Pattani|Phangnga|Phatthalung|Phayao|Phetchabun|Phetchaburi|Phichit|Phitsanulok|Phra Nakhon Si Ayutthaya|Phrae|Phuket|Prachin Buri|Prachuap Khiri Khan|Ranong|Ratchaburi|Rayong|Roi Et|Sa Kaeo|Sakon Nakhon|Samut Prakan|Samut Sakhon|Samut Songkhram|Sara Buri|Satun|Sing Buri|Sisaket|Songkhla|Sukhothai|Suphan Buri|Surat Thani|Surin|Tak|Trang|Trat|Ubon Ratchathani|Udon Thani|Uthai Thani|Uttaradit|Yala|Yasothon';
states[225] = 'Tobago';
states[226] = 'De La Kara|Des Plateaux|Des Savanes|Du Centre|Maritime';
states[227] = 'Atafu|Fakaofo|Nukunonu';
states[228] = 'Ha\'apai|Tongatapu|Vava\'u';
states[229] = 'Arima|Caroni|Mayaro|Nariva|Port-of-Spain|Saint Andrew|Saint David|Saint George|Saint Patrick|San Fernando|Victoria';
states[230] = 'Ariana|Beja|Ben Arous|Bizerte|El Kef|Gabes|Gafsa|Jendouba|Kairouan|Kasserine|Kebili|Mahdia|Medenine|Monastir|Nabeul|Sfax|Sidi Bou Zid|Siliana|Sousse|Tataouine|Tozeur|Tunis|Zaghouan';
states[231] = 'Adana|Adiyaman|Afyon|Agri|Aksaray|Amasya|Ankara|Antalya|Ardahan|Artvin|Aydin|Balikesir|Bartin|Batman|Bayburt|Bilecik|Bingol|Bitlis|Bolu|Burdur|Bursa|Canakkale|Cankiri|Corum|Denizli|Diyarbakir|Duzce|Edirne|Elazig|Erzincan|Erzurum|Eskisehir|Gaziantep|Giresun|Gumushane|Hakkari|Hatay|Icel|Igdir|Isparta|Istanbul|Izmir|Kahramanmaras|Karabuk|Karaman|Kars|Kastamonu|Kayseri|Kilis|Kirikkale|Kirklareli|Kirsehir|Kocaeli|Konya|Kutahya|Malatya|Manisa|Mardin|Mugla|Mus|Nevsehir|Nigde|Ordu|Osmaniye|Rize|Sakarya|Samsun|Sanliurfa|Siirt|Sinop|Sirnak|Sivas|Tekirdag|Tokat|Trabzon|Tunceli|Usak|Van|Yalova|Yozgat|Zonguldak';
states[232] = 'Ahal Welayaty|Balkan Welayaty|Dashhowuz Welayaty|Lebap Welayaty|Mary Welayaty';
states[233] = 'Tuvalu';
states[234] = 'Adjumani|Apac|Arua|Bugiri|Bundibugyo|Bushenyi|Busia|Gulu|Hoima|Iganga|Jinja|Kabale|Kabarole|Kalangala|Kampala|Kamuli|Kapchorwa|Kasese|Katakwi|Kibale|Kiboga|Kisoro|Kitgum|Kotido|Kumi|Lira|Luwero|Masaka|Masindi|Mbale|Mbarara|Moroto|Moyo|Mpigi|Mubende|Mukono|Nakasongola|Nebbi|Ntungamo|Pallisa|Rakai|Rukungiri|Sembabule|Soroti|Tororo';
states[235] = 'Avtonomna Respublika Krym (Simferopol\')|Cherkas\'ka (Cherkasy)|Chernihivs\'ka (Chernihiv)|Chernivets\'ka (Chernivtsi)|Dnipropetrovs\'ka (Dnipropetrovs\'k)|Donets\'ka (Donets\'k)|Ivano-Frankivs\'ka (Ivano-Frankivs\'k)|Kharkivs\'ka (Kharkiv)|Khersons\'ka (Kherson)|Khmel\'nyts\'ka (Khmel\'nyts\'kyy)|Kirovohrads\'ka (Kirovohrad)|Kyyiv|Kyyivs\'ka (Kiev)|L\'vivs\'ka (L\'viv)|Luhans\'ka (Luhans\'k)|Mykolayivs\'ka (Mykolayiv)|Odes\'ka (Odesa)|Poltavs\'ka (Poltava)|Rivnens\'ka (Rivne)|Sevastopol\'|Sums\'ka (Sumy)|Ternopil\'s\'ka (Ternopil\')|Vinnyts\'ka (Vinnytsya)|Volyns\'ka (Luts\'k)|Zakarpats\'ka (Uzhhorod)|Zaporiz\'ka (Zaporizhzhya)|Zhytomyrs\'ka (Zhytomyr)';
states[236] = '\'Ajman|Abu Zaby (Abu Dhabi)|Al Fujayrah|Ash Shariqah (Sharjah)|Dubayy (Dubai)|Ra\'s al Khaymah|Umm al Qaywayn';
states[237] = 'Barking and Dagenham|Barnet|Barnsley|Bath and North East Somerset|Bedfordshire|Bexley|Birmingham|Blackburn with Darwen|Blackpool|Bolton|Bournemouth|Bracknell Forest|Bradford|Brent|Brighton and Hove|Bromley|Buckinghamshire|Bury|Calderdale|Cambridgeshire|Camden|Cheshire|City of Bristol|City of Kingston upon Hull|City of London|Cornwall|Coventry|Croydon|Cumbria|Darlington|Derby|Derbyshire|Devon|Doncaster|Dorset|Dudley|Durham|Ealing|East Riding of Yorkshire|East Sussex|Enfield|Essex|Gateshead|Gloucestershire|Greenwich|Hackney|Halton|Hammersmith and Fulham|Hampshire|Haringey|Harrow|Hartlepool|Havering|Herefordshire|Hertfordshire|Hillingdon|Hounslow|Isle of Wight|Islington|Kensington and Chelsea|Kent|Kingston upon Thames|Kirklees|Knowsley|Lambeth|Lancashire|Leeds|Leicester|Leicestershire|Lewisham|Lincolnshire|Liverpool|Luton|Manchester|Medway|Merton|Middlesbrough|Milton Keynes|Newcastle upon Tyne|Newham|Norfolk|North East Lincolnshire|North Lincolnshire|North Somerset|North Tyneside|North Yorkshire|Northamptonshire|Northumberland|Nottingham|Nottinghamshire|Oldham|Oxfordshire|Peterborough|Plymouth|Poole|Portsmouth|Reading|Redbridge|Redcar and Cleveland|Richmond upon Thames|Rochdale|Rotherham|Rutland|Salford|Sandwell|Sefton|Sheffield|Shropshire|Slough|Solihull|Somerset|South Gloucestershire|South Tyneside|Southampton|Southend-on-Sea|Southwark|St. Helens|Staffordshire|Stockport|Stockton-on-Tees|Stoke-on-Trent|Suffolk|Sunderland|Surrey|Sutton|Swindon|Tameside|Telford and Wrekin|Thurrock|Torbay|Tower Hamlets|Trafford|Wakefield|Walsall|Waltham Forest|Wandsworth|Warrington|Warwickshire|West Berkshire|West Sussex|Westminster|Wigan|Wiltshire|Windsor and Maidenhead|Wirral|Wokingham|Wolverhampton|Worcestershire|York';
states[238] = 'Artigas|Canelones|Cerro Largo|Colonia|Durazno|Flores|Florida|Lavalleja|Maldonado|Montevideo|Paysandu|Rio Negro|Rivera|Rocha|Salto|San Jose|Soriano|Tacuarembo|Treinta y Tres';
states[239] = 'Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming';
states[240] = 'Andijon Wiloyati|Bukhoro Wiloyati|Farghona Wiloyati|Jizzakh Wiloyati|Khorazm Wiloyati (Urganch)|Namangan Wiloyati|Nawoiy Wiloyati|Qashqadaryo Wiloyati (Qarshi)|Qoraqalpoghiston (Nukus)|Samarqand Wiloyati|Sirdaryo Wiloyati (Guliston)|Surkhondaryo Wiloyati (Termiz)|Toshkent Shahri|Toshkent Wiloyati';
states[241] = 'Malampa|Penama|Sanma|Shefa|Tafea|Torba';
states[242] = 'Amazonas|Anzoategui|Apure|Aragua|Barinas|Bolivar|Carabobo|Cojedes|Delta Amacuro|Dependencias Federales|Distrito Federal|Falcon|Guarico|Lara|Merida|Miranda|Monagas|Nueva Esparta|Portuguesa|Sucre|Tachira|Trujillo|Vargas|Yaracuy|Zulia';
states[243] = 'An Giang|Ba Ria-Vung Tau|Bac Giang|Bac Kan|Bac Lieu|Bac Ninh|Ben Tre|Binh Dinh|Binh Duong|Binh Phuoc|Binh Thuan|Ca Mau|Can Tho|Cao Bang|Da Nang|Dac Lak|Dong Nai|Dong Thap|Gia Lai|Ha Giang|Ha Nam|Ha Noi|Ha Tay|Ha Tinh|Hai Duong|Hai Phong|Ho Chi Minh|Hoa Binh|Hung Yen|Khanh Hoa|Kien Giang|Kon Tum|Lai Chau|Lam Dong|Lang Son|Lao Cai|Long An|Nam Dinh|Nghe An|Ninh Binh|Ninh Thuan|Phu Tho|Phu Yen|Quang Binh|Quang Nam|Quang Ngai|Quang Ninh|Quang Tri|Soc Trang|Son La|Tay Ninh|Thai Binh|Thai Nguyen|Thanh Hoa|Thua Thien-Hue|Tien Giang|Tra Vinh|Tuyen Quang|Vinh Long|Vinh Phuc|Yen Bai';
states[244] = 'Saint Croix|Saint John|Saint Thomas';
states[245] = 'Blaenau Gwent|Bridgend|Caerphilly|Cardiff|Carmarthenshire|Ceredigion|Conwy|Denbighshire|Flintshire|Gwynedd|Isle of Anglesey|Merthyr Tydfil|Monmouthshire|Neath Port Talbot|Newport|Pembrokeshire|Powys|Rhondda Cynon Taff|Swansea|The Vale of Glamorgan|Torfaen|Wrexham';
states[246] = 'Alo|Sigave|Wallis';
states[247] = 'West Bank';
states[248] = 'Western Sahara';
states[249] = '\'Adan|\'Ataq|Abyan|Al Bayda\'|Al Hudaydah|Al Jawf|Al Mahrah|Al Mahwit|Dhamar|Hadhramawt|Hajjah|Ibb|Lahij|Ma\'rib|Sa\'dah|San\'a\'|Ta\'izz';
states[250] = 'Kosovo|Montenegro|Serbia|Vojvodina';
states[251] = 'Central|Copperbelt|Eastern|Luapula|Lusaka|North-Western|Northern|Southern|Western';
states[252] = 'Bulawayo|Harare|ManicalandMashonaland Central|Mashonaland East|Mashonaland West|Masvingo|Matabeleland North|Matabeleland South|Midlands';

/* harmony default export */ __webpack_exports__["a"] = ({ countries: countries, states: states });

/***/ }),

/***/ "n8BA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nj1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row customers"},[_c('div',{staticClass:"col-lg-3 col-md-4 col-xs-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"fixed",style:({height: _vm.windowHeight + 'px'})},[_c('div',{ref:"tableTop",staticClass:"table-top"},[_c('el-row',[_c('el-col',[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('general.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-container",style:({height: _vm.windowHeight - _vm.tableTopHeight + 'px'})},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","background":"#fff"},attrs:{"data":_vm.tableData,"current-page":1,"page-size":_vm.paginationDef.pageSize,"filters":_vm.filters,"table-props":{'row-class-name': _vm.rowClass, 'border': false, 'stripe': false,}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"label":"","min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('b',[_vm._v("# "+_vm._s(props.row.id))])]),_vm._v(" "),(props.row.firstname != null || props.row.lastname != null)?[_vm._v("\n                  "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n                ")]:[_c('small',[_vm._v(_vm._s(props.row.email))])],_vm._v(" "),_c('div',{staticClass:"xxs-font"},[_vm._v(_vm._s(_vm.$t('orders.counterPerCustomer'))+" "+_vm._s(props.row.counter_orders_per_customer))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","min-width":60},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.sales > 0 ? _vm.formatMoneyAmount(props.row.sales, props.row.currency) : ''))])]}}])})],1)],1)])])]),_vm._v(" "),_c('div',{ref:"detailsScroll",staticClass:"col-lg-9 col-md-8 col-xs-8 detailsScroll",style:({height: _vm.windowHeight + 'px'})},[(_vm.showForm())?_c('customer-view',{ref:"customerForm"}):_vm._e(),_vm._v(" "),(!_vm.showForm())?_c('div',{staticClass:"no-element"},[_c('i',{staticClass:"user"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('customers.noCustomer')))])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "okfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css__ = __webpack_require__("V5v9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group__ = __webpack_require__("D8db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css__ = __webpack_require__("/bpg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__ = __webpack_require__("ACGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css__ = __webpack_require__("bwiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu__ = __webpack_require__("SExR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SettingsMenu__ = __webpack_require__("bukA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Users_Users_vue__ = __webpack_require__("SvXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Users_UserForm_vue__ = __webpack_require__("HOa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__OrderingManagement_OrderingManagement__ = __webpack_require__("pznp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__RewardProgram_RewardProgramForm_vue__ = __webpack_require__("RYO5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__InfoPages_InfoPages_vue__ = __webpack_require__("TUUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Tabs_Taxes_vue__ = __webpack_require__("sAdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Tabs_Tips_vue__ = __webpack_require__("CpwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Tabs_CompanyDetails_vue__ = __webpack_require__("1hFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Tabs_Currency_vue__ = __webpack_require__("LPdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Tabs_DateTime_vue__ = __webpack_require__("kzgQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Tabs_PushNotifications_vue__ = __webpack_require__("2Igw");




















var _components;




















__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'SettingsMenu', __WEBPACK_IMPORTED_MODULE_23__SettingsMenu__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_25__Users_UserForm_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'OrderingManagement', __WEBPACK_IMPORTED_MODULE_26__OrderingManagement_OrderingManagement__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'RewardForm', __WEBPACK_IMPORTED_MODULE_27__RewardProgram_RewardProgramForm_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'InfoPages', __WEBPACK_IMPORTED_MODULE_28__InfoPages_InfoPages_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TaxForm', __WEBPACK_IMPORTED_MODULE_29__Tabs_Taxes_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TipsForm', __WEBPACK_IMPORTED_MODULE_30__Tabs_Tips_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CompanyDetails', __WEBPACK_IMPORTED_MODULE_31__Tabs_CompanyDetails_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CurrencyForm', __WEBPACK_IMPORTED_MODULE_32__Tabs_Currency_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'DatetimeForm', __WEBPACK_IMPORTED_MODULE_33__Tabs_DateTime_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PushNotifications', __WEBPACK_IMPORTED_MODULE_34__Tabs_PushNotifications_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'UsersList', __WEBPACK_IMPORTED_MODULE_24__Users_Users_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])),
  data: function data() {
    return {
      pickerOptions1: {},
      tabName: 'My Profile',
      currentTab: '',
      selectedUser: false,
      pickerNames: ['date_from', 'date_to'],
      days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      mainCategories: [],
      optionTypes: ['checkbox', 'radiobox', 'dropdown'],
      locations: [],
      model: {},
      user: JSON.parse(this.$session.get('userData')),
      defaultData: {
        'available_languages': {},
        'countries': {},
        'currencies': {},
        'currency_display_format': [],
        'date_formats': [],
        'time_formats': [],
        'timezones': {}
      },
      timeformats: [{ format: 'H:mm', example: '15:40' }, { format: 'h:mm a', example: '3:40 pm' }],
      dateformats: [{ format: 'DD/MM/YYYY', example: '15/03/2018' }, { format: 'MM/DD/YYYY', example: '03/15/2018' }, { format: 'MMMM D, YYYY', example: 'March 15, 2018' }],
      newLocation: {
        'street': '',
        'city': '',
        'state': '',
        'country': ''
      },
      modelValidations: {},
      modelValidate: {},
      taxes: []
    };
  },
  created: function created() {
    var data = {
      token: this.$session.get('token')
    };
    var self = this;
    var companyID = this.$session.get('selectedCompany');

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.defaultData = response.data[0];
      }
    });

    this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
      if (response2.status === true) {
        self.model = response2.data[0];
      }
    });

    var taxesData = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/settings/taxes', 'GET', taxesData, function (response) {
      if (response.status === true) {
        self.taxes = response.data;
      }
    });

    var tab = this.$session.get('selectedTab');

    if (tab !== undefined && tab !== '') {
      this.tabName = tab;
      this.$session.set('selectedTab', '');
    }
  },

  methods: {
    getData: function getData() {
      return [];
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    },
    addNewLocation: function addNewLocation() {
      var locationCopy = this.newLocation;
      var newRow = [];
      newRow = this.newLocation;
      newRow.location_id = '';
      newRow.location_id = 'new_' + Math.round(Math.random() * 10000);

      if (this.locations === undefined) {
        this.locations = [];
      }

      console.warn(newRow);

      this.locations.push(newRow);
      this.newLocation = locationCopy;

      console.warn(this.locations);
    },
    goToRecordUser: function goToRecordUser(row, event, column) {
      this.globalGoToRecord(row, event, column, '/user/edit/');
    },
    onUserSubmit: function onUserSubmit(model, isValid) {},
    updateList: function updateList() {
      console.warn('---- update list ----');
      this.selectedUser = false;
      this.$refs.userList.getData();
    },
    getUser: function getUser(id) {
      this.selectedUser = id;
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.selectedUser = false;
    },
    setSelectedTab: function setSelectedTab(value) {
      this.tabName = value;
    },
    setTaxes: function setTaxes(value) {
      this.taxes = value;
    },
    updateModelData: function updateModelData(data) {
      this.model = data;
    }
  }
});

/***/ }),

/***/ "oreA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pUJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("8VFO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1eecdfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("fUd2");
function injectStyle (ssrContext) {
  __webpack_require__("RE7N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1eecdfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d72a5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("4DSV");
function injectStyle (ssrContext) {
  __webpack_require__("1rzg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d72a5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pcxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pe4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ro__ = __webpack_require__("jU9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ro__);




var messages = {
  en: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    general: {
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      activate: 'activate',
      deactivate: 'deactivate',
      active: 'active',
      inactive: 'inactive',
      yes: 'Yes',
      no: 'No',
      success: 'Success',
      required: 'required',
      back: 'back',
      next: 'Next',
      finish: 'Finish',
      duplicate: 'Duplicate',
      select: 'Select',
      all: 'All',
      reset: 'Reset',
      export: 'Export',
      loadMore: 'Load More',
      showing: 'Showing {length} result(s)'
    },
    pages: {
      login: 'Login',
      register: 'Register',
      recoverPassword: 'Recover Password',
      resetPassword: 'Reset Password',
      dashboard: 'Dashboard',
      orderingManagement: 'Ordering Management',
      customerDetails: 'Customer Details',
      customers: 'Customers',
      orders: 'Orders',
      products: 'Products',
      catalog: 'Catalog',
      categories: 'Categories',
      productOptions: 'Product Options',
      marketing: 'Marketing',
      campaigns: 'Campaigns',
      offersSlider: 'Offers Slider',
      reports: 'Reports',
      feedback: 'Feedback',
      settings: 'Settings',
      logout: 'Logout'
    },
    ordersStatus: {
      AWAITING_TRANSPORT: 'Awaiting Transport',
      CANCELED: 'Canceled',
      DELIVERED: 'Delivered',
      DRAFT: 'Draft',
      NEW: 'New',
      NOT_DELIVERED: 'Not Delivered',
      PICKED_UP_BY_DELIVERY: 'Picked up for delivery',
      PROCESSING: 'Processing',
      PREPARED: 'Prepared',
      TRANSPORT: 'In transport'
    },
    ordersTypes: {
      GROUP: 'Group',
      SINGLE: 'Single'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Card'
    },
    paymentStatus: {
      notPaid: 'Not paid',
      paid: 'Paid',
      notOk: 'Declined'
    },
    campaignsModes: {
      AUTO: 'Auto',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Push Notification'
    },
    days: {
      monday: 'monday',
      tuesday: 'tuesday',
      wednesday: 'wednesday',
      thursday: 'thursday',
      friday: 'friday',
      saturday: 'saturday',
      sunday: 'sunday'
    },
    gender: {
      selectGender: 'Select gender',
      male: 'male',
      female: 'female',
      Male: 'Male',
      Female: 'Female',
      Other: 'Other'
    },
    reportsAgesGroups: {
      selectAge: 'Select Age',
      '20': 'Under 20',
      'Under 20': 'Under 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Unspecified'
    },
    deliveryTypes: {
      DELIVERY: 'Delivery',
      EAT_LOCATION: 'Eat on location',
      MEET_HALF: 'Meet me half way',
      PICK_UP: 'Pick-up'
    },
    couponsTypes: {
      FIXED: 'Fixed',
      PERCENTAGE: 'Percentage'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fixed (included)',
      PERCENTAGE_INCLUDED: 'Percentage (included)',
      FIXED_EXCLUDED: 'Fixed (excluded)',
      PERCENTAGE_EXCLUDED: 'Percentage (excluded)'
    },
    productOptions: {
      checkbox: 'Allows selecting multiple options on the product',
      radio: 'Allows selecting only one option on the product'
    },
    validations: {
      areYouSureYouWantTo: 'Are you sure you want to ',
      areYouSure: 'Are you sure you want to update the status to ',
      wentWrong: 'Something went wrong, please try again later...',
      pictureSize: 'jpg/png files with a size less than 5MB ',
      pictureSizeExceed: 'Picture size can not exceed 5MB!',
      removePhoto: 'Please remove the current file in order to be able to add a new one',
      dataCouldNotBeSaved: 'Data could not be saved, please try again later.',
      passReq: 'Password field id required.',
      passMin: 'Password must be at least 6 characters.',
      passConf: 'Password and password confirmation do not match.',
      validPoinsNo: 'Please add a valid money amount and a comment.'
    },
    dashboard: {
      selectLocation: 'Select location:',
      tile1Title: 'New Orders',
      tile2Title: 'Total Orders',
      tile3Title: 'Revenue',
      tile4Title: 'Newly registered users',
      today: 'Today',
      orderChart: 'Orders',
      completed: 'Number of orders',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      top5Chart: 'Top 5 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders'
    },
    customers: {
      noCustomer: 'No Customer Selected',
      single: 'customer',
      plural: 'customers',
      title: 'CUSTOMER DETAILS',
      pointsTitle: 'Customer Loyalty Points',
      currentPoints: 'Current Points',
      pointsAddTitle: 'Add Points',
      id: 'ID',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      gender: 'Gender',
      birth: 'Birth Day',
      location: 'Location',
      number: 'Number',
      dateCreated: 'Date Created',
      delivery: 'Deliery',
      type: 'Type',
      status: 'Status',
      total: 'Total',
      allTimeSale: 'All time sale',
      none: 'None',
      pointsLabel: 'Money spent',
      commentsLabel: 'Comment',
      pointsSuccess: 'Loyalty points added successfully.',
      pointsError: 'We cound not add the points to the customer.'
    },
    orders: {
      counterPerCustomer: 'Number of Orders',
      noOrders: 'No Order Selected',
      single: 'order',
      the_order: 'Order',
      plural: 'orders',
      status: 'Status',
      location: 'Location',
      updateStatus: 'Update Status',
      ordDetails: 'Order Details',
      date: 'Date',
      madeAt: 'Order made at',
      pickupTime: 'Delivery / Pick-up at',
      reservationTime: 'Reservation Time',
      reservationSeats: 'Reservation seats',
      rating: 'Rating',
      meetupLocation: 'Meet-up Location',
      ordLocation: 'Order Location',
      delivery: 'Deliery',
      type: 'Type',
      payment: 'Payment',
      name: 'Name',
      qty: 'Qty',
      unit: 'Unit Price',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount from loyalty points',
      totals_grandtotal: 'Total',
      totals_shipping: 'Shipping',
      totals_tip: 'Tips',
      custComments: 'Customer Comment',
      adminComments: 'Admin Comment',
      custDetails: 'Customer Details',
      shipping: 'Shipping Address',
      billing: 'Billing Address',
      orderStatusSuccess: 'Order status updated successfully',
      orderCommnetSuccess: 'Order comment updated successfully',
      orderHourSuccess: 'Order delivery / pick-up time updated successfully',
      orderHourError: 'Prease provide a valid hour.',
      none: 'No Comment',
      at: 'at',
      filtersApplied: 'Filters applied - click on filter button to see more',
      customFilters: 'Custom filters applied',
      resetFilters: 'click here to reset and see live data'
    },
    catalogProd: {
      noProducts: 'No Product Selected',
      single: 'product',
      plural: 'products',
      generalDetails: 'General Details',
      name: 'Name',
      desc: 'Description',
      image: 'Image',
      category: 'Category',
      price: 'Price',
      taxes: 'Applied taxes',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Allow user comments',
      validFromTo: 'Valid from - to',
      prodType: 'Product Type',
      singleType: 'single',
      groupType: 'group',
      rewardPoints: 'Reward points',
      moneySpent: 'Money to Points',
      numberOfYouNeedToSpend: 'Number of {currency} that the customer needs to spend to get a point.',
      points: 'points',
      soldWith: 'Sold with',
      pickAnOption: 'Pick an option',
      minNoSelected: 'Min no. selected',
      maxNoSelected: 'Max no. selected',
      optVal: 'Value',
      leaveEmpty: 'Leave empty or put 0 if option does not cost extra',
      prodDeleted: 'Product deleted successfully',
      prodAdded: 'Product added successfully',
      prodUpdated: 'Product updated successfully',
      prodPhotoError: 'We could not save the product photo, please try again later.',
      rewardPossibelValue: 'Possible values',
      errorOptions: 'Please check all the product options, some might not be filled in.'
    },
    catalogProdRewardsHints: {
      hint1: 'Leave empty to apply default value from settings',
      hint2: 'Put 0 to not apply reward program on this product',
      hint3: 'Add a positive value to override default value from settings'
    },
    catalogCateg: {
      single: 'category',
      plural: 'categories',
      name: 'Name',
      image: 'Image',
      displayType: 'Display Type',
      shortDescription: 'Short Description',
      validFromTo: 'Valid from - to',
      areYouSure: 'Are you sure you want to {label} this category?',
      categAdded: 'Category added successfully',
      categUpdated: 'Category updated successfully',
      categDeleted: 'Category deleted successfully',
      couldNotSave: 'We could not save the category photo, please try again later.'
    },
    catalogProdOpt: {
      single: 'Option',
      plural: 'options',
      new: 'New Option',
      name: 'Name',
      type: 'Type',
      value: 'Value',
      values: 'Values',
      posid: 'POS ID',
      optionSaved: 'Product options saved successfully.',
      areyouSure: 'Are you sure you want to delete this option?'
    },
    marketingCampaigns: {
      single: 'campaign',
      plural: 'campaigns',
      name: 'Name',
      image: 'Image',
      startEnd: 'Start - End Date',
      daysLeft: 'Days Left',
      status: 'Status',
      actions: 'Actions',
      send: 'Send',
      areYouSureNotif: 'Are you sure you want to send out the notifications?',
      notifSent: 'Notifications were sent.',
      campaignDeleted: 'Campaign deleted successfully.',
      areYouSureDelete: 'Are you sure you want to delete ',
      campaignAdded: 'Campaign added successfully',
      campaignUpdated: 'Campaign updated successfully',
      campaignPhotoError: 'We could not save the campaign photo, please try again later.',
      campaignDetails: 'Campaign Details',
      description: 'Description',
      maxDescription: '(max. 255 characters)',
      characters: 'characters',
      validFromTo: 'Valid from - to',
      notif: 'Notifications',
      model: 'Model',
      setHours: 'Set Hours',
      selectTime: 'Select time',
      chooseTarget: 'Choose target audience',
      gender: 'Gender',
      age: 'Age',
      city: 'City',
      location: 'Location',
      ordersAbove: 'Orders above',
      addCoupon: 'Add Coupon',
      applyTo: 'Apply to',
      value: 'Value',
      code: 'Code',
      generateCode: 'Generate Code',
      Products: 'Products',
      Shipping: 'Shipping',
      chooseCategProduct: 'Choose categories or products on which the coupon will apply:'
    },
    marketingOffers: {
      single: 'offer banner',
      plural: 'offer banners',
      title: 'Title',
      image: 'Image',
      linkType: 'Link Type',
      startEndDate: 'Start - End Date',
      actions: 'Actions',
      offerAdded: 'Offer banner added successfully.',
      offerUpdated: 'Offer banner updated successfully.',
      offerDeleted: 'Offer banner deleted successfully.',
      weCouldNot: 'We could not save the slider photo, please try again later.',
      validImg: 'Please add a valid image.',
      areYouSure: 'Are you sure you want to {label} this offer banner?',
      pageText: 'Page Text',
      pickCateg: 'Pick Category',
      pickProd: 'Pick Product',
      none: 'None'
    },
    marketingOffersTypes: {
      category: 'category',
      product: 'product',
      page: 'page'
    },
    reports: {
      trends: 'Trends',
      clients: 'Clients',
      products: 'Products',
      marketing: 'Marketing',
      today: 'Today',
      orderChart: 'Orders',
      completed: 'Completed',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      customersChart: 'Customers',
      appInstalls: 'App Installs',
      custWithAcc: 'Customers with account',
      top10Chart: 'Top 10 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders',
      customersAge: 'Customers Age',
      customersGender: 'Customers Gender',
      name: 'Name',
      appInstalled: 'App Installed',
      gender: 'Gender',
      location: 'Location',
      email: 'Email',
      phone: 'Phone',
      totalAmount: 'Total Amount',
      itemsSold: 'Items Sold',
      campaign: 'Campaign',
      couponsTimesUsed: 'Coupons Times Used',
      revenue: 'Revenue',
      total: 'Total'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Type',
      sentBy: 'Sent By',
      text: 'Text',
      seen: 'Seen',
      sentAt: 'Sent At'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Issue',
      suggestion: 'Suggestion'
    },
    settings: {},
    settingsPages: {
      userSettings: 'User Settings',
      myProfile: 'My Profile',
      users: 'Users',
      general: 'General',
      companyDetails: 'Company Details',
      dateTime: 'Date & Time',
      currency: 'Currency',
      accounting: 'Accounting',
      tax: 'Tax',
      payment: 'Payment',
      orderingMng: 'Ordering Management',
      loyalty: 'Loyalty Program',
      push: 'Push Notifications',
      tips: 'Tips',
      subscription: 'Subscription',
      myPlan: 'My Plan',
      infoPages: 'Info Pages'
    },
    settingUsers: {
      single: 'user',
      fn: 'First Name',
      ln: 'Last Name',
      email: 'Email',
      username: 'Username',
      lang: 'Interface language',
      langMsg: 'This is the language in which you will see the administration area.',
      avatar: 'Avatar',
      role: 'Role',
      resetPass: 'Reset Password',
      password: 'Password',
      pass: 'Password',
      confPass: 'Confirm Password',
      userAdded: 'New user added successfully',
      userUpdated: 'User updated successfully',
      userPicError: 'We could not save the user avatar, please try again later.'
    },
    settingCompany: {
      title: 'Company',
      location: 'Location',
      name: 'Name',
      lang: 'Application language',
      bussLoc: 'Bussiness Location',
      deliveryLabels: 'Delivery types labels',
      pick_up: 'Pick-up',
      meet_half: 'Meet me half way',
      delivery: 'Delivery',
      eat_location: 'Eat on location',
      phone: 'Phone',
      street: 'Street',
      email: 'Email',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDaysHrs: 'AVAILABLE DAYS AND HOURS',
      from: 'from',
      to: 'to',
      preOrder: 'pre-order from',
      allowPreOrder: 'Allow Pre-order',
      userTaxes: 'USED TAXES',
      noTaxMsg: 'Info: You have made changes on taxes, don\'t forget to save them.',
      areYouSureDelete: 'Are you sure you want to delete this location? This action will also delete the ordering settings for this location.',
      areYouSureTax: 'Are you sure you want to remove this tax from taxes list? Don\'t forget to save the changes!',
      companyUpdated: 'Company data updated successfully.'
    },
    settingDateTime: {
      timezone: 'Timezone',
      timeFormat: 'Time format',
      dateFormat: 'Date format',
      saveMsg: 'Date & Time settings saved successfully'
    },
    settingCurrency: {
      currency: 'Shop currency',
      saveMsg: 'Currency data saved successfully'
    },
    settingTaxes: {
      single: 'Tax',
      name: 'Name',
      type: 'Type',
      amount: 'Amount',
      notice: 'Info: At "Tax" you only define a label name for the tax to be applied. To define the tax details such as value or type you need to go to',
      notice2: 'company details'
    },
    settingsPayment: {
      publicKey: 'Public key',
      privateKey: 'Private key'
    },
    settingsOrdering: {
      enabled: 'Enabled',
      paymentOptions: 'Payment Options',
      paymentOptionsErr: 'The payment option field is required.',
      waitingTime: 'Default waiting time',
      minimumOrderValue: 'Minimum order value',
      minutes: 'min',
      shippingCost: 'Shipping cost',
      shippingTax: 'Shipping tax',
      locations: 'Locations',
      street: 'Street',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDays: 'Available days and hours',
      availableDaysErr: 'The available days and hours option field is required.',
      notice: 'Please check the error in the enabled ordering methods tabs then try to save again the form',
      saveSuccess: 'Ordering details data saved successfully'
    },
    settingsInfoPages: {
      single: 'page',
      noPage: 'No pages added yet.',
      title: 'Page Title',
      content: 'Page Content',
      newPage: 'New Page',
      addedSuccess: 'Page saved successfully.',
      deletedSuccess: 'Page deleted successfully',
      deleteMsg: 'Are you sure you want to delete this page?',
      TERMS_CONDITIONS: 'Terms and Conditions',
      PRIVACY_POLICY: 'Privacy Policy',
      CONTACT_DETAILS: 'Contact Details'
    },
    settingsRewards: {
      single: 'point',
      plural: 'points',
      state: 'State',
      points: 'point(s)',
      moneySpent: 'Money Spent to points',
      pointsTo: 'Points to Money',
      numberOfcurrencyNeedToSpend: 'Amount of money client has to spend to earn 1 point.',
      numberOfpointsToReward: 'Amount of points client needs when he wants to pay using points.',
      rewardSuccess: 'Loyalty program data saved successfully'
    },
    settingsPushNotif: {
      order_new: 'New order message',
      order_completed_pickup: 'Completed order message - Pick-up',
      order_completed_meet: 'Completed order message - Meet me half way',
      order_completed_delivery: 'Completed order message - Delivery',
      order_completed_eat: 'Completed order message - Eat on location',
      order_canceled: 'Canceled order message',
      notifUpdated: 'Push notifications data saved successfully',
      preview: 'Preview',
      time: 'time',
      dateTime: 'date and time',
      persons: 'persons number',
      timePrev: '45 minutes',
      personsPrev: '3',
      dateTimePrev: 'Tuesday, February 15, 2019, at 6pm'
    },
    settingsTips: {
      tipsTaxes: 'Tips taxes',
      state: 'Use tips',
      tipsSuccess: 'Tips saved successfully'
    },
    settingsPlans: {
      plan1Title: 'Monthly',
      plan1Rate: '160€ / month',
      plan1Description: 'Get started with a monthly fixed fee, no matter the amount of sales you make through the app.',
      plan2Title: 'Sales percentage',
      plan2Rate: '10%',
      plan2Description: 'Pay as you sell. Chose the Sales Percentage and pay a monthly fee in relation with the amount you sell through the app.',
      current: 'Current subscription',
      switch: 'Switch'
    },
    checkbox: 'Allows selecting multiple options on the product',
    radio: 'Allows selecting only one option on the product'
  }, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default.a),
  ro: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    general: {
      search: 'Caută',
      add: 'Adaugă',
      edit: 'Editează',
      delete: 'Șterge',
      remove: 'Elimină',
      save: 'Salvează',
      update: 'Actualizează',
      cancel: 'Anulează',
      activate: 'activează',
      deactivate: 'dezactivează',
      active: 'activ',
      inactive: 'inactiv',
      yes: 'Da',
      no: 'Nu',
      success: 'Succes',
      required: 'necesar',
      back: 'înapoi',
      next: 'Următorul',
      finish: 'Finalizează',
      duplicate: 'Duplică',
      select: 'Selectează',
      all: 'Toate',
      reset: 'Resetează',
      export: 'Exportă',
      loadMore: 'Încarcă mai mult',
      showing: '{length} rezultate afișate'
    },
    pages: {
      login: 'Logare',
      register: 'Înregistrare',
      recoverPassword: 'Recuperează Parola',
      resetPassword: 'Resetează Parola',
      dashboard: 'Panou comandă',
      orderingManagement: 'Gestionare Comenzi',
      customerDetails: 'Detalii Client',
      customers: 'Clienți',
      orders: 'Comenzi',
      products: 'Produse',
      catalog: 'Catalog',
      categories: 'Categorii',
      productOptions: 'Optiuni Produs',
      marketing: 'Marketing',
      campaigns: 'Campanii',
      offersSlider: 'Banner oferte',
      reports: 'Rapoarte',
      feedback: 'Feedback',
      settings: 'Setări',
      logout: 'Delogare'
    },
    ordersStatus: {
      AWAITING_TRANSPORT: 'În așteptarea transportului',
      CANCELED: 'Anulată',
      DELIVERED: 'Livrată',
      DRAFT: 'Ciornă',
      NEW: 'Nou',
      NOT_DELIVERED: 'Nelivrată',
      PICKED_UP_BY_DELIVERY: 'Preluată pentru livrare',
      PROCESSING: 'Procesată',
      PREPARED: 'Preparată',
      TRANSPORT: 'În transport'
    },
    ordersTypes: {
      GROUP: 'Grup',
      SINGLE: 'Individual'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Card'
    },
    paymentStatus: {
      notPaid: 'Neachitat',
      paid: 'Achitat',
      notOk: 'Refuzat'
    },
    campaignsModes: {
      AUTO: 'Auto',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Notificări'
    },
    days: {
      monday: 'luni',
      tuesday: 'marți',
      wednesday: 'miercuri',
      thursday: 'joi',
      friday: 'vineri',
      saturday: 'sâmbătă',
      sunday: 'duminică'
    },
    gender: {
      selectGender: 'Selectează Genul',
      male: 'masculin',
      female: 'feminin',
      Male: 'Masculin',
      Female: 'Feminin',
      Other: 'Altul'
    },
    reportsAgesGroups: {
      selectAge: 'Selectează Vârsta',
      '20': 'Sub 20',
      'Under 20': 'Sub 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Nespecificat'
    },
    deliveryTypes: {
      DELIVERY: 'Livare',
      EAT_LOCATION: 'Rezervă masă',
      MEET_HALF: 'Ne întâlnim la jumătate',
      PICK_UP: 'Ridicare comandă'
    },
    couponsTypes: {
      FIXED: 'Fix',
      PERCENTAGE: 'Procent'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fix (inclus)',
      PERCENTAGE_INCLUDED: 'Procent (inclus)',
      FIXED_EXCLUDED: 'Fix (exclus)',
      PERCENTAGE_EXCLUDED: 'Procent (exclus)'
    },
    productOptions: {
      checkbox: 'Permite selectarea mai multor opțiuni pe produs',
      radio: 'Permite selectarea unei singure opțiuni pe produs'
    },
    validations: {
      areYouSureYouWantTo: 'Sigur că dorești modificarea ',
      areYouSure: 'Sigur dorești să actualizezi statusul ',
      wentWrong: 'A apărut o eroare, te rugăm să încerci mai târziu...',
      pictureSize: 'fișiere jpg/png cu o dimensiune mai mică de 5MB ',
      pictureSizeExceed: 'Dimeniunea pozelor nu poate depăși 5MB!',
      removePhoto: 'Te rugăm să ștergi documentele existente pentru a putea adăuga altele noi',
      dataCouldNotBeSaved: 'Datele nu au putut fi salvate, te rugăm să încerci mai târziu.',
      passReq: 'ID-ul câmpului de parolă este necesar.',
      passMin: 'Parola trebuie să conțină cel puțin 6 caractere.',
      passConf: 'Parola și confirmarea parolei nu corespund.',
      validPoinsNo: 'Te rugăm să adaugi o sumă valabilă de bani și un comentariu.'
    },
    dashboard: {
      selectLocation: 'Selectează locatia:',
      tile1Title: 'Comenzi Noi',
      tile2Title: 'Total Comenzi',
      tile3Title: 'Venituri',
      tile4Title: 'Utilizatori nou înregistrați',
      today: 'Azi',
      orderChart: 'Comenzi',
      completed: 'Număr de comenzi',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      top5Chart: 'Top 5 produse',
      orderingChart: 'Tipuri de comenzi',
      nrOfOrders: 'Număr de comenzi'
    },
    customers: {
      noCustomer: 'Nici un Client Selectat',
      single: 'client',
      plural: 'clienți',
      title: 'DETALII CLIENT',
      pointsTitle: 'Puncte Loialitate Client',
      currentPoints: 'Puncte Actuale',
      pointsAddTitle: 'Adaugă Puncte',
      id: 'ID',
      name: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      gender: 'Gen',
      birth: 'Data nașterii',
      location: 'Locație',
      number: 'Număr',
      dateCreated: 'Data creare',
      delivery: 'Livrare',
      type: 'Tip',
      status: 'Status',
      total: 'Total',
      allTimeSale: 'Vânzări totale',
      none: 'Nici unul',
      pointsLabel: 'Bani cheluiți',
      commentsLabel: 'Comentariu',
      pointsSuccess: 'Puncte loialitate adăugate cu succes.',
      pointsError: 'Nu am putut adăuga punctele de loialitate clientului.'
    },
    orders: {
      counterPerCustomer: 'Număr Comenzi',
      noOrders: 'Nici o comandă Selectată',
      single: 'comandă',
      the_order: 'Comandă',
      plural: 'comenzi',
      status: 'Status',
      location: 'Locație',
      updateStatus: 'Actualizează Status',
      ordDetails: 'Detalii Comenzi',
      date: 'Data',
      madeAt: 'Comandă plasată la',
      pickupTime: 'Livrare / Ridicare la',
      reservationTime: 'Oră Rezervare',
      reservationSeats: 'Rezervare Locuri',
      rating: 'Evaluare',
      meetupLocation: 'Puncte întâlnire',
      ordLocation: 'Locație Comandă',
      delivery: 'Livrare',
      type: 'Tip',
      payment: 'Plată',
      name: 'Nume',
      qty: 'Cantitate',
      unit: 'Preț buc',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount puncte loialitate',
      totals_grandtotal: 'Total',
      totals_shipping: 'Livrare',
      totals_tip: 'Bacșiș',
      custComments: 'Comentariu Client',
      adminComments: 'Comentariu Admin',
      custDetails: 'Detalii Clienți',
      shipping: 'Adresă Livrare',
      billing: 'Adresă Facturare',
      orderStatusSuccess: 'Statusul comenzii a fost actualizat cu succes',
      orderCommnetSuccess: 'Comentariul pe comandă a fost actualizat cu succes',
      orderHourSuccess: 'Timpul de livrare / ridicare comandă actualizat cu succes',
      orderHourError: 'Te rugăm să oferi o oră validă.',
      none: 'Nici un comentariu',
      at: 'la',
      filtersApplied: 'Filtre aplicate - apasă butonul de filtru pentru a vedea mai mult',
      customFilters: 'Filtre specifice aplicate',
      resetFilters: 'apasă aici pentru a reseta și a vedea datele actualizate'
    },
    catalogProd: {
      noProducts: 'Nici un produs selectat',
      single: 'produs',
      plural: 'produse',
      generalDetails: 'Detalii Generale',
      name: 'Nume',
      desc: 'Descriere',
      image: 'Imagine',
      category: 'Categorie',
      price: 'Preț',
      taxes: 'Taxe aplicate',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Permite utilizatorilor să lase un mesaj',
      validFromTo: 'Valibil de la - până la',
      prodType: 'Tip Produs',
      singleType: 'indivuald',
      groupType: 'grup',
      rewardPoints: 'Puncte loialitate',
      moneySpent: 'Bani în Puncte',
      numberOfYouNeedToSpend: 'Suma de {currency} pe care clientul trebuie să o cheltuiască pentru a primi 1 punct.',
      points: 'puncte',
      soldWith: 'Vândut cu',
      pickAnOption: 'Alege o opțiune',
      minNoSelected: 'Nr. min selectat',
      maxNoSelected: 'Nr. max selectat',
      optVal: 'Valoare',
      leaveEmpty: 'Lasă gol sau pune 0 dacă opțiunea nu costă suplimentar',
      prodDeleted: 'Produs șters cu succes',
      prodAdded: 'Produs adăugat cu succes',
      prodUpdated: 'Produs actualizat cu succes',
      prodPhotoError: 'Nu am putut salva poza de produs, te rugăm să încerci mai târziu.',
      rewardPossibelValue: 'Posibile valori'
    },
    catalogProdRewardsHints: {
      hint1: 'Lasă gol pentru a putea aplica valoarea implicită din setări',
      hint2: 'Pune 0 pentru a nu aplica punctele de loialitate pentru acest produs',
      hint3: 'Adaugă o valoare pozivită pentru a trece peste valoarea implicită din setări'
    },
    catalogCateg: {
      single: 'categorie',
      plural: 'categorii',
      name: 'Nume',
      image: 'Imagine',
      displayType: 'Tip afișare',
      shortDescription: 'Scurtă Descriere',
      validFromTo: 'Valibil de la - până la',
      areYouSure: 'Ești sigur că vrei să {label} această categorie?',
      categAdded: 'Categorie adăugată cu succes',
      categUpdated: 'Categorie actualizată cu succes',
      categDeleted: 'Categorie ștearsă cu succes',
      couldNotSave: 'Poza de categorie nu a fost salvată, te rugăm să încerci mai târziu.'
    },
    catalogProdOpt: {
      single: 'Opțiune',
      plural: 'opțiuni',
      new: 'Opțiune Nouă',
      name: 'Nume',
      type: 'Tip',
      value: 'Valoare',
      values: 'Valori',
      posid: 'POS ID',
      optionSaved: 'Opțiune produs salvată cu succes.',
      areyouSure: 'Ești sigur că dorești să ștergi această opțiune?'
    },
    marketingCampaigns: {
      single: 'campanie',
      plural: 'campanii',
      name: 'Nume',
      image: 'Imagine',
      startEnd: 'Start - Sfârșit Perioadă',
      daysLeft: 'Zile rămase',
      status: 'Status',
      actions: 'Acțiuni',
      send: 'Trimite',
      areYouSureNotif: 'Ești sigur că dorești să trimiți aceste notificări?',
      notifSent: 'Notificările au fost trimise.',
      campaignDeleted: 'Campanie ștearsă cu succes.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi ',
      campaignAdded: 'Campanie adăugată cu succes',
      campaignUpdated: 'Campanie actualizată cu succes',
      campaignPhotoError: 'Poza de campanie nu a fost salvată, te rugăm să încerci mai târziu.',
      campaignDetails: 'Detalii Campanie',
      description: 'Descriere',
      maxDescription: '(max. 255 caractere)',
      characters: 'caractere',
      validFromTo: 'Valibil de la - până la',
      notif: 'Notificări',
      model: 'Model',
      setHours: 'Setează Orele',
      selectTime: 'Alege Ora',
      chooseTarget: 'Alege publicul țintă',
      gender: 'Gen',
      age: 'Vârstă',
      city: 'Oraș',
      location: 'Locație',
      ordersAbove: 'Comenzi mai sus',
      addCoupon: 'Adaugă cupon',
      applyTo: 'Aplică la',
      value: 'Valoare',
      code: 'Cod',
      generateCode: 'Generează Cod',
      Products: 'Produse',
      Shipping: 'Livrare',
      chooseCategProduct: 'Alege caregoriile sau produsele pe care se va aplica cuponul:'
    },
    marketingOffers: {
      single: 'banner ofertă',
      plural: 'banner oferte',
      title: 'Titlu',
      image: 'Imagine',
      linkType: 'Tip Link',
      startEndDate: 'Valabil de la - până la',
      actions: 'Acțiuni',
      offerAdded: 'Banner ofertă adăugat cu succes.',
      offerUpdated: 'Banner ofertă actualizat cu succes.',
      offerDeleted: 'Banner ofertă șters cu succes.',
      weCouldNot: 'Poza pentru bannerul de oferă nu a fost salvată, te rugăm să încerci mai târziu.',
      validImg: 'Te rugăm să adaugi o imagine validă.',
      areYouSure: 'Ești sigur că dorești să {label} acest banner ofertă?',
      pageText: 'Text Pagină',
      pickCateg: 'Alege Categoria',
      pickProd: 'Alege Produsul',
      none: 'Nici unul'
    },
    marketingOffersTypes: {
      category: 'categorie',
      product: 'produs',
      page: 'pagină'
    },
    reports: {
      trends: 'Tendințe',
      clients: 'Clienți',
      products: 'Produse',
      marketing: 'Marketing',
      today: 'Azi',
      orderChart: 'Comenzi',
      completed: 'Finalizate',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      customersChart: 'Clienți',
      appInstalls: 'Aplicații Instalate',
      custWithAcc: 'Conturi clienți',
      top10Chart: 'Top 10 produse',
      orderingChart: 'Tip comandă',
      nrOfOrders: 'Număr comenzi',
      customersAge: 'Vârsta client',
      customersGender: 'Gen client',
      name: 'Nume',
      appInstalled: 'Aplicații Instalate',
      gender: 'Gen',
      location: 'Locație',
      email: 'Email',
      phone: 'Telefon',
      totalAmount: 'Total sumă',
      itemsSold: 'Produse vândute',
      campaign: 'Campanii',
      couponsTimesUsed: 'Număr cupoane utilizate',
      revenue: 'Venituri',
      total: 'Total'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Tip',
      sentBy: 'Trimis prin',
      text: 'Text',
      seen: 'Văzut',
      sentAt: 'Trimis la'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Problemă',
      suggestion: 'Sugestie'
    },
    settings: {},
    settingsPages: {
      userSettings: 'Setări utilizator',
      myProfile: 'Profilul meu',
      users: 'Utilizatori',
      general: 'General',
      companyDetails: 'Detalii Companie',
      dateTime: 'Data și Timp',
      currency: 'Monedă',
      accounting: 'Contabilitate',
      tax: 'Taxe',
      payment: 'Plata',
      orderingMng: 'Management Comenzi',
      loyalty: 'Program Loialitate',
      push: 'Notificări',
      tips: 'Bacșiș',
      subscription: 'Subscripție',
      myPlan: 'Abonamentul meu',
      infoPages: 'Pagini informative'
    },
    settingUsers: {
      single: 'utilizator',
      fn: 'Prenume',
      ln: 'Nume',
      email: 'Email',
      username: 'Nume utilizator',
      lang: 'Limbaj interfață',
      langMsg: 'Acesta este limbajul în care vei vedea panoul de administrare.',
      avatar: 'Avatar',
      role: 'Rol',
      resetPass: 'Resetează Parolă',
      password: 'Parolă',
      pass: 'Parolă',
      confPass: 'Confirmă Parolă',
      userAdded: 'Utilizator nou adăugat cu succes',
      userUpdated: 'Utilizator actualizat cu succes',
      userPicError: 'Avatarul utilizatorului nu a fost salvat, te rugăm să încerci mai târziu.'
    },
    settingCompany: {
      title: 'Companie',
      location: 'Locație',
      name: 'Nume',
      lang: 'Limbaj aplicație',
      bussLoc: 'Locație local',
      deliveryLabels: 'Status de livrare',
      pick_up: 'Ridicare comandă',
      meet_half: 'Ne întâlnim la jumătate',
      delivery: 'Livrare',
      eat_location: 'Rezervare masă',
      phone: 'Telefon',
      street: 'Stradă',
      email: 'Email',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDaysHrs: 'ZILE ȘI ORE DISPONIBILE',
      from: 'de la',
      to: 'până la',
      preOrder: 'pre-comandă de la',
      allowPreOrder: 'Permite Pre-comandă',
      userTaxes: 'TAXE UTILIZATE',
      noTaxMsg: 'Info: Ai făcut modificări la taxe, nu uita să le salvezi.',
      areYouSureDelete: 'Ești sigur că dorești să ștergi această locație? Această acțiune va șterge, de asemenea, setările de comandă pentru această opțiune.',
      areYouSureTax: 'Sigur dorești să elimini această taxă din lista impozitelor? Nu uita să salvezi modificările făcute!',
      companyUpdated: 'Informațiile despre companie au fost actualizate cu succes.'
    },
    settingDateTime: {
      timezone: 'Fus orar',
      timeFormat: 'Formatul de timp',
      dateFormat: 'Formatul de dată',
      saveMsg: 'Setările pentru dată și oră salvate cu succes'
    },
    settingCurrency: {
      currency: 'Moneda localului',
      saveMsg: 'Moneda localului salvată cu succes'
    },
    settingTaxes: {
      single: 'Taxă',
      name: 'Nume',
      type: 'Tip',
      amount: 'Cantitate',
      notice: 'Info: La "Taxe" definește doar un nume de etichetă pentru impozitul ce trebuie aplicat. Pentru a defini detaliile fiscale, cum ar fi valoarea sau tipul, trebuie să accesați ',
      notice2: 'detalii companie'
    },
    settingsPayment: {
      publicKey: 'Cheie publică',
      privateKey: 'Cheie privată'
    },
    settingsOrdering: {
      enabled: 'Activat',
      paymentOptions: 'Opțiuni de plată',
      paymentOptionsErr: 'Câmpul de opțiuni de plată este obligatoriu.',
      waitingTime: 'Timpul de așteptare implicit',
      minimumOrderValue: 'Valoarea minimă a comenzii',
      minutes: 'min',
      shippingCost: 'Cost livrare',
      shippingTax: 'Taxe livrare',
      locations: 'Locație',
      street: 'Stradă',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDays: 'Zile și ore disponibile',
      availableDaysErr: 'Câmpul pentru zilele și orele disponibile este obligatoriu.',
      notice: 'Verifică eroarea din câmpul modalităților de livrare activate, apoi încearcă să salvezi din nou formularul',
      saveSuccess: 'Datele despre detaliile comenzilor au fost salvate cu succes'
    },
    settingsInfoPages: {
      single: 'pagină',
      noPage: 'Nu s-au adăugat pagini încă.',
      title: 'Titlu Pagină',
      content: 'Conținut Pagină',
      newPage: 'Pagină nouă',
      addedSuccess: 'Pagină salvată cu succes.',
      deletedSuccess: 'Pagină ștearsă cu succes',
      deleteMsg: 'Ești sigur că dorești să ștergi această pagină?',
      TERMS_CONDITIONS: 'Termeni și Condiții',
      PRIVACY_POLICY: 'Politica de Confidențialitate',
      CONTACT_DETAILS: 'Date Contact'
    },
    settingsRewards: {
      single: 'punct',
      plural: 'puncte',
      state: 'Status',
      points: 'punct(e)',
      moneySpent: 'Bani cheltuiți în puncte',
      pointsTo: 'Puncte în Bani',
      numberOfcurrencyNeedToSpend: 'Suma de bani pe care clientul trebuie să o cheltuiască pentru a câștiga 1 punct.',
      numberOfpointsToReward: 'Suma de puncte de care clientul are nevoie atunci când vrea să plătească folosind puncte.',
      rewardSuccess: 'Datele programului de loialitate salvate cu succes'
    },
    settingsPushNotif: {
      order_new: 'Mesaj nou comandă',
      order_completed_pickup: 'Mesaj comandă finalizată - Ridicare comandă',
      order_completed_meet: 'Mesaj comandă finalizată - Ne întâlnim la jumătate',
      order_completed_delivery: 'Mesaj comandă finalizată - Livrare',
      order_completed_eat: 'Mesaj comandă finalizată - Rezervare masă',
      order_canceled: 'Mesaj comandă anulată',
      notifUpdated: 'Datele notificărilor prin mesaj salvate cu succes',
      preview: 'Previzualizare',
      time: 'oră',
      dateTime: 'data și ora',
      persons: 'numărul clientului',
      timePrev: '45 minute',
      personsPrev: '3',
      dateTimePrev: 'Marți, Februarie 15, 2019, la 18'
    },
    settingsTips: {
      tipsTaxes: 'Taxe bacșiș',
      state: 'Folosește bacșiș',
      tipsSuccess: 'Bacșiș salvat cu succes'
    },
    settingsPlans: {
      plan1Title: 'Lunar',
      plan1Rate: '160Euro / lună',
      plan1Description: 'Începe cu o taxă fixă lunară, indiferent de suma facturată prin aplicație.',
      plan2Title: 'Procentaj vânzari',
      plan2Rate: '10%',
      plan2Description: 'Plătești în funcție de cât vinzi. Alege procentul din vânzări și vei plăti o taxă lunară raportată doar la vânzările tale prin aplicație.',
      current: 'Subscripția actuală',
      switch: 'Schimbă'
    },
    checkbox: 'Permite selectarea mai multor opțiuni pe produs',
    radio: 'Permite selectarea unei singure opțiuni pe produs'
  }, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ro___default.a)
};

/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),

/***/ "pznp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderingManagement_vue__ = __webpack_require__("eh/v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b24a08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderingManagement_vue__ = __webpack_require__("XZbu");
function injectStyle (ssrContext) {
  __webpack_require__("PD+C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderingManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b24a08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderingManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0FD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderView_vue__ = __webpack_require__("KheQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c8030e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderView_vue__ = __webpack_require__("DaTz");
function injectStyle (ssrContext) {
  __webpack_require__("gZBb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c8030e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qBXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'email': 'otho.smitham@example.com',
  'age': 39,
  'gender': 'female',
  'location': 'Oradea',
  'sales': 654,
  'phone': '+44 745 000 111',
  'active': true
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'sales': '35978.00',
  'age': 26,
  'gender': 'male',
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': false
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'customer_id',
  'email': 'little.myrna@example.net',
  'sales': '26278.00',
  'age': 48,
  'gender': 'male',
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': false
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'sales': '25537.00',
  'gender': 'male',
  'age': 27,
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': true
}, {
  'customer_id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'customer_id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'customer_id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'customer_id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'customer_id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'customer_id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'customer_id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'customer_id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'customer_id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'customer_id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'customer_id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'customer_id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'customer_id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'customer_id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'customer_id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'customer_id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'customer_id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'customer_id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'customer_id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'customer_id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'customer_id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'customer_id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'customer_id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'customer_id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'customer_id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'customer_id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'customer_id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'customer_id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'customer_id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'customer_id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'customer_id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'customer_id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'customer_id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'customer_id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'customer_id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'customer_id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'customer_id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'customer_id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'customer_id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'customer_id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'customer_id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'customer_id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'customer_id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'customer_id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'customer_id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'customer_id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "qEKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJwf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-form',{on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r4QW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reward-form',{on:{"on-submit":_vm.onRewardSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rat0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 'pickup',
  'type': 'Pick up'
}, {
  'id': 'halfway',
  'type': 'Meet me half way'
}, {
  'id': 'athome',
  'type': 'At home'
}, {
  'id': 'location',
  'type': 'Consume on location'
}]);

/***/ }),

/***/ "rprZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-info",attrs:{"to":"/feedback"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-12 pad-to-15"},[_c('div',{staticClass:"card feedback-card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 feedback-sides"},[_c('p',{staticClass:"feedback-top"},[_c('span',{staticClass:"label label-empty",class:'label-' + _vm.feedbackTypeClass(_vm.message.type)},[_vm._v(_vm._s(_vm.$t('feedbackTypes.' + _vm.message.type)))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formatDateTime(_vm.message.created_at)))])]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.message.creater.name)+" ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.message.text))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 feedback-sides"},[_c('h6',{staticClass:"mar-to-0"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('customers.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.firstname)+" "+_vm._s(_vm.message.creater.lastname))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.email ? _vm.message.creater.email : '-'))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.phone ? _vm.message.creater.phone : '-'))])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sAdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Taxes_vue__ = __webpack_require__("xidW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a56d340e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Taxes_vue__ = __webpack_require__("aFPV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Taxes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a56d340e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Taxes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07780cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("C2Zq");
function injectStyle (ssrContext) {
  __webpack_require__("OFEX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07780cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sWJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{ref:"navbarHeader",staticClass:"navbar-header"},[_c('div',{staticClass:"text-center logo-normal pull-left pad-to-25"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sbkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "slG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__ = __webpack_require__("41va");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OffersForm', __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      offerModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "soYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__ = __webpack_require__("FfsB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c15a2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__ = __webpack_require__("Mily");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c15a2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t1Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__("9WFt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1692b9d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__("edxA");
function injectStyle (ssrContext) {
  __webpack_require__("a722")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1692b9d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1692b9d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignForm_vue__ = __webpack_require__("NE6U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a0906b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignForm_vue__ = __webpack_require__("PiIk");
function injectStyle (ssrContext) {
  __webpack_require__("021c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a0906b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tkRG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean,
    required: Boolean,
    name: String
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    },
    isRequired: function isRequired() {
      if (this.required) {
        return 'required';
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2229d0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("Kf/x");
function injectStyle (ssrContext) {
  __webpack_require__("RLX6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2229d0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uKvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-orange",attrs:{"to":"/marketing/offers"}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back')))])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('offers-form',{on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uVnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("koIN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a8debc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("4KBV");
function injectStyle (ssrContext) {
  __webpack_require__("zYXx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a8debc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uWep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-pie-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Pie' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "ug9+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "vCTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryForm_vue__ = __webpack_require__("agLU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92121010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryForm_vue__ = __webpack_require__("3FB1");
function injectStyle (ssrContext) {
  __webpack_require__("lqCJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92121010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelFromParent: {
      type: [Object, Array],
      required: true
    },
    daysParent: {
      type: Array,
      required: true
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.model = value;
      this.filters[1].value = value.user_filters ? value.user_filters.gender : null;
      this.filters[2].value = value.user_filters ? value.user_filters.orders_above : null;
      this.filters[3].value = value.user_filters ? value.user_filters.age : null;
      this.filters[4].value = value.user_filters ? value.user_filters.location_id : null;
      this.counter_matching_users = value.user_filters && value.user_filters.counter_matching_users ? value.user_filters.counter_matching_users : this.counter_matching_users;
      this.model.counter_matching_users = this.counter_matching_users;
    },
    daysParent: function daysParent(value, oldVal) {
      this.days = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['notification_type', 'notification_mode', 'email'])),
  created: function created() {
    var self = this;
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.apiRequest('/customer', 'GET', data, function (response) {
      if (response.status === true) {
        self.tableData = response.data;
        self.counter_matching_users = response.data.length;
      }
    });

    var company = this.$session.get('selectedCompanyData');
    this.locations = company.locations_details;
    if (this.locations.length > 1) {
      this.colsClass = 'col-md-3';
    }
    this.currency = this.getCurrencySymbol(company.currency_iso);
  },
  data: function data() {
    var _this = this;

    return {
      tableData: [],
      model: this.value || this.modelFromParent,
      days: this.value || this.daysParent,
      modelValidations: {
        notification_type: {
          required: true
        },
        notification_mode: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      },
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      locations: [],
      colsClass: 'col-md-4',
      campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
      campaignsModes: this.$session.get('defaultData')['campaigns_modes'],
      filters: [{
        value: '',
        prop: ['firstname', 'lastname', 'sales']
      }, {
        value: '',
        prop: ['gender']
      }, {
        value: '',
        prop: ['sales'],
        filterFn: function filterFn(row, filter) {
          return row.sales > filter.value;
        }
      }, {
        value: '',
        prop: ['birthdate'],
        filterFn: function filterFn(row, filter) {
          var age = _this.getAge(row.birthdate);
          switch (filter.value) {
            case '20':
              if (age < 20) {
                return row;
              }
              break;
            case '20-30':
              if (age >= 20 && age <= 30) {
                return row;
              }
              break;
            case '30-40':
              if (age >= 30 && age <= 40) {
                return row;
              }
              break;
            case '40-50':
              if (age >= 40 && age <= 50) {
                return row;
              }
              break;
            case '50+':
              if (age > 50) {
                return row;
              }
              break;
          }
          return false;
        }
      }, {
        value: '',
        prop: ['orders_locations'],
        filterFn: function filterFn(row, filter) {
          if (row.orders_locations.includes(filter.value)) {
            return true;
          }
          return false;
        }
      }],
      counter_matching_users: 0,
      currency: ''
    };
  },

  methods: {
    dataFiltered: function dataFiltered(data) {
      this.counter_matching_users = data.length;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      this.model.user_filters = {
        gender: this.filters[1].value,
        orders_above: this.filters[2].value,
        age: this.filters[3].value,
        location_id: this.filters[4].value
      };
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7342f395_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("sbkR");
function injectStyle (ssrContext) {
  __webpack_require__("04eR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7342f395"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7342f395_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vRh+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-10 col-sm-12 pad-to-15"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('customers.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.id')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.id))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.name')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.email')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.email)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.phone')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.phone))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.gender')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.gender))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.birth')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.customer.birthdate)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.location')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[(_vm.customer.addresses !== undefined && _vm.customer.addresses.address_shipping !== undefined)?[_vm._v("\n                    "+_vm._s(_vm.customer.addresses.address_shipping.join())+"\n                  ")]:[_c('b',[_vm._v("-")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.pointsTitle')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.customer.loyalty_points))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-10 col-sm-12 pad-to-15"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12 pad-to-10"},[_c('h6',{},[_vm._v(_vm._s(_vm.$t('customers.pointsAddTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.pointsLabel'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.newPoints.money_spent),expression:"newPoints.money_spent"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.newPoints.money_spent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newPoints, "money_spent", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.commentsLabel')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.newPoints.comments),expression:"newPoints.comments"}],staticClass:"form-control ",attrs:{"type":"number","min":"1","rows":"2"},domProps:{"value":(_vm.newPoints.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newPoints, "comments", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success",on:{"click":function($event){$event.preventDefault();return _vm.addPoints($event)}}},[_vm._v(_vm._s(_vm.$t('general.add')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card mar-bt-0"},[_c('div',{staticClass:"row card-content"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.customer.orders,"action-def":_vm.defaultActionDef,"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":70,"sortable":"","prop":"number","label":_vm.$t('customers.number')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v("#"+_vm._s(props.row.token))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":70,"sortable":"","prop":"date","label":_vm.$t('customers.dateCreated')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"sortable":"","prop":"delivery_type","label":_vm.$t('customers.delivery')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.delivery_type ? _vm.$t('deliveryTypes.' + props.row.delivery_type) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"order_type","label":_vm.$t('customers.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'text-lowercase'},[_vm._v("\n                "+_vm._s(_vm.$t('ordersTypes.' + props.row.order_type))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"","prop":"status","label":_vm.$t('customers.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'label label-' + _vm.orderStatusClass(props.row.status.id)},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + props.row.status.id)))])]}}])}),_vm._v(" "),_c('el-table-column',{class:'text-right',attrs:{"min-width":60,"sortable":"","prop":"total","label":_vm.$t('customers.total')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.totals_grandtotal, props.row.currency)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":45},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"fa fa-pencil"})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"cust-sales"},[_c('div',{staticClass:"pull-right"},[_c('span',{staticClass:"details-label"},[_vm._v(_vm._s(_vm.$t('customers.allTimeSale'))+":")]),_c('b',[_vm._v(" "+_vm._s(_vm.formatMoneyAmount(_vm.customer.sales)))])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vTqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdStep_vue__ = __webpack_require__("vIMW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a2313f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdStep_vue__ = __webpack_require__("HRf+");
function injectStyle (ssrContext) {
  __webpack_require__("RqR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a2313f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vg2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "viQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerView_vue__ = __webpack_require__("QJOo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2aeec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerView_vue__ = __webpack_require__("vRh+");
function injectStyle (ssrContext) {
  __webpack_require__("6Yze")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2aeec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b79b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("mG7c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b79b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRw/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"row pad-to-15"},[(_vm.errors.has('error'))?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.getError('error'))+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.errors.items.length)?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger alert-custom-danger"},[_vm._v(_vm._s(_vm.$t('catalogProd.errorOptions'))+"\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.generalDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.desc')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"name":"description","rows":"5"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.description.invalid),expression:"description.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('description'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.category_id),expression:"modelValidations.category_id"}],ref:"category_id",staticClass:"form-control",attrs:{"name":"category_id","data-vv-as":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.mainCategories),function(option){return _c('option',{key:option.id,attrs:{"label":option.name},domProps:{"value":option.id}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.category_id.invalid),expression:"category_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('category_id'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.price'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.price),expression:"modelValidations.price"},{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":_vm.$t('catalogProd.price')},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.price.invalid),expression:"price.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('price'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('catalogProd.taxes')))]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.taxes,"label":"name"},model:{value:(_vm.model.taxes),callback:function ($$v) {_vm.$set(_vm.model, "taxes", $$v)},expression:"model.taxes"}})],1),_vm._v(" "),(_vm.errors.has('taxes'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('taxes'))+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.active),expression:"model.active"}],staticClass:"form-control",attrs:{"name":"active"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('general.active')))]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('general.inactive')))])]),_vm._v(" "),(_vm.errors.has('status'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('status'))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.posid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_id),expression:"model.pos_id"}],staticClass:"form-control",attrs:{"type":"text","name":"pos_id","placeholder":_vm.$t('catalogProd.posid')},domProps:{"value":(_vm.model.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "pos_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.allowUserComments')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_user_comments),callback:function ($$v) {_vm.$set(_vm.model, "allow_user_comments", $$v)},expression:"model.allow_user_comments"}}),_vm._v(" "),(_vm.errors.has('allow_user_comments'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('allow_user_comments'))+"\n                    ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],attrs:{"type":"hidden","name":"","value":"single"},domProps:{"value":(_vm.model.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "type", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 "},[(_vm.model.type == 'group')?_c('div',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Pick products that should be in the group")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.products,"label":"name","value":"id"},model:{value:(_vm.model.child_products),callback:function ($$v) {_vm.$set(_vm.model, "child_products", $$v)},expression:"model.child_products"}})],1),_vm._v(" "),(_vm.errors.has('child_products'))?_c('small',{staticClass:"text-danger col-md-12"},[_vm._v("\n                        "+_vm._s(_vm.getError('child_products'))+"\n                      ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.rewardPoints')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.moneySpent')))]),_vm._v(" "),_c('small',{staticClass:"help-block"},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogProd.numberOfYouNeedToSpend', { currency: _vm.currency }))+"\n                    "),_c('div',{staticClass:"pad-to-5"},[_vm._v(_vm._s(_vm.$t('catalogProd.rewardPossibelValue'))+":\n                      "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint1')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint2')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint3')))])])])]),_vm._v("\n                  1 "+_vm._s(_vm.currency)+" = "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.monetary_conversion),expression:"model.monetary_conversion"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","step":"0.1","name":"monetary_conversion"},domProps:{"value":(_vm.model.monetary_conversion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "monetary_conversion", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('catalogProd.points'))+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.plural')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-10 "},[_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_vm._l((_vm.model.product_options),function(option,idxO){return [_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",on:{"click":function($event){$event.preventDefault();_vm.deleteOption(idxO)}}},[_c('i',{staticClass:"ti-trash"})]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":_vm.getOptData(option, 'name'),"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.single')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.id),expression:"option.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"placeholder":"Pick an option"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"lazy",undefined,$event.key,undefined)){ return null; }_vm.changeOption(idxO, option.id, option)}]}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('catalogProd.pickAnOption')))]),_vm._v(" "),_vm._l((_vm.productOptions),function(prOption){return [_c('option',{attrs:{"disabled":_vm.disableOption(idxO, prOption.id, true) && option.id != prOption.id},domProps:{"value":prOption.id}},[_vm._v(_vm._s(prOption.name))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.required')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.required),expression:"option.required"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.getOptData(option, 'type') == 'checkbox')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.minNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(option.min_no),expression:"option.min_no"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(option.min_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "min_no", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.getOptData(option, 'type') == 'checkbox')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.maxNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(option.max_no),expression:"option.max_no"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(option.max_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "max_no", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),(option.id != '')?_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProd.price'))+" ("+_vm._s(_vm.currency)+")\n                                  ")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((option.values),function(value,idx){return _c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.id),expression:"option.id"}],attrs:{"type":"hidden"},domProps:{"value":(option.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "id", $event.target.value)}}}),_vm._v(" "),_c('td',[(_vm.productOptions[_vm.getObjectByElemKeyValue('id', option.id, _vm.productOptions)])?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(value.id),expression:"value.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(value, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.productOptions[_vm.getObjectByElemKeyValue('id', option.id, _vm.productOptions)]['values']),function(prOption){return [_c('option',{attrs:{"disabled":_vm.disableOption(idxO, prOption.id, false) && value.id != prOption.id},domProps:{"value":prOption.id}},[_vm._v(_vm._s(prOption.label))])]})],2)]:_vm._e()],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(value.price),expression:"value.price"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(value.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "price", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteOptionValue(idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":"Remove"}})])])])}))]):_vm._e(),_vm._v(" "),(_vm.showAddButton(idxO, option))?_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-simple btn-icon mar-bt-5",attrs:{"title":""},on:{"click":function($event){$event.preventDefault();_vm.addNewOptionValue(idxO)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v("\n                                "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+"\n                            ")])]):_vm._e()])]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"},[(_vm.productOptions.length > _vm.model.product_options.length)?_c('button',{staticClass:"btn btn-info btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single'))+"\n                    ")]):_vm._e()])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.soldWith')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"text-left icon-search",attrs:{"title":"","tabId":"first"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchword),expression:"searchword"}],staticClass:"form-control ",attrs:{"type":"text","placeholder":_vm.$t('general.search')},domProps:{"value":(_vm.searchword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchword=$event.target.value},_vm.search]}}),_vm._v(" "),_c('v-tree',{ref:"tree",attrs:{"data":_vm.treeData,"multiple":true,"halfcheck":true}})],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "wi/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){_vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wiU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__ = __webpack_require__("hZ/Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cd2a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__ = __webpack_require__("Zuvs");
function injectStyle (ssrContext) {
  __webpack_require__("4/sg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cd2a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wpqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__ = __webpack_require__("HOa3");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      userModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userModel = model;
    }
  }
});

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "x36W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.state')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive($event)}},model:{value:(_vm.model.loyalty_in_use),callback:function ($$v) {_vm.$set(_vm.model, "loyalty_in_use", $$v)},expression:"model.loyalty_in_use"}})],1),_vm._v(" "),(_vm.model.loyalty_in_use)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.moneySpent')))]),_vm._v(" "),_c('br'),_vm._v("\n              1 "+_vm._s(_vm.currency)+" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_currency),expression:"modelValidations.loyalty_value_one_currency"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_currency),expression:"model.loyalty_value_one_currency"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"0.1","name":"loyalty_value_one_currency"},domProps:{"value":(_vm.model.loyalty_value_one_currency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_currency", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n              "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.numberOfcurrencyNeedToSpend')))]),_vm._v(" "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.pointsTo')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_point_amount),expression:"modelValidations.loyalty_value_one_point_amount"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_point_amount),expression:"model.loyalty_value_one_point_amount"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","default":"1","step":"0.1","name":"loyalty_value_one_point_amount"},domProps:{"value":(_vm.model.loyalty_value_one_point_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_point_amount", $event.target.value)}}}),_vm._v(" \n              "+_vm._s(_vm.$t('settingsRewards.points'))+" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_point),expression:"modelValidations.loyalty_value_one_point"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_point),expression:"model.loyalty_value_one_point"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","default":"1","step":"0.1","name":"loyalty_value_one_point"},domProps:{"value":(_vm.model.loyalty_value_one_point)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_point", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.currency)+"\n              "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.numberOfpointsToReward')))]),_vm._v(" "),(_vm.errors.has('loyalty_value_one_point'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('loyalty_value_one_point'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mar-bt-5"},[_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.update')))])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "p4sG"));
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xXCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("okfR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12b53b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("Fk17");
function injectStyle (ssrContext) {
  __webpack_require__("zLhl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12b53b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xidW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("sUu7");














__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a),
  props: {
    defaultData: {},
    modeldata: {},
    taxesData: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    },
    taxesData: function taxesData(value) {
      this.taxes = value;
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      taxes: this.value || this.taxesData,
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  created: function created() {
    this.$nextTick(function () {
      this.loading = false;
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveTax();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        this.errors.add(prop, errors[prop]);
        console.warn(this.errors);
      }
    },
    goToCompany: function goToCompany() {
      this.$emit('setSelectedTab', 'Company Details');
    },
    saveTax: function saveTax() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {};
      var taxes = this.taxes;
      var companyId = this.$session.get('selectedCompany');
      for (var tax in taxes) {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(taxes[tax].id) && taxes[tax].id.indexOf('new') === 0) {
          delete taxes[tax].id;
        }
        taxes[tax].company_id = companyId;
      }
      data.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.taxes);
      data.token = this.$session.get('token');
      var self = this;
      this.apiRequest('/settings/taxes/all', 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Taxes saved successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          for (var taxIdx in response.data) {
            response.data[taxIdx].hash_id = response.data[taxIdx].id;
          }
          self.$emit('setTaxes', response.data);
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.handleErrors(response.errors);
        }
      });
    },
    addNewTax: function addNewTax() {
      var id = 'new_' + Math.floor(Math.random() * 10000);
      var newRow = {
        'hash_id': id,
        'id': id,
        'name': ''
      };
      this.taxes.push(newRow);
    },
    deleteTax: function deleteTax(taxId) {
      var _this2 = this;

      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.taxes);

      var self = this;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: 'Are you sure you want to delete this tax?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(taxId) && taxId.indexOf('new') === 0) {
            _this2.taxes.splice(thisTaxIdx, 1);
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          } else {
            var id = taxId;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/settings/taxes/' + id, 'DELETE', data, function (response) {
              console.warn(response);
              if (response.status === true) {
                var updatedTaxes = self.taxes;
                updatedTaxes.splice(thisTaxIdx, 1);
                self.$emit('setTaxes', updatedTaxes);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
              } else {
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "yCkF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yJjF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-spacing"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ylrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ywXP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zATB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css__ = __webpack_require__("V5v9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group__ = __webpack_require__("D8db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css__ = __webpack_require__("/bpg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item__ = __webpack_require__("ACGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css__ = __webpack_require__("bwiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu__ = __webpack_require__("SExR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);









var _components;



__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings-menu',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a), _components)
});

/***/ }),

/***/ "zLhl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false,
      logo: 'static/img/logo-taptasty.png'
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.$route.path === '/login' && this.$session.exists()) {
      this.$router.push('/');
    } else if (!this.$session.exists()) {
      this.$router.push('/login');
    }
    if (this.$session.exists()) {
      var user = JSON.parse(this.$session.get('userData'));
      if (user !== undefined && user.language !== undefined) {
        this.$i18n.locale = user.language;
      }
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$session.get('token');
    }
  }
});

/***/ }),

/***/ "zYXx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zeKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{class:_vm.isNew ? 'col-md-6 ' : 'col-lg-6 col-md-12'},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isNew)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getDriverCode(_vm.model.role)}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.roles),function(role,key){return _c('option',{key:key,attrs:{"label":role},domProps:{"value":key}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.fn')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.firstname),expression:"modelValidate.firstname"},{name:"model",rawName:"v-model",value:(_vm.model.firstname),expression:"model.firstname"}],staticClass:"form-control",attrs:{"type":"text","name":"firstname","data-vv-as":"first name","placeholder":_vm.$t('settingUsers.ln')},domProps:{"value":(_vm.model.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstname", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('firstname'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('firstname'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.ln')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.lastname),expression:"modelValidate.lastname"},{name:"model",rawName:"v-model",value:(_vm.model.lastname),expression:"model.lastname"}],staticClass:"form-control",attrs:{"type":"text","name":"lastname","data-vv-as":"last name","placeholder":_vm.$t('settingUsers.fn')},domProps:{"value":(_vm.model.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastname", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('lastname'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('lastname'))+"\n                ")]):_vm._e()]),_vm._v(" "),(_vm.model.role != 'DRIVER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingUsers.email')},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('email'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role == 'DRIVER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.username')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingUsers.username'),"disabled":""},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('email'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isNew)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.password')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.password),expression:"modelValidate.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":_vm.$t('settingUsers.password')},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('password'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isNew)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.confPass')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.password_confirmation),expression:"modelValidate.password_confirmation"},{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation","placeholder":_vm.$t('settingUsers.confPass')},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('password_confirmation'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role != 'OWNER' && !_vm.isNew)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.roles),function(role,key){return _c('option',{key:key,attrs:{"label":role},domProps:{"value":key}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.lang')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.language),expression:"modelValidate.language"}],staticClass:" form-control",attrs:{"placeholder":" - Select Language - "},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.languages),function(label,key){return _c('option',{key:key,attrs:{"label":label},domProps:{"value":key}},[_vm._v(_vm._s(label))])})),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('settingUsers.langMsg')))]),_vm._v(" "),(_vm.errors.has('language'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('language'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.avatar')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer "},[_c('button',{staticClass:"btn btn-fill btn-success",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill",attrs:{"type":"text","title":""},on:{"click":function($event){$event.preventDefault();return _vm.cancelUser($event)}}},[_vm._v(" "+_vm._s(_vm.$t('general.cancel')))])])])])]),_vm._v(" "),(!_vm.isNew)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loadingReset ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{},[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"card-title"},[_vm._v("\n              "+_vm._s(_vm.$t('settingUsers.resetPass'))+"\n            ")]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.pass')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":_vm.$t('settingUsers.pass'),"aria-invalid":_vm.errors.has('password_2') ? true : false},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_2'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password_2'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.confPass')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","placeholder":_vm.$t('settingUsers.confPass'),"aria-invalid":_vm.errors.has('password_confirm_2') ? true : false},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirm_2'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('password_confirm_2'))+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row card-footer"},[_c('div',{staticClass:"col-md-12 form-group"},[_c('label'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-orange",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validateReset($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.reset'))+"\n            ")])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zijR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramEdit_vue__ = __webpack_require__("ToeX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6cc13b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramEdit_vue__ = __webpack_require__("r6tJ");
function injectStyle (ssrContext) {
  __webpack_require__("EWf/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6cc13b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zouy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c4493107762061ba9b95.js